import mushroom, { defineAsyncResource, defineAsyncView, fireEvent, createRestfulAsyncFunction, Mushroom, MushroomError } from "mushroomjs";
import type { IdType, IMushroom, MushroomRequest, MushroomRequestSetting, MushroomRestfulRequest, MushroomResponse, MushroomResponseDataType, MushroomResourceBase, MushroomListResource, MushroomCountResource, MushroomFindByIdResource, MushroomCreateResource, MushroomBatchCreateResource, MushroomUpdateResource, MushroomBatchUpdateResource, MushroomPartialUpdateResource, MushroomDeleteResource, MushroomBatchDeleteResource, MushroomExtensibleResource, MushroomViewFunction, IMushroomOfflineResponse, MushroomOfflineResponse, MushroomOfflineResponseState } from "mushroomjs";
/* import all mushroom extensions */
import * as AuthExtension from "mushroomjs-auth";
import config from "../../../src/config.json";
import * as FileExtension from "mushroomjs-file";
export * from "mushroomjs";
export const extensions = {
    /* export all mushroom extensions */
    File: FileExtension,
    Auth: AuthExtension
};

export type ISODateValue = string | Date;
export type IdValue = string;

export interface CustomMethodRequest<TParam extends {}, TBody> extends MushroomRequest {
  params?: TParam;
  body?: TBody;
}

export interface CustomMethodParamsRequest<TParam extends {}> extends MushroomRequest {
  params?: TParam;
}

export interface CustomMethodBodyRequest<TBody> extends MushroomRequest {
  body?: TBody;
}

export interface User {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Tài khoản
     */
    account?: string | null;
    /**
     * Mật khẩu
     */
    password?: string | null;
    /**
     * Số định danh đã xác thực qua VNeID.
     */
    vneid_identifier?: string | null;
    /**
     * Ứng dụng liên kết VNeID; một CCCD được liên kết một tài khoản cho mỗi app.
     */
    vneid_app?: string | null;
    /**
     * Thời điểm liên kết VNeID lần đầu
     */
    vneid_linked_at?: ISODateValue | null;
    /**
     * Tài khoản đã xác thực và liên kết định danh VNeID
     */
    is_vneid_verified?: boolean | null;
    /**
     * Tên đăng nhập ACS đã được xác nhận khi liên kết hoặc đăng ký bằng số điện thoại VNeID.
     */
    vneid_acs_login_name?: string | null;
    /**
     * Cho biết tài khoản có bị khóa hay không, nếu bị khóa, tài khoản sẽ không thể đăng nhập được
     */
    disabled?: boolean | null;
    /**
     * Danh sách quyền của người dùng
     */
    roles?: Array<string | null | undefined> | null;
    /**
     * Danh sách các token của người dùng
     */
    tokens?: Array<User_Tokens | null | undefined> | null;
    __no_pwd?: boolean | null;
    /**
     * Trạng thái đồng bộ dữ liệu lên ACS
     */
    __sync_status_acs?: User___sync_status_acs | null;
}

export interface User_Tokens {
    /**
     * Giá trị token
     */
    value?: string | null;
    /**
     * Thời điểm token được tạo
     */
    time?: ISODateValue | null;
}

export interface User___sync_status_acs {
    /**
     * Trạng thái
     */
    trang_thai?: string | null;
    /**
     * Thông tin lỗi
     */
    log_error?: string | null;
    /**
     * Thời gian đồng bộ
     */
    sync_time?: ISODateValue | null;
}

export interface User_IsPhoneNumberMatchedCardCodeRequest {
    /**
     * Số điện thoại cần kiểm tra
     */
    phone_number: string;
    /**
     * Card code cần kiểm tra
     */
    card_code: string;
}

export interface User$CustomMethodResource {
    isOnlineAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    registerAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    registerForeignerTouristAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    requestEmailOtpAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    registerForeignerTouristWithEmailAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    registerSafePlaceUserAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    generateHashCodeAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    getUserIdOrFetchAcsUserAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    requestOtpAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    validateOtpAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    validateOtp_v2Async: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    login_no_passAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    isPhoneNumberMatchedCardCodeAsync: (request: CustomMethodBodyRequest<User_IsPhoneNumberMatchedCardCodeRequest>) => Promise<MushroomResponse<any>>;
    getAccountByEmailAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    createUserAcsV3Async: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    registerSafePlaceAppAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    validateSafePlaceAppAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    requestOtpV3Async: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    getAccountByPhoneOrEmailAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    logModuleActivityAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    cosPeopleRegisterMobileAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    cosPeopleUnregisterMobileAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    getNameByAccountAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    getRolesByUserIdAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<User>({"name":"user","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"_raw_http_method_isOnline":{},"_raw_http_method_register":{},"_raw_http_method_registerForeignerTourist":{},"_raw_http_method_requestEmailOtp":{},"_raw_http_method_registerForeignerTouristWithEmail":{},"_raw_http_method_registerSafePlaceUser":{},"_raw_http_method_generateHashCode":{},"_raw_http_method_getUserIdOrFetchAcsUser":{},"_raw_http_method_requestOtp":{},"_raw_http_method_validateOtp":{},"_raw_http_method_validateOtp_v2":{},"_raw_http_method_login_no_pass":{},"_raw_http_method_isPhoneNumberMatchedCardCode":{},"_raw_http_method_getAccountByEmail":{},"_raw_http_method_createUserAcsV3":{},"_raw_http_method_registerSafePlaceApp":{},"_raw_http_method_validateSafePlaceApp":{},"_raw_http_method_requestOtpV3":{},"_raw_http_method_getAccountByPhoneOrEmail":{},"_raw_http_method_logModuleActivity":{},"_raw_http_method_cosPeopleRegisterMobile":{},"_raw_http_method_cosPeopleUnregisterMobile":{},"_raw_http_method_getNameByAccount":{},"_raw_http_method_getRolesByUserId":{}},"views":{}}, mushroom);

export interface User_tcqltt {
    /**
     * Mã người dùng có quyền là TCQLTT
     */
    id?: IdValue | null;
    /**
     * Mã người dùng là cấp trên
     */
    parent_id?: IdValue | null;
    /**
     * Danh sách mã người dùng cấp dưới
     */
    children?: Array<IdValue | null | undefined> | null;
}

defineAsyncResource<User_tcqltt>({"name":"user_tcqltt","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{}},"views":{}}, mushroom);

export interface User_svhtt {
    /**
     * Mã người dùng có quyền là SVHTT
     */
    id?: IdValue | null;
    /**
     * Mã tỉnh
     */
    province_id?: IdValue | null;
}

defineAsyncResource<User_svhtt>({"name":"user_svhtt","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{}},"views":{}}, mushroom);

export interface User_pvhtt {
    /**
     * Mã người dùng có quyền là PVHTT
     */
    id?: IdValue | null;
    /**
     * Mã tỉnh
     */
    province_id?: IdValue | null;
    /**
     * Mã huyện
     */
    district_id?: IdValue | null;
}

defineAsyncResource<User_pvhtt>({"name":"user_pvhtt","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{}},"views":{}}, mushroom);

export interface Profile {
    /**
     * Mã người dùng
     */
    id?: IdValue | null;
    /**
     * Tên người dùng
     */
    ho_ten?: Profile_Ho_ten | null;
    /**
     * Email
     */
    email?: string | null;
    /**
     * Số điện thoại
     */
    dien_thoai?: string | null;
    /**
     * Giới tính: 1 - Nữ, 2 - Nam, 3 - Chưa có thông tin, 4 - Khác
     */
    gioi_tinh?: number | null;
    /**
     * Mã ảnh đại diện
     */
    avatar_id?: IdValue | null;
}

export interface Profile_Ho_ten {
    /**
     * Tên
     */
    ten?: string | null;
    /**
     * Họ
     */
    ho?: string | null;
    /**
     * Họ tên đầy đủ
     */
    ho_ten?: string | null;
    /**
     * Định dạng tên
     */
    dinh_dang?: string | null;
}

export interface Profile_Verify_user_profile_informationResult {
    /**
     * Danh sách tên trường khớp với dữ liệu trong hệ thống Du Lịch
     */
    valid?: Array<any | null | undefined> | null;
    /**
     * Danh sách tên trường không khớp
     */
    invalid?: Array<any | null | undefined> | null;
}

export interface Profile_Verify_user_profile_informationRequest {
    /**
     * Mã người dùng trên hệ thống Du Lịch
     */
    id: string;
    /**
     * Các trường cần xác minh (flat, key dạng dotted: ho_ten.ho, ngay_sinh.ngay_sinh, giay_to.so_giay_to, dia_chi.province_id, dia_chi_thuong_chu...). Tất cả đều optional, đối tác chỉ gửi field cần verify.
     */
    info: Profile_Verify_user_profile_informationRequest_Info;
    /**
     * Chữ ký request. Sinh từ `id` và tất cả các trường trong `info`; option chữ ký đọc từ merchant.data: Signature_HashAlgorithm, Signature_Separator, Signature_OutputFormat.
     */
    signature: string;
}

export interface Profile_Verify_user_profile_informationRequest_Info {
}

export interface Profile$CustomMethodResource {
    verify_user_profile_informationAsync: (request: CustomMethodBodyRequest<Profile_Verify_user_profile_informationRequest>) => Promise<MushroomResponse<Profile_Verify_user_profile_informationResult>>;
}
export interface Profile$ViewsResource_listSafePlaceUsersByPhoneNumberView_Parameters {
    /**
     * Số điện thoại
     */
    dien_thoai: string;
};
export interface Profile$ViewsResource {
    views: {
        listSafePlaceUsersByPhoneNumberAsync: MushroomViewFunction<any, Profile$ViewsResource_listSafePlaceUsersByPhoneNumberView_Parameters>;
    }
}
defineAsyncResource<Profile>({"name":"profile","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"_raw_http_method_verify_user_profile_information":{}},"views":{"listSafePlaceUsersByPhoneNumber":{"clientCache":true}}}, mushroom);

export interface Khach_du_lich {
    /**
     * Mã người dùng
     */
    id?: IdValue | null;
    /**
     * Mã thẻ
     */
    so_the?: string | null;
    /**
     * Danh sách các thẻ
     */
    danh_sach_the?: Array<string | null | undefined> | null;
    /**
     * Mã people code
     */
    people_code?: string | null;
    /**
     * Tên người dùng
     */
    ho_ten?: Khach_du_lich_Ho_ten | null;
    /**
     * Email
     */
    email?: string | null;
    /**
     * Số điện thoại
     */
    dien_thoai?: string | null;
    /**
     * Giới tính: 1 - Nữ, 2 - Nam, 3 - Chưa có thông tin, 4 - Khác
     */
    gioi_tinh?: number | null;
    /**
     * Ngày tháng năm sinh
     */
    ngay_sinh?: Khach_du_lich_Ngay_sinh | null;
    /**
     * Giấy tờ, ví dụ: CMT, CCCD, Họ chiếu
     */
    giay_to?: Array<Khach_du_lich_Giay_to | null | undefined> | null;
    /**
     * Quốc tịch
     */
    quoc_tich?: Khach_du_lich_Quoc_tich | null;
    /**
     * Địa chỉ
     */
    dia_chi?: Khach_du_lich_Dia_chi | null;
    /**
     * Địa chỉ thường chú
     */
    dia_chi_thuong_chu?: string | null;
    /**
     * Mã ảnh đại diện
     */
    avatar_id?: IdValue | null;
    /**
     * Ảnh CMND/CCCD
     */
    anh_cmnd?: Khach_du_lich_Anh_cmnd | null;
    /**
     * Ảnh chân dung
     */
    avatar_url?: string | null;
}

export interface Khach_du_lich_Ho_ten {
    /**
     * Tên
     */
    ten?: string | null;
    /**
     * Họ
     */
    ho?: string | null;
    /**
     * Họ tên đầy đủ
     */
    ho_ten?: string | null;
    /**
     * Định dạng tên
     */
    dinh_dang?: string | null;
}

export interface Khach_du_lich_Ngay_sinh {
    /**
     * Ngày
     */
    ngay?: number | null;
    /**
     * Tháng
     */
    thang?: number | null;
    /**
     * Năm
     */
    nam?: number | null;
    /**
     * Ngày sinh
     */
    ngay_sinh?: ISODateValue | null;
}

export interface Khach_du_lich_Giay_to {
    /**
     * Loại giấy tờ
     */
    loai_giay_to?: string | null;
    /**
     * Số giấy tờ
     */
    so_giay_to?: string | null;
    /**
     * Nơi cấp
     */
    noi_cap?: string | null;
    /**
     * Ngày cấp
     */
    ngay_cap?: ISODateValue | null;
    /**
     * Ngày hết hạn
     */
    ngay_het_han?: ISODateValue | null;
}

export interface Khach_du_lich_Quoc_tich {
    /**
     * Mã quốc tịch
     */
    quoc_tich_id?: IdValue | null;
    /**
     * Tên quốc tịch
     */
    ten_quoc_tich?: string | null;
}

export interface Khach_du_lich_Dia_chi {
    /**
     * Mã tỉnh/TP
     */
    province_id?: IdValue | null;
    /**
     * Tên tỉnh/TP
     */
    province_name?: string | null;
    /**
     * Mã quận/huyện
     */
    district_id?: IdValue | null;
    /**
     * Tên quận/huyện
     */
    district_name?: string | null;
    /**
     * Mã phường/xã
     */
    commune_id?: IdValue | null;
    /**
     * Tên phường/xã
     */
    commune_name?: string | null;
    /**
     * Địa chỉ đầy đủ
     */
    dia_chi?: string | null;
}

export interface Khach_du_lich_Anh_cmnd {
    /**
     * Ảnh CMND/CCCD mặt trước
     */
    mat_truoc?: string | null;
    /**
     * Ảnh CMND/CCCD mặt sau
     */
    mat_sau?: string | null;
}

export interface Khach_du_lich$CustomMethodResource {
    updateForMobileAccountTypeAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
export interface Khach_du_lich$ViewsResource_layHoTenTheoSoTheView_Parameters {
    /**
     * Giá trị số thẻ cần tìm tên (tìm kiếm chính xác), nếu là số điện thoại thì cần chuyển về 84
     */
    so_the: string;
};
export interface Khach_du_lich$ViewsResource_layHoTenTheoPeopleCodeView_Parameters {
    /**
     * Danh sách giá trị people_code cần tìm tên (tìm kiếm chính xác)
     */
    people_code: string[];
};
export interface Khach_du_lich$ViewsResource_laySoTheNganHangView_UserParameters {};
export interface Khach_du_lich$ViewsResource {
    views: {
        layHoTenTheoSoTheAsync: MushroomViewFunction<any, Khach_du_lich$ViewsResource_layHoTenTheoSoTheView_Parameters>;
        layHoTenTheoPeopleCodeAsync: MushroomViewFunction<any, Khach_du_lich$ViewsResource_layHoTenTheoPeopleCodeView_Parameters>;
        laySoTheNganHangAsync: MushroomViewFunction<any, Khach_du_lich$ViewsResource_laySoTheNganHangView_UserParameters>;
    }
}
defineAsyncResource<Khach_du_lich>({"name":"khach_du_lich","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"_raw_http_method_updateForMobileAccountType":{}},"views":{"layHoTenTheoSoThe":{"clientCache":true},"layHoTenTheoPeopleCode":{"clientCache":true},"laySoTheNganHang":{"clientCache":true}}}, mushroom);

export interface Huong_dan_vien {
    /**
     * Mã người dùng
     */
    id?: IdValue | null;
    /**
     * Tên người dùng
     */
    ho_ten?: Huong_dan_vien_Ho_ten | null;
    /**
     * Email
     */
    email?: string | null;
    /**
     * Số điện thoại
     */
    dien_thoai?: string | null;
    /**
     * Danh sách các số điện thoại của người dùng
     */
    danh_sach_dien_thoai?: Array<string | null | undefined> | null;
    /**
     * Giới tính: 1 - Nữ, 2 - Nam, 3 - Chưa có thông tin, 4 - Khác
     */
    gioi_tinh?: number | null;
    /**
     * Ngày tháng năm sinh
     */
    ngay_sinh?: Huong_dan_vien_Ngay_sinh | null;
    /**
     * Giấy tờ, ví dụ: CMT, CCCD, Họ chiếu
     */
    giay_to?: Array<Huong_dan_vien_Giay_to | null | undefined> | null;
    /**
     * Quốc tịch
     */
    quoc_tich?: Huong_dan_vien_Quoc_tich | null;
    /**
     * Địa chỉ
     */
    dia_chi?: Huong_dan_vien_Dia_chi | null;
    /**
     * Mã ảnh đại diện
     */
    avatar_id?: IdValue | null;
    /**
     * Thẻ hướng dẫn viên du lịch
     */
    the_hdv?: Huong_dan_vien_The_hdv | null;
    /**
     * Danh sách ngôn ngữ
     */
    ngoai_ngu?: Array<IdValue | null | undefined> | null;
    /**
     * Danh sách sở trường
     */
    so_truong?: Array<IdValue | null | undefined> | null;
    /**
     * Thành tích
     */
    thanh_tich?: string | null;
    /**
     * Lịch sử hành nghề
     */
    lich_su_hanh_nghe?: string | null;
    /**
     * Đặc tả thông tin riêng tư
     */
    privacy?: Huong_dan_vien_Privacy | null;
    /**
     * Danh sách các thẻ
     */
    danh_sach_the_du_lich?: Array<string | null | undefined> | null;
    /**
     * Mã people code
     */
    people_code?: string | null;
    /**
     * [Dùng cho tool import dữ liệu] Version của dữ liệu
     */
    __version?: Huong_dan_vien___version | null;
    /**
     * Các thông tin về xác thực hướng dẫn viên
     */
    xac_thuc?: Huong_dan_vien_Xac_thuc | null;
}

export interface Huong_dan_vien_Ho_ten {
    /**
     * Tên
     */
    ten?: string | null;
    /**
     * Họ
     */
    ho?: string | null;
    /**
     * Họ tên đầy đủ
     */
    ho_ten?: string | null;
    /**
     * Định dạng tên
     */
    dinh_dang?: string | null;
}

export interface Huong_dan_vien_Ngay_sinh {
    /**
     * Ngày
     */
    ngay?: number | null;
    /**
     * Tháng
     */
    thang?: number | null;
    /**
     * Năm
     */
    nam?: number | null;
}

export interface Huong_dan_vien_Giay_to {
    /**
     * Loại giấy tờ
     */
    loai_giay_to?: string | null;
    /**
     * Số giấy tờ
     */
    so_giay_to?: string | null;
    /**
     * Nơi cấp
     */
    noi_cap?: string | null;
    /**
     * Ngày cấp
     */
    ngay_cap?: ISODateValue | null;
    /**
     * Ngày hết hạn
     */
    ngay_het_han?: ISODateValue | null;
}

export interface Huong_dan_vien_Quoc_tich {
    /**
     * Mã quốc tịch
     */
    quoc_tich_id?: IdValue | null;
    /**
     * Tên quốc tịch
     */
    ten_quoc_tich?: string | null;
}

export interface Huong_dan_vien_Dia_chi {
    /**
     * Mã tỉnh/TP
     */
    province_id?: IdValue | null;
    /**
     * Tên tỉnh/TP
     */
    province_name?: string | null;
    /**
     * Mã quận/huyện
     */
    district_id?: IdValue | null;
    /**
     * Tên quận/huyện
     */
    district_name?: string | null;
    /**
     * Địa chỉ đầy đủ
     */
    dia_chi?: string | null;
}

export interface Huong_dan_vien_The_hdv {
    /**
     * Số thẻ Hướng dẫn viên
     */
    so_the?: string | null;
    /**
     * Loại thẻ
     */
    loai_the?: string | null;
    /**
     * Ngày cấp
     */
    ngay_cap?: ISODateValue | null;
    /**
     * Nơi cấp
     */
    noi_cap?: string | null;
    /**
     * Ngày hết hạn
     */
    het_han?: ISODateValue | null;
    /**
     * Cho biết hướng dẫn viên có còn hoạt động hay không (được gán trên tổng cục du lịch)
     */
    trang_thai?: boolean | null;
}

export interface Huong_dan_vien_Privacy {
    /**
     * Danh sách các trường chứa dữ liệu riêng tư, không công khai
     */
    privateFields?: Array<string | null | undefined> | null;
}

export interface Huong_dan_vien___version {
    /**
     * Mã băm
     */
    hashCode?: number | null;
    /**
     * Đường dẫn ảnh gốc
     */
    anh?: string | null;
    /**
     * Mã dữ liệu tại nguồn
     */
    srcId?: string | null;
}

export interface Huong_dan_vien_Xac_thuc {
    /**
     * Cho biết đã xác thực thành công hay chưa
     */
    da_xac_thuc?: boolean | null;
    /**
     * Thời điểm xác thực thành công
     */
    thoi_diem_xac_thuc?: ISODateValue | null;
}

export interface Huong_dan_vien_Xac_thuc_cccdRequest {
    /**
     * Mã session_id sinh ra ở api ocr
     */
    ocr_session_id: IdValue;
    /**
     * Mã session_id sinh ra ở api face matching
     */
    face_session_id: IdValue;
    /**
     * Thông tin cccd (dg13)
     */
    cccc_info?: string | null;
}

export interface Huong_dan_vien$CustomMethodResource {
    finishSyncSessionAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    xac_thuc_cccdAsync: (request: CustomMethodBodyRequest<Huong_dan_vien_Xac_thuc_cccdRequest>) => Promise<MushroomResponse<any>>;
}
export interface Huong_dan_vien$ViewsResource_laySoTheNganHangView_TourGuideParameters {};
export interface Huong_dan_vien$ViewsResource {
    views: {
        laySoTheNganHangAsync: MushroomViewFunction<any, Huong_dan_vien$ViewsResource_laySoTheNganHangView_TourGuideParameters>;
    }
}
defineAsyncResource<Huong_dan_vien>({"name":"huong_dan_vien","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"_raw_http_method_finishSyncSession":{},"_raw_http_method_xac_thuc_cccd":{}},"views":{"laySoTheNganHang":{"clientCache":true}}}, mushroom);

export interface Huong_dan_vien_check_in {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã người đến checkin
     */
    nguoi_check_in_id?: IdValue | null;
    /**
     * Mã hướng dẫn viên
     */
    huong_dan_vien_id?: IdValue | null;
    /**
     * Thời điểm check in
     */
    thoi_diem_check_in?: ISODateValue | null;
    /**
     * Mã người tạo
     */
    nguoi_tao_id?: IdValue | null;
}

defineAsyncResource<Huong_dan_vien_check_in>({"name":"huong_dan_vien_check_in","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{}},"views":{}}, mushroom);

export interface So_truong {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã sở trường
     */
    code?: string | null;
    /**
     * Tên sở trường
     */
    name?: So_truong_Name | null;
    /**
     * Thứ tự sắp xếp
     */
    index?: number | null;
}

export interface So_truong_Name {
    /**
     * Tên tiếng Việt
     */
    vi?: string | null;
    /**
     * Tên tiếng Anh
     */
    en?: string | null;
}

defineAsyncResource<So_truong>({"name":"so_truong","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{}},"views":{}}, mushroom);

export interface Ngoai_ngu {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã ngoại ngữ
     */
    code?: string | null;
    /**
     * Tên ngoại ngữ
     */
    name?: Ngoai_ngu_Name | null;
    /**
     * Thứ tự sắp xếp
     */
    index?: number | null;
}

export interface Ngoai_ngu_Name {
    /**
     * Tên tiếng Việt
     */
    vi?: string | null;
    /**
     * Tên tiếng Anh
     */
    en?: string | null;
}

defineAsyncResource<Ngoai_ngu>({"name":"ngoai_ngu","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{}},"views":{}}, mushroom);

export interface Quoc_tich {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Tên Quốc tịch
     */
    ten?: Quoc_tich_Ten | null;
    /**
     * Mã quốc gia
     */
    ma?: string | null;
}

export interface Quoc_tich_Ten {
    /**
     * Tên tiếng Việt
     */
    vi?: string | null;
    /**
     * Tên tiếng Anh
     */
    en?: string | null;
}

defineAsyncResource<Quoc_tich>({"name":"quoc_tich","actions":{"findMany":{"clientCache":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{}},"views":{}}, mushroom);

export interface Ms_khach_du_lich {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Người giám hộ
     */
    guardian?: Ms_khach_du_lich_Guardian | null;
    /**
     * mã đăng ký ms
     */
    register_code?: string | null;
    /**
     * Số điện thoại
     */
    mobile?: string | null;
    /**
     * cmnd người giám hộ
     */
    cmnd_number?: string | null;
    /**
     * Bảo hiểm y tế
     */
    bhyt_number?: string | null;
    /**
     * Giới tính: 1 - Nữ, 2 - Nam, 3 - Chưa có thông tin, 4 - Khác
     */
    gioi_tinh?: number | null;
    /**
     * Tên
     */
    first_name?: string | null;
    /**
     * Họ + tên đệm
     */
    last_name?: string | null;
    /**
     * Tên quốc tịch
     */
    nationality_name?: string | null;
    /**
     * Số hộ chiếu
     */
    passport_no?: string | null;
    /**
     * Mã quốc gia
     */
    nationality_code?: string | null;
    /**
     * Ngày sinh
     */
    dob?: number | null;
    /**
     * Số thẻ
     */
    card_code?: string | null;
    /**
     * Thời gian tạo
     */
    created_time?: ISODateValue | null;
    /**
     * Người tạo
     */
    user_id?: IdValue | null;
    /**
     * Thông tin lỗi
     */
    reason?: string | null;
}

export interface Ms_khach_du_lich_Guardian {
    /**
     * mã đăng ký ms
     */
    register_code?: string | null;
    /**
     * Số điện thoại
     */
    mobile?: string | null;
    /**
     * cmnd người giám hộ
     */
    cmnd_number?: string | null;
    /**
     * Bảo hiểm y tế
     */
    bhyt_number?: string | null;
    /**
     * Giới tính: 1 - Nữ, 2 - Nam, 3 - Chưa có thông tin, 4 - Khác
     */
    gioi_tinh?: number | null;
    /**
     * Tên
     */
    first_name?: string | null;
    /**
     * Họ + tên đệm
     */
    last_name?: string | null;
    /**
     * Tên quốc tịch
     */
    nationality_name?: string | null;
    /**
     * Số hộ chiếu
     */
    passport_no?: string | null;
    /**
     * Mã quốc gia
     */
    nationality_code?: string | null;
    /**
     * Ngày sinh
     */
    dob?: number | null;
    /**
     * Số thẻ
     */
    card_code?: string | null;
}

export interface Ms_khach_du_lich$CustomMethodResource {
    register_ms_khachdulichAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<Ms_khach_du_lich>({"name":"ms_khach_du_lich","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"_raw_http_method_register_ms_khachdulich":{}},"views":{}}, mushroom);

export interface Acs_token {
    /**
     * Id tự động
     */
    id?: IdValue | null;
    /**
     * Mã token
     */
    token_code?: string | null;
    /**
     * Thời hạn token
     */
    expire_time?: ISODateValue | null;
}

defineAsyncResource<Acs_token>({"name":"acs_token","actions":{"findMany":{"clientCache":true},"findById":{"clientCache":true}},"views":{}}, mushroom);

export interface Vneid {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
}

export interface Vneid_Get_login_urlResult {
    /**
     * Đường dẫn mở ứng dụng VNeID để người dùng xác thực
     */
    login_url: string;
    /**
     * ID bản ghi vneid_login_session. Giữ tại ứng dụng và gửi lại khi đăng nhập; không gửi sang VNeID.
     */
    session_id: IdValue;
    /**
     * Thời hạn của phiên đăng nhập, đơn vị giây; mặc định là 300 giây
     */
    expires_in: number;
}

export interface Vneid_Get_login_urlParamRequest {
    /**
     * Ứng dụng đăng nhập: kdl là Khách du lịch; qtkddl là Quản trị và Kinh doanh du lịch. Không dùng giá trị này để xác định quyền người dùng.
     */
    app: string;
}

export interface Vneid_LoginRequest {
    /**
     * ID bản ghi vneid_login_session nhận từ login_url
     */
    session_id: IdValue;
    /**
     * Mã xác thực VNeID trong callback, tối đa 65536 ký tự.
     */
    code: string;
    /**
     * Khóa AES đã được VNeID mã hóa bằng RSA, tối đa 16384 ký tự. Chỉ gửi khi callback có trường này; không có thì bỏ qua.
     */
    encrypt_key?: string | null;
}

export interface Vneid_Registration_otpRequest {
    /**
     * Phiên đang chờ đăng ký, nhận từ login
     */
    session_id: IdValue;
    /**
     * Số điện thoại nhận OTP đăng ký (0xxxxxxxxx, 84xxxxxxxxx hoặc +84xxxxxxxxx). Chỉ dùng khi VNeID không trả số điện thoại; nếu VNeID có số điện thoại thì bỏ qua giá trị này và dùng số của VNeID.
     */
    phone?: string | null;
}

export interface Vneid_Complete_registrationRequest {
    /**
     * Phiên chờ hoàn tất đăng ký nhận từ login
     */
    session_id: IdValue;
    /**
     * Mật khẩu mới, từ 6 đến 256 ký tự
     */
    password: string;
    /**
     * Nhập lại chính xác mật khẩu mới
     */
    confirm_password: string;
    /**
     * Bắt buộc với kdl: OTP đăng ký ACS; không dùng với qtkddl
     */
    otp?: string | null;
}

export interface Vneid_Confirm_linkRequest {
    /**
     * Phiên chờ xác nhận liên kết nhận từ login
     */
    session_id: IdValue;
    /**
     * Mật khẩu hiện tại của tài khoản đã tồn tại
     */
    password: string;
}

export interface Vneid_Link_urlResult {
    /**
     * Đường dẫn mở ứng dụng VNeID để xác thực danh tính cần liên kết
     */
    login_url: string;
    /**
     * ID bản ghi vneid_login_session. Lưu tại ứng dụng để gửi sang link_account; không gửi sang VNeID
     */
    session_id: IdValue;
    /**
     * Thời hạn phiên liên kết, đơn vị giây; mặc định là 300 giây
     */
    expires_in: number;
}

export interface Vneid_Link_urlParamRequest {
    /**
     * Ứng dụng khởi tạo liên kết: kdl là Khách du lịch; qtkddl là Quản trị và Kinh doanh du lịch
     */
    app: string;
}

export interface Vneid_Link_accountRequest {
    /**
     * ID bản ghi vneid_login_session nhận từ link_url
     */
    session_id: IdValue;
    /**
     * Mã xác thực VNeID trong callback, tối đa 65536 ký tự.
     */
    code: string;
    /**
     * Khóa AES đã được VNeID mã hóa bằng RSA, tối đa 16384 ký tự. Chỉ gửi khi callback có trường này; không có thì bỏ qua.
     */
    encrypt_key?: string | null;
}

export interface Vneid$CustomMethodResource {
    get_login_urlAsync: (request: CustomMethodParamsRequest<Vneid_Get_login_urlParamRequest>) => Promise<MushroomResponse<Vneid_Get_login_urlResult>>;
    loginAsync: (request: CustomMethodBodyRequest<Vneid_LoginRequest>) => Promise<MushroomResponse<string>>;
    registration_otpAsync: (request: CustomMethodBodyRequest<Vneid_Registration_otpRequest>) => Promise<MushroomResponse<boolean>>;
    complete_registrationAsync: (request: CustomMethodBodyRequest<Vneid_Complete_registrationRequest>) => Promise<MushroomResponse<string>>;
    confirm_linkAsync: (request: CustomMethodBodyRequest<Vneid_Confirm_linkRequest>) => Promise<MushroomResponse<string>>;
    link_urlAsync: (request: CustomMethodParamsRequest<Vneid_Link_urlParamRequest>) => Promise<MushroomResponse<Vneid_Link_urlResult>>;
    link_accountAsync: (request: CustomMethodBodyRequest<Vneid_Link_accountRequest>) => Promise<MushroomResponse<string>>;
}
defineAsyncResource<Vneid>({"name":"vneid","actions":{"_raw_http_method_get_login_url":{},"_raw_http_method_login":{},"_raw_http_method_registration_otp":{},"_raw_http_method_complete_registration":{},"_raw_http_method_confirm_link":{},"_raw_http_method_link_url":{},"_raw_http_method_link_account":{}},"views":{}}, mushroom);

export interface Vtq {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Thứ tự hiển thị
     */
    index?: number | null;
    /**
     * Mã địa điểm
     */
    place_code?: string | null;
    /**
     * Mã merchant
     */
    merchant_code?: string | null;
    /**
     * Mã số thuế
     */
    tax_code?: string | null;
    /**
     * Đoạn text thời gian mở cửa
     */
    open_time?: string | null;
    /**
     * Đoạn text thời gian mở cửa ngoài menu
     */
    open_time_outside_menu?: string | null;
    /**
     * Tên địa điểm bằng tiếng anh
     */
    place_name_en?: string | null;
    /**
     * Đoạn text giá vé
     */
    ticket_price?: string | null;
    /**
     * Đoạn text hướng dẫn đường đi đến khu di tích
     */
    directions_to_site?: string | null;
    /**
     * Danh sách id ảnh bìa
     */
    id_anh_bia?: Array<string | null | undefined> | null;
    /**
     * Id ảnh đại diện
     */
    id_anh_dai_dien?: string | null;
}

export interface Vtq_Vtq_tity_place_get_ticket_type___Result {
    success: boolean;
    data: Array<Vtq_Vtq_tity_place_get_ticket_type___Result_Data | null | undefined>;
}

export interface Vtq_Vtq_tity_place_get_ticket_type___Result_Data {
    /**
     * Mã loại vé
     */
    Id?: number | null;
    /**
     * Mã code của loại vé
     */
    TicketTypeCode?: string | null;
    /**
     * Tên loại vé
     */
    TicketTypeName?: string | null;
    /**
     * Đơn giá vé (VNĐ)
     */
    DefaultPrice?: number | null;
}

export interface Vtq_Vtq_tity_place_get_ticket_type___Request {
    /**
     * Mã điểm tham quan
     */
    place_code: string;
}

export interface Vtq_Get_ticketResult {
    /**
     * van_mieu.id
     */
    id?: string | null;
    /**
     * Mã pmt_session
     */
    payment_id?: string | null;
    serial_number?: string | null;
    /**
     * serial_number client gửi lên
     */
    requested_serial_number?: string | null;
    created_time?: ISODateValue | null;
    /**
     * Số lượng vé
     */
    amount?: number | null;
    /**
     * Loại vé (partner)
     */
    type?: string | null;
    /**
     * Dữ liệu vé trả về từ VTQ
     */
    data?: Vtq_Get_ticketResult_Data | null;
}

export interface Vtq_Get_ticketResult_Data {
    OrderCode?: string | null;
    SerialNumber?: string | null;
    PrintQrCode?: string | null;
    IsGroup?: boolean | null;
    Amount?: number | null;
    TotalPrice?: number | null;
    PlaceCode?: string | null;
    PlaceName?: string | null;
    TicketTypeCode?: string | null;
    TicketTypeName?: string | null;
    /**
     * Có thể null
     */
    EffectiveDate?: ISODateValue | null;
    /**
     * Thời điểm xuất vé dạng yyyyMMddHHmmss
     */
    ExportTime?: number | null;
    IsExportedEinvoice?: boolean | null;
    ExportedUsername?: string | null;
    Tickets?: Array<Vtq_Get_ticketResult_Data_Tickets | null | undefined> | null;
}

export interface Vtq_Get_ticketResult_Data_Tickets {
    SerialNumber?: string | null;
    PrintQrCode?: string | null;
    Price?: number | null;
}

export interface Vtq$CustomMethodResource {
    vtq_tity_place_get_ticket_typeAsync: (request: CustomMethodBodyRequest<Vtq_Vtq_tity_place_get_ticket_type___Request>) => Promise<MushroomResponse<Vtq_Vtq_tity_place_get_ticket_type___Result>>;
    get_ticketAsync: (request: MushroomRequest) => Promise<MushroomResponse<Vtq_Get_ticketResult>>;
}
defineAsyncResource<Vtq>({"name":"vtq","actions":{"findMany":{"clientCache":true,"includeTotal":true},"createOne":{},"_raw_http_method_vtq_tity_place_get_ticket_type":{},"_raw_http_method_get_ticket":{}},"views":{}}, mushroom);

export interface Cong_ty_lu_hanh {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Cho biết Công ty có bị disable hay không
     */
    isDisabled?: boolean | null;
    /**
     * Tên sở trường
     */
    ten?: Cong_ty_lu_hanh_Ten | null;
    /**
     * Hotline
     */
    hotline?: string | null;
    /**
     * Email
     */
    email?: string | null;
    /**
     * Số điện thoại
     */
    dien_thoai?: string | null;
    /**
     * Website
     */
    website?: string | null;
    /**
     * Slogan
     */
    slogan?: string | null;
    /**
     * Mã ảnh đại diện
     */
    avatar_id?: IdValue | null;
    /**
     * Địa chỉ
     */
    dia_chi?: Cong_ty_lu_hanh_Dia_chi | null;
    /**
     * Giấy phép kinh doanh lữ hành
     */
    giay_phep_kinh_doanh?: Cong_ty_lu_hanh_Giay_phep_kinh_doanh | null;
    /**
     * Danh sách mã người quản lý công ty lữ hành
     */
    nguoi_quan_ly_ids?: Array<IdValue | null | undefined> | null;
    /**
     * Nội dung hiển thị
     */
    noi_dung_hien_thi?: Array<Cong_ty_lu_hanh_Noi_dung_hien_thi | null | undefined> | null;
    /**
     * [Dùng cho tool import dữ liệu] Version của dữ liệu
     */
    __version?: Cong_ty_lu_hanh___version | null;
}

export interface Cong_ty_lu_hanh_Ten {
    /**
     * Tên tiếng Việt
     */
    vi?: string | null;
    /**
     * Tên tiếng Anh
     */
    en?: string | null;
}

export interface Cong_ty_lu_hanh_Dia_chi {
    /**
     * Mã tỉnh/TP
     */
    province_id?: IdValue | null;
    /**
     * Tên tỉnh/TP
     */
    province_name?: string | null;
    /**
     * Mã quận/huyện
     */
    district_id?: IdValue | null;
    /**
     * Tên quận/huyện
     */
    district_name?: string | null;
    /**
     * Địa chỉ đầy đủ
     */
    dia_chi?: string | null;
}

export interface Cong_ty_lu_hanh_Giay_phep_kinh_doanh {
    /**
     * Số giấy phép
     */
    so_giay_phep?: string | null;
    /**
     * Nơi cấp
     */
    noi_cap?: string | null;
}

export interface Cong_ty_lu_hanh_Noi_dung_hien_thi {
    /**
     * Ngôn ngữ hiển thị
     */
    ngon_ngu?: string | null;
    /**
     * Giới thiệu thông tin
     */
    gioi_thieu?: string | null;
    /**
     * Id của ảnh hiển thị
     */
    anh_id?: IdValue | null;
    /**
     * Nội dung hiển thị
     */
    noi_dung?: string | null;
}

export interface Cong_ty_lu_hanh___version {
    /**
     * Mã băm
     */
    hashCode?: number | null;
    /**
     * Mã dữ liệu tại nguồn
     */
    srcId?: string | null;
}

export interface Cong_ty_lu_hanh$CustomMethodResource {
    saodanhgiaAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
export interface Cong_ty_lu_hanh$ViewsResource_dashboard_getStatisticsView_OfficerParameters {};
export interface Cong_ty_lu_hanh$ViewsResource {
    views: {
        dashboard_getStatisticsAsync: MushroomViewFunction<any, Cong_ty_lu_hanh$ViewsResource_dashboard_getStatisticsView_OfficerParameters>;
    }
}
defineAsyncResource<Cong_ty_lu_hanh>({"name":"cong_ty_lu_hanh","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"_raw_http_method_saodanhgia":{}},"views":{"dashboard_getStatistics":{"clientCache":true}}}, mushroom);

export interface Tour {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Cho biết tour đã hoàn thành hay chưa, mặc đinh là chưa
     */
    da_hoan_thanh?: boolean | null;
    /**
     * Tên tour
     */
    ten_tour?: string | null;
    /**
     * Tên đoàn
     */
    ten_doan?: string | null;
    /**
     * Thông tin địa điểm của tour
     */
    dia_diem?: Tour_Dia_diem | null;
    /**
     * Hành trình
     */
    hanh_trinh?: Array<Tour_Hanh_trinh | null | undefined> | null;
    /**
     * Mã Công ty lữ hành
     */
    cong_ty_lu_hanh_id?: IdValue | null;
    /**
     * Thời gian bắt đầu
     */
    thoi_gian_bat_dau?: ISODateValue | null;
    /**
     * Thời gian kết thúc
     */
    thoi_gian_ket_thuc?: ISODateValue | null;
    /**
     * Số lượng khách
     */
    so_luong_khach?: Tour_So_luong_khach | null;
    /**
     * Thông tin trưởng đoàn
     */
    truong_doan?: Tour_Truong_doan | null;
    /**
     * Các ảnh scan
     */
    scan?: Tour_Scan | null;
    /**
     * Thông tin ô tô
     */
    oto?: Tour_Oto | null;
    /**
     * Danh sách Khách sạn
     */
    khach_san?: Array<Tour_Khach_san | null | undefined> | null;
    /**
     * Danh sách Nhà hàng
     */
    nha_hang?: Array<Tour_Nha_hang | null | undefined> | null;
    /**
     * Các thể loại ảnh của tour
     */
    anh?: Tour_Anh | null;
    /**
     * [Markdown] Nội dung thông tin tour
     */
    noi_dung?: string | null;
    /**
     * Danh sách khách du lịch chờ xác nhận tour
     */
    khach_du_lich_cho_xac_nhan_ids?: Array<IdValue | null | undefined> | null;
    /**
     * Danh sách khách du lịch
     */
    khach_du_lich_ids?: Array<IdValue | null | undefined> | null;
    /**
     * Danh sách khách du lịch chưa có thẻ (tài khoản)
     */
    danh_sach_khach_du_lich_khong_tai_khoan?: Array<Tour_Danh_sach_khach_du_lich_khong_tai_khoan | null | undefined> | null;
    /**
     * Danh sách hướng dẫn viên
     */
    huong_dan_vien_ids?: Array<IdValue | null | undefined> | null;
}

export interface Tour_Dia_diem {
    /**
     * Địa điểm của tour
     */
    dia_diem?: string | null;
    /**
     * Mã tỉnh
     */
    province_id?: IdValue | null;
    /**
     * Kinh độ (longitude)
     */
    lng?: number | null;
    /**
     * Vĩ độ (latitude)
     */
    lat?: number | null;
}

export interface Tour_Hanh_trinh {
    /**
     * Từ ngày/thời điểm
     */
    thoi_gian_bat_dau?: ISODateValue | null;
    /**
     * Đến ngày/thời điểm
     */
    thoi_gian_ket_thuc?: ISODateValue | null;
    /**
     * Địa điểm diễn ra hoặc địa điểm khởi đầu (nếu dia_diem_dich bằng null)
     */
    dia_diem?: Tour_Hanh_trinh_Dia_diem | null;
    /**
     * Địa điểm đích
     */
    dia_diem_dich?: Tour_Hanh_trinh_Dia_diem_dich | null;
    /**
     * Tiêu đề
     */
    tieu_de?: string | null;
    /**
     * Nội dung
     */
    noi_dung?: string | null;
    /**
     * Mã phiếu điều tour
     */
    phieu_dieu_tour_id?: IdValue | null;
}

export interface Tour_Hanh_trinh_Dia_diem {
    /**
     * Địa điểm diễn ra hoặc địa điểm khởi đầu
     */
    dia_diem?: string | null;
    /**
     * Mã tỉnh
     */
    province_id?: IdValue | null;
    /**
     * Mã huyện
     */
    district_id?: IdValue | null;
    /**
     * Kinh độ (longitude)
     */
    lng?: number | null;
    /**
     * Vĩ độ (latitude)
     */
    lat?: number | null;
}

export interface Tour_Hanh_trinh_Dia_diem_dich {
    /**
     * Địa điểm đích
     */
    dia_diem?: string | null;
    /**
     * Mã tỉnh
     */
    province_id?: IdValue | null;
    /**
     * Mã huyện
     */
    district_id?: IdValue | null;
    /**
     * Kinh độ (longitude)
     */
    lng?: number | null;
    /**
     * Vĩ độ (latitude)
     */
    lat?: number | null;
}

export interface Tour_So_luong_khach {
    /**
     * Tổng số lượng khách
     */
    so_luong?: number | null;
    /**
     * Số người lớn
     */
    nguoi_lon?: number | null;
    /**
     * Số trẻ từ 5 đến 15 tuổi
     */
    tre_5_15?: number | null;
    /**
     * Số trẻ dưới 5 tuổi
     */
    tre_duoi_5?: number | null;
}

export interface Tour_Truong_doan {
    /**
     * Mã trưởng đoàn
     */
    truong_doan_id?: IdValue | null;
    /**
     * Ngày tháng năm sinh
     */
    ngay_sinh?: Tour_Truong_doan_Ngay_sinh | null;
    /**
     * Số điện thoại
     */
    dien_thoai?: string | null;
}

export interface Tour_Truong_doan_Ngay_sinh {
    /**
     * Ngày
     */
    ngay?: number | null;
    /**
     * Tháng
     */
    thang?: number | null;
    /**
     * Năm
     */
    nam?: number | null;
    /**
     * Ngày sinh
     */
    ngay_sinh?: ISODateValue | null;
}

export interface Tour_Scan {
    /**
     * Scan các ảnh chụp thông tin điều tour
     */
    thong_tin_dieu_tour?: Array<IdValue | null | undefined> | null;
    /**
     * Các file đính kèm về hồ sơ Tour
     */
    ho_so_tour?: Array<IdValue | null | undefined> | null;
}

export interface Tour_Oto {
    /**
     * Biển số xe
     */
    bien_so_xe?: string | null;
    /**
     * Thông tin tài xế
     */
    tai_xe?: Tour_Oto_Tai_xe | null;
}

export interface Tour_Oto_Tai_xe {
    /**
     * Họ tên tài xế
     */
    ho_ten?: string | null;
    /**
     * Số điện thoại tài xế
     */
    dien_thoai?: string | null;
}

export interface Tour_Khach_san {
    /**
     * Tên khách sạn
     */
    ten?: string | null;
    /**
     * Số điện thoại người phụ trách
     */
    dien_thoai?: string | null;
    /**
     * Địa chỉ khách sạn
     */
    dia_chi?: Tour_Khach_san_Dia_chi | null;
    /**
     * Tên người quản lý
     */
    ten_nguoi_quan_ly?: string | null;
}

export interface Tour_Khach_san_Dia_chi {
    /**
     * Địa chỉ khách sạn
     */
    dia_chi?: string | null;
    /**
     * Mã tỉnh
     */
    province_id?: IdValue | null;
    /**
     * Kinh độ (longitude)
     */
    lng?: number | null;
    /**
     * Vĩ độ (latitude)
     */
    lat?: number | null;
}

export interface Tour_Nha_hang {
    /**
     * Tên Nhà hàng
     */
    ten?: string | null;
    /**
     * Số điện thoại người phụ trách
     */
    dien_thoai?: string | null;
    /**
     * Địa chỉ nhà hàng
     */
    dia_chi?: Tour_Nha_hang_Dia_chi | null;
    /**
     * Tên người quản lý
     */
    ten_nguoi_quan_ly?: string | null;
}

export interface Tour_Nha_hang_Dia_chi {
    /**
     * Địa chỉ nhà hàng
     */
    dia_chi?: string | null;
    /**
     * Mã tỉnh
     */
    province_id?: IdValue | null;
    /**
     * Kinh độ (longitude)
     */
    lng?: number | null;
    /**
     * Vĩ độ (latitude)
     */
    lat?: number | null;
}

export interface Tour_Anh {
    /**
     * Mã ảnh đại diện của tour (thường là ảnh vuông)
     */
    anh_dai_dien?: IdValue | null;
    /**
     * Danh sách ảnh chụp của tour
     */
    anh_tour?: Array<IdValue | null | undefined> | null;
}

export interface Tour_Danh_sach_khach_du_lich_khong_tai_khoan {
    /**
     * Mã thẻ
     */
    so_the?: string | null;
    /**
     * Mã people_code
     */
    people_code?: string | null;
    /**
     * Tên người dùng
     */
    ho_ten?: Tour_Danh_sach_khach_du_lich_khong_tai_khoan_Ho_ten | null;
    /**
     * Email
     */
    email?: string | null;
    /**
     * Số điện thoại
     */
    dien_thoai?: string | null;
    /**
     * Giới tính: 1 - Nữ, 2 - Nam, 3 - Chưa có thông tin, 4 - Khác
     */
    gioi_tinh?: number | null;
    /**
     * Ngày tháng năm sinh
     */
    ngay_sinh?: Tour_Danh_sach_khach_du_lich_khong_tai_khoan_Ngay_sinh | null;
    /**
     * Giấy tờ, ví dụ: CMT, CCCD, Họ chiếu
     */
    giay_to?: Array<Tour_Danh_sach_khach_du_lich_khong_tai_khoan_Giay_to | null | undefined> | null;
    /**
     * Quốc tịch
     */
    quoc_tich?: Tour_Danh_sach_khach_du_lich_khong_tai_khoan_Quoc_tich | null;
    /**
     * Địa chỉ
     */
    dia_chi?: Tour_Danh_sach_khach_du_lich_khong_tai_khoan_Dia_chi | null;
}

export interface Tour_Danh_sach_khach_du_lich_khong_tai_khoan_Ho_ten {
    /**
     * Tên
     */
    ten?: string | null;
    /**
     * Họ
     */
    ho?: string | null;
    /**
     * Họ tên đầy đủ
     */
    ho_ten?: string | null;
    /**
     * Định dạng tên
     */
    dinh_dang?: string | null;
}

export interface Tour_Danh_sach_khach_du_lich_khong_tai_khoan_Ngay_sinh {
    /**
     * Ngày
     */
    ngay?: number | null;
    /**
     * Tháng
     */
    thang?: number | null;
    /**
     * Năm
     */
    nam?: number | null;
    /**
     * Ngày sinh
     */
    ngay_sinh?: ISODateValue | null;
}

export interface Tour_Danh_sach_khach_du_lich_khong_tai_khoan_Giay_to {
    /**
     * Loại giấy tờ
     */
    loai_giay_to?: string | null;
    /**
     * Số giấy tờ
     */
    so_giay_to?: string | null;
    /**
     * Nơi cấp
     */
    noi_cap?: string | null;
    /**
     * Ngày cấp
     */
    ngay_cap?: ISODateValue | null;
    /**
     * Ngày hết hạn
     */
    ngay_het_han?: ISODateValue | null;
}

export interface Tour_Danh_sach_khach_du_lich_khong_tai_khoan_Quoc_tich {
    /**
     * Mã quốc tịch
     */
    quoc_tich_id?: IdValue | null;
    /**
     * Tên quốc tịch
     */
    ten_quoc_tich?: string | null;
}

export interface Tour_Danh_sach_khach_du_lich_khong_tai_khoan_Dia_chi {
    /**
     * Mã tỉnh/TP
     */
    province_id?: IdValue | null;
    /**
     * Tên tỉnh/TP
     */
    province_name?: string | null;
    /**
     * Mã quận/huyện
     */
    district_id?: IdValue | null;
    /**
     * Tên quận/huyện
     */
    district_name?: string | null;
    /**
     * Địa chỉ đầy đủ
     */
    dia_chi?: string | null;
}

export interface Tour$CustomMethodResource {
    confirmTourAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    cancelTourAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    removeKhachDuLichAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    importTouristsAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    addTouristByCardCodeAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
export interface Tour$ViewsResource_getPendingToursView_TourGuideParameters {};
export interface Tour$ViewsResource_getPendingToursView_UserParameters {};
export interface Tour$ViewsResource_getTourCountByTourGuideIdsView_Parameters {
    /**
     * Danh sách mã hướng dẫn viên
     */
    hdv_ids?: IdValue[] | null;
};
export interface Tour$ViewsResource_dashboard_getTourGuideStatisticsView_TourAgentParameters {};
export interface Tour$ViewsResource_dashboard_getTourCountStatisticsView_TourAgentParameters {
    /**
     * Từ ngày, mặc định 1 năm trước
     */
    from?: ISODateValue | null;
    /**
     * Đến ngày, mặc định ngày mai
     */
    to?: ISODateValue | null;
};
export interface Tour$ViewsResource {
    views: {
        getPendingToursAsync: MushroomViewFunction<any, Tour$ViewsResource_getPendingToursView_TourGuideParameters> | MushroomViewFunction<any, Tour$ViewsResource_getPendingToursView_UserParameters>;
        getTourCountByTourGuideIdsAsync: MushroomViewFunction<any, Tour$ViewsResource_getTourCountByTourGuideIdsView_Parameters>;
        dashboard_getTourGuideStatisticsAsync: MushroomViewFunction<any, Tour$ViewsResource_dashboard_getTourGuideStatisticsView_TourAgentParameters>;
        dashboard_getTourCountStatisticsAsync: MushroomViewFunction<any, Tour$ViewsResource_dashboard_getTourCountStatisticsView_TourAgentParameters>;
    }
}
defineAsyncResource<Tour>({"name":"tour","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"deleteOne":{},"_raw_http_method_confirmTour":{},"_raw_http_method_cancelTour":{},"_raw_http_method_removeKhachDuLich":{},"_raw_http_method_importTourists":{},"_raw_http_method_addTouristByCardCode":{}},"views":{"getPendingTours":{"clientCache":true},"getTourCountByTourGuideIds":{"clientCache":true},"dashboard_getTourGuideStatistics":{"clientCache":true},"dashboard_getTourCountStatistics":{"clientCache":true}}}, mushroom);

export interface Phieu_dieu_tour {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã tour
     */
    tour_id?: IdValue | null;
    /**
     * Danh sách mã hướng dẫn viên chờ xác nhận
     */
    huong_dan_vien_cho_xac_nhan_ids?: Array<IdValue | null | undefined> | null;
    /**
     * Danh sách mã hướng dẫn viên
     */
    huong_dan_vien_ids?: Array<IdValue | null | undefined> | null;
    /**
     * Thời gian bắt đầu
     */
    thoi_gian_bat_dau?: ISODateValue | null;
    /**
     * Thời gian kết thúc
     */
    thoi_gian_ket_thuc?: ISODateValue | null;
    /**
     * Danh sách mã các file đính kèm
     */
    file_dinh_kem_ids?: Array<IdValue | null | undefined> | null;
}

export interface Phieu_dieu_tour$CustomMethodResource {
    confirmPhieuDieuTourAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    cancelPhieuDieuTourAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
export interface Phieu_dieu_tour$ViewsResource_getListForTourGuideView_TourGuideParameters {
    /**
     * Các từ khóa tìm kiếm
     */
    words?: string[] | null;
    /**
     * Số lượng tối đa bản ghi trả về
     */
    limit?: number | null;
    /**
     * Bỏ qua offset bản ghi đầu danh sách
     */
    offset?: number | null;
};
export interface Phieu_dieu_tour$ViewsResource_getCurrentListOfTourGuideView_UserParameters {
    /**
     * Mã hướng dẫn viên
     */
    hdv_id: IdValue;
};
export interface Phieu_dieu_tour$ViewsResource {
    views: {
        getListForTourGuideAsync: MushroomViewFunction<any, Phieu_dieu_tour$ViewsResource_getListForTourGuideView_TourGuideParameters>;
        getCurrentListOfTourGuideAsync: MushroomViewFunction<any, Phieu_dieu_tour$ViewsResource_getCurrentListOfTourGuideView_UserParameters>;
    }
}
defineAsyncResource<Phieu_dieu_tour>({"name":"phieu_dieu_tour","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"deleteOne":{},"_raw_http_method_confirmPhieuDieuTour":{},"_raw_http_method_cancelPhieuDieuTour":{}},"views":{"getListForTourGuide":{"clientCache":true},"getCurrentListOfTourGuide":{"clientCache":true}}}, mushroom);

export interface Tourist_group {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Tên đoàn du lịch
     */
    ten_doan?: string | null;
    /**
     * Thời gian tạo đoàn
     */
    thoi_gian_tao?: ISODateValue | null;
    /**
     * Thời gian bắt đầu
     */
    thoi_gian_bat_dau?: ISODateValue | null;
    /**
     * Thời gian kết thúc
     */
    thoi_gian_ket_thuc?: ISODateValue | null;
    /**
     * Trạng thái đoàn du lịch
     */
    trang_thai?: string | null;
    /**
     * Thời gian hệ thống đóng/giải phóng đoàn
     */
    thoi_gian_dong?: ISODateValue | null;
    /**
     * Đã gửi thông báo tự động khi đoàn hết thời gian
     */
    thong_bao_dong?: boolean | null;
    /**
     * Id người tạo
     */
    nguoi_tao_id?: IdValue | null;
    /**
     * Số lượng khách
     */
    so_luong_khach?: number | null;
    /**
     * Danh sách khách du lịch
     */
    khach_du_lichs?: Array<Tourist_group_Khach_du_lichs | null | undefined> | null;
    /**
     * Nội dung thông tin đoàn
     */
    noi_dung?: string | null;
}

export interface Tourist_group_Khach_du_lichs {
    /**
     * Id khách du lịch
     */
    khach_du_lich_id?: IdValue | null;
    /**
     * Họ và tên khách du lịch
     */
    ho_ten?: string | null;
    /**
     * Số thẻ việt
     */
    so_the?: string | null;
    /**
     * Số điện thoại
     */
    so_dien_thoai?: string | null;
}

export interface Tourist_group_Action_kdl_to_tourist_group_by_qrRequest {
    /**
     * Mã đoàn du lịch
     */
    doan_id: string;
    /**
     * Mã QR trên app khách
     */
    qr_code: string;
}

export interface Tourist_group_Action_get_hdv_by_kdl_idResult {
    /**
     * Mã hướng dẫn viên cùng đoàn
     */
    huong_dan_vien_id?: IdValue | null;
    /**
     * Mã đoàn du lịch đang hoạt động
     */
    tourist_group_id?: IdValue | null;
}

export interface Tourist_group_Action_get_hdv_by_kdl_idRequest {
    /**
     * Mã khách du lịch
     */
    khach_du_lich_id: IdValue;
}

export interface Tourist_group$CustomMethodResource {
    action_kdl_to_tourist_groupAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    action_kdl_to_tourist_group_by_qrAsync: (request: CustomMethodBodyRequest<Tourist_group_Action_kdl_to_tourist_group_by_qrRequest>) => Promise<MushroomResponse<any>>;
    action_get_hdv_by_kdl_cardCodeAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    action_get_hdv_by_kdl_idAsync: (request: CustomMethodBodyRequest<Tourist_group_Action_get_hdv_by_kdl_idRequest>) => Promise<MushroomResponse<Tourist_group_Action_get_hdv_by_kdl_idResult>>;
}
defineAsyncResource<Tourist_group>({"name":"tourist_group","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"deleteOne":{},"_raw_http_method_action_kdl_to_tourist_group":{},"_raw_http_method_action_kdl_to_tourist_group_by_qr":{},"_raw_http_method_action_get_hdv_by_kdl_cardCode":{},"_raw_http_method_action_get_hdv_by_kdl_id":{}},"views":{}}, mushroom);

export interface Nhom_phan_hoi {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Loại nhóm phản hồi, nhận một trong ba giá trị sau: kdl, hdv, ddat, trang_vang
     */
    loai?: string | null;
    /**
     * Các đối tượng có thể nhận phản hồi từ nhóm này
     */
    doi_tuong_nhan?: Array<string | null | undefined> | null;
    /**
     * Tên nhóm
     */
    ten?: Nhom_phan_hoi_Ten | null;
    /**
     * Thứ tự sắp xếp
     */
    thu_tu?: number | null;
    /**
     * Cho biết các phản hồi vào nhóm này có chuyển sang tổng cục quản lý thị trường hay không
     */
    chuyen_tcqltt?: boolean | null;
}

export interface Nhom_phan_hoi_Ten {
    /**
     * Tên tiếng Việt
     */
    vi?: string | null;
    /**
     * Tên tiếng Anh
     */
    en?: string | null;
}

defineAsyncResource<Nhom_phan_hoi>({"name":"nhom_phan_hoi","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{}},"views":{}}, mushroom);

export interface Phan_hoi {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã người phản hồi
     */
    nguoi_gui_id?: IdValue | null;
    /**
     * Mã tỉnh của vị trí tại thời điểm người dùng gửi phản ảnh/phản hồi
     */
    province_id?: IdValue | null;
    /**
     * Thời điểm phản hồi
     */
    thoi_diem_phan_hoi?: ISODateValue | null;
    /**
     * Mã nhóm phản hồi
     */
    nhom_phan_hoi?: IdValue | null;
    /**
     * Mã công ty lữ hành nhận phản hồi, nếu null hoặc missing thì là phản hồi tới cơ quan quản lý
     */
    cong_ty_lu_hanh_id?: IdValue | null;
    /**
     * Id điểm đến nhận phản hồi
     */
    diem_den_an_toan_id?: IdValue | null;
    /**
     * Mã tỉnh của điểm đến nhận phản hồi
     */
    diem_den_an_toan_province_id?: IdValue | null;
    /**
     * [Obsoleted] Mã tour mà người dùng muốn phản hồi
     */
    tour_id?: IdValue | null;
    /**
     * Đối tượng nhận phản hồi
     */
    doi_tuong_nhan?: Phan_hoi_Doi_tuong_nhan | null;
    /**
     * Đối tượng bị phản hồi
     */
    doi_tuong_phan_hoi?: Phan_hoi_Doi_tuong_phan_hoi | null;
    /**
     * Nội dung phản hồi
     */
    noi_dung?: string | null;
    /**
     * Danh sách ảnh/video đính kèm
     */
    file_dinh_kem?: Array<IdValue | null | undefined> | null;
    /**
     * Trạng thái xử lý
     */
    trang_thai?: string | null;
    /**
     * Danh sách lịch sử thay đổi
     */
    lich_su?: Array<Phan_hoi_Lich_su | null | undefined> | null;
    /**
     * Các dữ liệu phát sinh khi chuyển sang tổng cục quản lý thị trường
     */
    tcqltt?: Phan_hoi_Tcqltt | null;
    /**
     * Thông tin tọa độ (theo chuẩn GeoJSON)
     */
    loc?: Phan_hoi_Loc | null;
}

export interface Phan_hoi_Doi_tuong_nhan {
    /**
     * Đối tượng nhận. CQQL (Cơ quan quản lý), DNLH (Doanh nghiệp lữ hành), DDAT(Điểm đến)
     */
    doi_tuong?: string | null;
    /**
     * Mã đối tượng nhận phản hồi
     */
    doi_tuong_id?: IdValue | null;
}

export interface Phan_hoi_Doi_tuong_phan_hoi {
    /**
     * Đối tượng bị phản hồi (DNLH - doanh nghiệp lữ hành, TOUR - tour, HDV - hướng dấn viên, CSLT - cơ sở lưu trú, DDAT - điểm đến an toàn)
     */
    doi_tuong?: string | null;
    /**
     * Mã đối tượng bị phản hồi
     */
    doi_tuong_id?: IdValue | null;
    /**
     * Mã đối tượng nhận phản hồi cấp con
     */
    doi_tuong_con_id?: IdValue | null;
}

export interface Phan_hoi_Lich_su {
    /**
     * Nội dung hồi đáp
     */
    noi_dung_hoi_dap?: string | null;
    /**
     * Danh sách file hồi đáp
     */
    file_hoi_dap_ids?: Array<IdValue | null | undefined> | null;
    /**
     * Nội dung xử lý
     */
    noi_dung_xu_ly?: string | null;
    /**
     * Danh sách đính kèm
     */
    file_xu_ly_ids?: Array<IdValue | null | undefined> | null;
    /**
     * Trạng thái xử lý của tổng cục quản lý thị trường
     */
    trang_thai_truoc?: string | null;
    /**
     * Trạng thái xử lý của tổng cục quản lý thị trường
     */
    trang_thai_sau?: string | null;
    /**
     * Thời điểm thay đổi
     */
    thoi_diem?: ISODateValue | null;
    /**
     * Mã người thay đổi
     */
    nguoi_thay_doi_id?: IdValue | null;
}

export interface Phan_hoi_Tcqltt {
    /**
     * Mã người được phân công xử lý
     */
    nguoi_xu_ly_id?: IdValue | null;
    /**
     * Trạng thái xử lý của tổng cục quản lý thị trường
     */
    trang_thai?: string | null;
    /**
     * Danh sách lịch sử chuyển phản hồi
     */
    lich_su?: Array<Phan_hoi_Tcqltt_Lich_su | null | undefined> | null;
}

export interface Phan_hoi_Tcqltt_Lich_su {
    /**
     * Từ người
     */
    tu?: IdValue | null;
    /**
     * Đến người
     */
    den?: IdValue | null;
    /**
     * Lý do chuyển
     */
    ly_do?: string | null;
    /**
     * Thời điểm chuyển
     */
    thoi_diem?: ISODateValue | null;
    /**
     * Danh sách ảnh/video đính kèm
     */
    file_dinh_kem?: Array<IdValue | null | undefined> | null;
    /**
     * Trạng thái xử lý của tổng cục quản lý thị trường
     */
    trang_thai?: string | null;
}

export interface Phan_hoi_Loc {
    /**
     * Fix cứng là Point
     */
    type?: string | null;
    /**
     * Thông tin tọa độ
     */
    coordinates?: Array<number | null | undefined> | null;
}

export interface Phan_hoi_Forward_to_tcqlttRequest {
    /**
     * Từ 1 đến 100 mã phản ánh
     */
    ids?: Array<IdValue | null | undefined> | null;
}

export interface Phan_hoi_UpdateStatusRequest {
    /**
     * Mã của phản hồi cần cập nhật
     */
    id?: IdValue | null;
    /**
     * Trạng thái
     */
    trang_thai?: string | null;
    /**
     * Nội dung hồi đáp
     */
    noi_dung_hoi_dap?: string | null;
    /**
     * Danh sách file hồi đáp
     */
    file_hoi_dap_ids?: Array<IdValue | null | undefined> | null;
    /**
     * Nội dung xử lý
     */
    noi_dung_xu_ly?: string | null;
    /**
     * Danh sách đính kèm
     */
    file_xu_ly_ids?: Array<IdValue | null | undefined> | null;
}

export interface Phan_hoi$CustomMethodResource {
    forward_to_tcqlttAsync: (request: CustomMethodBodyRequest<Phan_hoi_Forward_to_tcqlttRequest>) => Promise<MushroomResponse<any>>;
    updateStatusAsync: (request: CustomMethodBodyRequest<Phan_hoi_UpdateStatusRequest>) => Promise<MushroomResponse<any>>;
    check_payment_or_check_inAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
export interface Phan_hoi$ViewsResource_dashboard_getMonthCountStatisticsView_Officer_TrangVangContentManagerParameters {
    /**
     * Từ ngày, mặc định 1 năm trước
     */
    from?: ISODateValue | null;
    /**
     * Đến ngày, mặc định ngày mai
     */
    to?: ISODateValue | null;
};
export interface Phan_hoi$ViewsResource_dashboard_getMonthCountStatisticsView_TourAgentParameters {
    /**
     * Từ ngày, mặc định 1 năm trước
     */
    from?: ISODateValue | null;
    /**
     * Đến ngày, mặc định ngày mai
     */
    to?: ISODateValue | null;
};
export interface Phan_hoi$ViewsResource_dashboard_getStatusStatisticsView_TourAgentParameters {};
export interface Phan_hoi$ViewsResource_suggest_response_userView_Officer_TrangVangContentManager_VNATAdmin_TCQLTT_TourAgent_SafePlaceParameters {
    /**
     * Tên người check in
     */
    name?: string | null;
    /**
     * Số lượng tối đa trả về
     */
    limit?: number | null;
};
export interface Phan_hoi$ViewsResource_suggest_response_user_v2View_Officer_TrangVangContentManager_VNATAdmin_TCQLTT_TourAgent_SafePlaceParameters {
    /**
     * Tên người check in, mảng không dấu chữ thường
     */
    name?: string[] | null;
    /**
     * Số lượng tối đa trả về
     */
    limit?: number | null;
};
export interface Phan_hoi$ViewsResource {
    views: {
        dashboard_getMonthCountStatisticsAsync: MushroomViewFunction<any, Phan_hoi$ViewsResource_dashboard_getMonthCountStatisticsView_Officer_TrangVangContentManagerParameters> | MushroomViewFunction<any, Phan_hoi$ViewsResource_dashboard_getMonthCountStatisticsView_TourAgentParameters>;
        dashboard_getStatusStatisticsAsync: MushroomViewFunction<any, Phan_hoi$ViewsResource_dashboard_getStatusStatisticsView_TourAgentParameters>;
        suggest_response_userAsync: MushroomViewFunction<any, Phan_hoi$ViewsResource_suggest_response_userView_Officer_TrangVangContentManager_VNATAdmin_TCQLTT_TourAgent_SafePlaceParameters>;
        suggest_response_user_v2Async: MushroomViewFunction<any, Phan_hoi$ViewsResource_suggest_response_user_v2View_Officer_TrangVangContentManager_VNATAdmin_TCQLTT_TourAgent_SafePlaceParameters>;
    }
}
defineAsyncResource<Phan_hoi>({"name":"phan_hoi","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"deleteOne":{},"deleteMany":{},"_raw_http_method_forward_to_tcqltt":{},"_raw_http_method_updateStatus":{},"_raw_http_method_check_payment_or_check_in":{}},"views":{"dashboard_getMonthCountStatistics":{"clientCache":true},"dashboard_getStatusStatistics":{"clientCache":true},"suggest_response_user":{"clientCache":true},"suggest_response_user_v2":{"clientCache":true}}}, mushroom);

export interface Nhom_thanh_phan_danh_gia {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Phân loại đối tượng được đánh giá
     */
    loai?: string | null;
    /**
     * Tên nhóm thành phần đánh giá
     */
    ten?: Nhom_thanh_phan_danh_gia_Ten | null;
    /**
     * Thứ tự sắp xếp
     */
    thu_tu?: number | null;
    /**
     * Cho biết nhóm thành phần này có đang bị ẩn trên giao diện đánh giá của người dùng hay không
     */
    an?: boolean | null;
}

export interface Nhom_thanh_phan_danh_gia_Ten {
    /**
     * Tên tiếng Việt
     */
    vi?: string | null;
    /**
     * Tên tiếng Anh
     */
    en?: string | null;
}

defineAsyncResource<Nhom_thanh_phan_danh_gia>({"name":"nhom_thanh_phan_danh_gia","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{}},"views":{}}, mushroom);

export interface Danh_gia {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã người đánh giá
     */
    nguoi_danh_gia_id?: IdValue | null;
    /**
     * Mã tour, mã hướng dẫn viên du lịch hoặc mã dịch vụ du lịch được đánh giá (phụ thuộc vào trường loai_doi_tuong_danh_gia)
     */
    doi_tuong_danh_gia_id?: IdValue | null;
    /**
     * Loại đánh giá, dùng để phân biệt giá trị trong trường doi_tuong_danh_gia_id
     */
    loai_doi_tuong_danh_gia?: string | null;
    /**
     * Mã tour có giá trị trong trường hợp đánh giá hướng dẫn viên du lịch trong tour
     */
    tour_id?: IdValue | null;
    /**
     * Số sao đánh giá của người dùng
     */
    gia_tri?: number | null;
    /**
     * Nội dung đánh giá
     */
    noi_dung?: string | null;
    /**
     * Danh sách các đánh giá thành phần
     */
    thanh_phan?: Array<Danh_gia_Thanh_phan | null | undefined> | null;
    /**
     * Thời điểm tạo
     */
    thoi_diem_tao?: ISODateValue | null;
    /**
     * Lưu thông tin thêm của từng đánh giá
     */
    thong_tin_them?: Danh_gia_Thong_tin_them | null;
}

export interface Danh_gia_Thanh_phan {
    /**
     * Mã nhóm thành phần
     */
    nhom_id?: IdValue | null;
    /**
     * Giá trị đánh giá thành phần
     */
    gia_tri?: number | null;
}

export interface Danh_gia_Thong_tin_them {
    /**
     * Thong tin kpi
     */
    kpis?: Array<string | null | undefined> | null;
}

export interface Danh_gia$ViewsResource_getStarView_Parameters {
    /**
     * Danh sách mã đối tượng
     */
    doi_tuong_ids: IdValue[];
};
export interface Danh_gia$ViewsResource_getSortableStarView_Admin_VNATAdminParameters {
    /**
     * Đối tượng được đánh giá.
     */
    type: string;
    /**
     * Loại sắp xếp. Nhận giá trị 1 là asc, -1 là desc. Mặc định là -1
     */
    sort_type?: number | null;
    /**
     * Offset. Dùng để phân trang. Mặc định là 0
     */
    offset?: number | null;
    /**
     * Limit. Dùng để phân trang. Mặc định là 25
     */
    limit?: number | null;
};
export interface Danh_gia$ViewsResource_getSortableStarTotalView_Admin_VNATAdminParameters {
    /**
     * Loại đối tượng được đánh giá.
     */
    type: string;
};
export interface Danh_gia$ViewsResource_getSortableStarForTouristView_Admin_VNATAdmin_SVHTT_PVHTTParameters {
    /**
     * Danh sách các từ khóa dùng để tìm kiếm, không phân biệt hoa thường, dấu tiếng Việt nhưng yêu cầu tròn chữ
     */
    words?: string[] | null;
    /**
     * Số thẻ (tìm kiếm tương đối)
     */
    so_the?: string | null;
    /**
     * Điện thoại (tìm kiếm tương đối)
     */
    dien_thoai?: string | null;
    /**
     * Loại sắp xếp. Nhận giá trị 1 là asc, -1 là desc. Mặc định là -1
     */
    sort_type?: number | null;
    /**
     * Offset. Dùng để phân trang. Mặc định là 0
     */
    offset?: number | null;
    /**
     * Limit. Dùng để phân trang. Mặc định là 25
     */
    limit?: number | null;
};
export interface Danh_gia$ViewsResource_getSortableStarForTouristTotalView_Admin_VNATAdmin_SVHTT_PVHTTParameters {
    /**
     * Danh sách các từ khóa dùng để tìm kiếm, không phân biệt hoa thường, dấu tiếng Việt nhưng yêu cầu tròn chữ
     */
    words?: string[] | null;
    /**
     * Số thẻ (tìm kiếm tương đối)
     */
    so_the?: string | null;
    /**
     * Điện thoại (tìm kiếm tương đối)
     */
    dien_thoai?: string | null;
};
export interface Danh_gia$ViewsResource_getSortableStarForSafePlaceView_Admin_VNATAdmin_SVHTT_PVHTTParameters {
    /**
     * Loại điểm đến
     */
    loai?: string | null;
    /**
     * Tài khoản dd (tìm kiếm tương đối)
     */
    account?: string | null;
    /**
     * Tên điểm đến an toàn (tìm kiếm tương đối, phân biệt dấu tiếng Việt)
     */
    ten?: string | null;
    /**
     * Mã tỉnh
     */
    tinh_id?: IdValue | null;
    /**
     * Mã huyện
     */
    huyen_id?: IdValue | null;
    /**
     * Mã xã
     */
    xa_id?: IdValue | null;
    /**
     * Loại sắp xếp. Nhận giá trị 1 là asc, -1 là desc. Mặc định là -1
     */
    sort_type?: number | null;
    /**
     * Offset. Dùng để phân trang. Mặc định là 0
     */
    offset?: number | null;
    /**
     * Limit. Dùng để phân trang. Mặc định là 25
     */
    limit?: number | null;
};
export interface Danh_gia$ViewsResource_getSortableStarForSafePlaceTotalView_Admin_VNATAdmin_SVHTT_PVHTTParameters {
    /**
     * Loại điểm đến
     */
    loai?: string | null;
    /**
     * Tài khoản dd (tìm kiếm tương đối)
     */
    account?: string | null;
    /**
     * Tên điểm đến an toàn (tìm kiếm tương đối, phân biệt dấu tiếng Việt)
     */
    ten?: string | null;
    /**
     * Mã tỉnh
     */
    tinh_id?: IdValue | null;
    /**
     * Mã huyện
     */
    huyen_id?: IdValue | null;
    /**
     * Mã xã
     */
    xa_id?: IdValue | null;
};
export interface Danh_gia$ViewsResource_dashboard_getTourGuideStarStatisticsView_OfficerParameters {};
export interface Danh_gia$ViewsResource_dashboard_getCompanyStarStatisticsView_OfficerParameters {};
export interface Danh_gia$ViewsResource_dashboard_getTouristRatingForCompanyStatisticsView_TourAgentParameters {};
export interface Danh_gia$ViewsResource {
    views: {
        getStarAsync: MushroomViewFunction<any, Danh_gia$ViewsResource_getStarView_Parameters>;
        getSortableStarAsync: MushroomViewFunction<any, Danh_gia$ViewsResource_getSortableStarView_Admin_VNATAdminParameters>;
        getSortableStarTotalAsync: MushroomViewFunction<any, Danh_gia$ViewsResource_getSortableStarTotalView_Admin_VNATAdminParameters>;
        getSortableStarForTouristAsync: MushroomViewFunction<any, Danh_gia$ViewsResource_getSortableStarForTouristView_Admin_VNATAdmin_SVHTT_PVHTTParameters>;
        getSortableStarForTouristTotalAsync: MushroomViewFunction<any, Danh_gia$ViewsResource_getSortableStarForTouristTotalView_Admin_VNATAdmin_SVHTT_PVHTTParameters>;
        getSortableStarForSafePlaceAsync: MushroomViewFunction<any, Danh_gia$ViewsResource_getSortableStarForSafePlaceView_Admin_VNATAdmin_SVHTT_PVHTTParameters>;
        getSortableStarForSafePlaceTotalAsync: MushroomViewFunction<any, Danh_gia$ViewsResource_getSortableStarForSafePlaceTotalView_Admin_VNATAdmin_SVHTT_PVHTTParameters>;
        dashboard_getTourGuideStarStatisticsAsync: MushroomViewFunction<any, Danh_gia$ViewsResource_dashboard_getTourGuideStarStatisticsView_OfficerParameters>;
        dashboard_getCompanyStarStatisticsAsync: MushroomViewFunction<any, Danh_gia$ViewsResource_dashboard_getCompanyStarStatisticsView_OfficerParameters>;
        dashboard_getTouristRatingForCompanyStatisticsAsync: MushroomViewFunction<any, Danh_gia$ViewsResource_dashboard_getTouristRatingForCompanyStatisticsView_TourAgentParameters>;
    }
}
defineAsyncResource<Danh_gia>({"name":"danh_gia","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"deleteOne":{}},"views":{"getStar":{"clientCache":true},"getSortableStar":{"clientCache":true},"getSortableStarTotal":{"clientCache":true},"getSortableStarForTourist":{"clientCache":true},"getSortableStarForTouristTotal":{"clientCache":true},"getSortableStarForSafePlace":{"clientCache":true},"getSortableStarForSafePlaceTotal":{"clientCache":true},"dashboard_getTourGuideStarStatistics":{"clientCache":true},"dashboard_getCompanyStarStatistics":{"clientCache":true},"dashboard_getTouristRatingForCompanyStatistics":{"clientCache":true}}}, mushroom);

export interface Danh_gia_log {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã ddat checkin (nếu có)
     */
    check_in_id?: IdValue | null;
    /**
     * Mã đánh giá
     */
    danh_gia_id?: IdValue | null;
    /**
     * Mã người đánh giá
     */
    nguoi_danh_gia_id?: IdValue | null;
    /**
     * Mã tour, mã hướng dẫn viên du lịch hoặc mã dịch vụ du lịch được đánh giá (phụ thuộc vào trường loai_doi_tuong_danh_gia)
     */
    doi_tuong_danh_gia_id?: IdValue | null;
    /**
     * Loại đánh giá, dùng để phân biệt giá trị trong trường doi_tuong_danh_gia_id
     */
    loai_doi_tuong_danh_gia?: string | null;
    /**
     * Mã tour có giá trị trong trường hợp đánh giá hướng dẫn viên du lịch trong tour
     */
    tour_id?: IdValue | null;
    /**
     * Số sao đánh giá của người dùng
     */
    gia_tri?: number | null;
    /**
     * Nội dung đánh giá
     */
    noi_dung?: string | null;
    /**
     * Danh sách các đánh giá thành phần
     */
    thanh_phan?: Array<Danh_gia_log_Thanh_phan | null | undefined> | null;
    /**
     * Thời điểm tạo
     */
    thoi_diem_tao?: ISODateValue | null;
    /**
     * Lưu thông tin thêm của từng đánh giá
     */
    thong_tin_them?: Danh_gia_log_Thong_tin_them | null;
}

export interface Danh_gia_log_Thanh_phan {
    /**
     * Mã nhóm thành phần
     */
    nhom_id?: IdValue | null;
    /**
     * Giá trị đánh giá thành phần
     */
    gia_tri?: number | null;
}

export interface Danh_gia_log_Thong_tin_them {
    /**
     * Thong tin kpi
     */
    kpis?: Array<string | null | undefined> | null;
}

defineAsyncResource<Danh_gia_log>({"name":"danh_gia_log","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true}},"views":{}}, mushroom);

export interface Danh_muc_tin {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã ngôn ngữ
     */
    ngon_ngu?: string | null;
    /**
     * Tên danh mục
     */
    ten?: string | null;
    /**
     * Mã ảnh đại diện của danh mục tin
     */
    anh_dai_dien_id?: IdValue | null;
    /**
     * Thứ tự hiện thị
     */
    thu_tu?: number | null;
    /**
     * Cho biết có phải danh mục nổi bật hay không
     */
    noi_bat?: boolean | null;
    /**
     * Icon của danh mục
     */
    icon?: IdValue | null;
    /**
     * Cho phép ẩn hay không
     */
    an?: boolean | null;
    /**
     * Mã danh mục tin
     */
    code?: string | null;
}

defineAsyncResource<Danh_muc_tin>({"name":"danh_muc_tin","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{}},"views":{}}, mushroom);

export interface Tin_tuc {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã ngôn ngữ
     */
    ngon_ngu?: string | null;
    /**
     * Cho biết bài viết có bị ẩn hay không
     */
    an_bai_viet?: boolean | null;
    /**
     * Đối tượng sẽ nhìn thấy bài viết này, các giá trị hợp lệ: tourist, tourguide
     */
    doi_tuong_hien_thi?: Array<string | null | undefined> | null;
    /**
     * Mã danh mục tin tức
     */
    danh_muc_id?: IdValue | null;
    /**
     * Tiêu đề bài viết
     */
    tieu_de?: string | null;
    /**
     * [Markdown] Nội dung bài viết
     */
    noi_dung?: string | null;
    /**
     * Các thể loại ảnh của tin tức
     */
    anh?: Tin_tuc_Anh | null;
    /**
     * Thông tin địa điểm của tin tức
     */
    dia_diem?: Tin_tuc_Dia_diem | null;
    /**
     * Danh sách các tags của bài viết
     */
    tags?: Array<string | null | undefined> | null;
    /**
     * Thời điểm đăng bài
     */
    thoi_diem_dang_bai?: ISODateValue | null;
    /**
     * Thời điểm tạo
     */
    thoi_diem_tao?: ISODateValue | null;
    /**
     * Mã người tạo
     */
    nguoi_tao_id?: IdValue | null;
}

export interface Tin_tuc_Anh {
    /**
     * Mã ảnh đại diện của tin tức
     */
    anh_dai_dien?: IdValue | null;
    /**
     * Danh sách ảnh của tin tức
     */
    anh_tin_tuc?: Array<IdValue | null | undefined> | null;
}

export interface Tin_tuc_Dia_diem {
    /**
     * Địa điểm
     */
    dia_diem?: string | null;
    /**
     * Mã tỉnh
     */
    province_id?: IdValue | null;
    /**
     * Mã huyện
     */
    district_id?: IdValue | null;
    /**
     * Kinh độ (longitude)
     */
    lng?: number | null;
    /**
     * Vĩ độ (latitude)
     */
    lat?: number | null;
}

export interface Tin_tuc_Get_category_newsRequest {
    /**
     * Mã danh mục tin tức
     */
    category: number;
    /**
     * Ngôn ngữ của tin tức
     */
    lang: string;
    /**
     * Tỉnh/Thành phố cần lọc dữ liệu (Không gồm chữ Tỉnh hoặc Thành phố, bỏ dấu tiếng Việt, thay thế dấu cách thành dấu -)
     */
    city?: string | null;
    /**
     * Vị trí bắt đầu lấy tin tức
     */
    offset?: number | null;
    /**
     * Số lượng tin tức cần lấy về
     */
    limit: number;
    /**
     * callType
     */
    callType?: number | null;
    /**
     * type
     */
    type?: number | null;
}

export interface Tin_tuc_Get_news_by_idRequest {
    /**
     * Mã tin tức cần lấy về
     */
    news_id: number;
    /**
     * Ngôn ngữ của tin tức
     */
    lang: string;
}

export interface Tin_tuc$CustomMethodResource {
    get_category_newsAsync: (request: CustomMethodBodyRequest<Tin_tuc_Get_category_newsRequest>) => Promise<MushroomResponse<any>>;
    get_news_by_idAsync: (request: CustomMethodBodyRequest<Tin_tuc_Get_news_by_idRequest>) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<Tin_tuc>({"name":"tin_tuc","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"_raw_http_method_get_category_news":{},"_raw_http_method_get_news_by_id":{}},"views":{}}, mushroom);

export interface Dich_vu_chat_luong_cao {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Cho biết dịch vụ có bị ẩn hay không
     */
    an_dich_vu?: boolean | null;
    /**
     * Cho biết dịch vụ đã được duyệt hay chưa
     */
    da_duyet?: boolean | null;
    /**
     * Lý do không duyệt nội dung, nếu bằng null thì nghĩa là chưa xét duyệt
     */
    ly_do_khong_duyet?: string | null;
    /**
     * Tên dịch vụ du lịch
     */
    ten?: Dich_vu_chat_luong_cao_Ten | null;
    /**
     * Nội dung bài viết giới thiệu
     */
    noi_dung?: Dich_vu_chat_luong_cao_Noi_dung | null;
    /**
     * Các thể loại ảnh của dịch vụ
     */
    anh?: Dich_vu_chat_luong_cao_Anh | null;
    /**
     * Thông tin địa điểm của tin tức
     */
    dia_diem?: Dich_vu_chat_luong_cao_Dia_diem | null;
    /**
     * Cho biết dịch vụ có được ghim hay không
     */
    ghim?: boolean | null;
    /**
     * Thứ tự sắp xếp (chỉ tác dụng khi ghim=true)
     */
    thu_tu?: number | null;
    /**
     * Mã tham chiếu tới đối tượng của dịch vụ chất lượng cao. Ví dụ: công ty lữ hành, cơ sở lưu trú, nhà hàng, điểm đến...
     */
    tham_chieu_id?: IdValue | null;
    /**
     * Thời điểm tạo
     */
    thoi_diem_tao?: ISODateValue | null;
    /**
     * Mã người tạo
     */
    nguoi_tao_id?: IdValue | null;
}

export interface Dich_vu_chat_luong_cao_Ten {
    /**
     * Tên tiếng Việt
     */
    vi?: string | null;
    /**
     * Tên tiếng Anh
     */
    en?: string | null;
}

export interface Dich_vu_chat_luong_cao_Noi_dung {
    /**
     * [Markdown] Nội dung tiếng Việt
     */
    vi?: string | null;
    /**
     * [Markdown] Nội dung tiếng Anh
     */
    en?: string | null;
}

export interface Dich_vu_chat_luong_cao_Anh {
    /**
     * Mã ảnh đại diện của dịch vụ
     */
    anh_dai_dien?: IdValue | null;
    /**
     * Danh sách ảnh của bài viết
     */
    anh_bai_viet?: Array<IdValue | null | undefined> | null;
}

export interface Dich_vu_chat_luong_cao_Dia_diem {
    /**
     * Địa điểm
     */
    dia_diem?: string | null;
    /**
     * Mã tỉnh
     */
    province_id?: IdValue | null;
    /**
     * Mã huyện
     */
    district_id?: IdValue | null;
    /**
     * Kinh độ (longitude)
     */
    lng?: number | null;
    /**
     * Vĩ độ (latitude)
     */
    lat?: number | null;
}

defineAsyncResource<Dich_vu_chat_luong_cao>({"name":"dich_vu_chat_luong_cao","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{}},"views":{}}, mushroom);

export interface Co_so_luu_tru {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Tên Cơ sở lưu trú
     */
    ten?: Co_so_luu_tru_Ten | null;
    /**
     * Địa chỉ
     */
    dia_chi?: Co_so_luu_tru_Dia_chi | null;
    /**
     * Đường dẫn ảnh logo trên trang tổng cục du lịch
     */
    logo?: string | null;
    /**
     * Các thông tin điện thoại
     */
    dien_thoai?: Co_so_luu_tru_Dien_thoai | null;
    /**
     * Email
     */
    email?: string | null;
    /**
     * Website
     */
    website?: string | null;
    /**
     * Cho biết cơ sở lưu trú có ngừng hoạt động không
     */
    disabled?: boolean | null;
    /**
     * Loại hình cơ sở lưu trú
     */
    loai_hinh_id?: IdValue | null;
    /**
     * Thông tin xếp hạng cơ sở lưu trú
     */
    xep_hang_id?: IdValue | null;
    /**
     * Danh sách các dịch vụ
     */
    dich_vu_ids?: Array<IdValue | null | undefined> | null;
    /**
     * Số quyết định
     */
    so_quyet_dinh?: string | null;
    /**
     * Ngày quyết định
     */
    ngay_quyet_dinh?: string | null;
    /**
     * Tổng số phòng
     */
    tong_so_phong?: number | null;
    /**
     * Thông tin giá phòng
     */
    gia?: Co_so_luu_tru_Gia | null;
    /**
     * [Dùng cho tool import dữ liệu] Version của dữ liệu
     */
    __version?: Co_so_luu_tru___version | null;
}

export interface Co_so_luu_tru_Ten {
    /**
     * Tên tiếng Việt
     */
    vi?: string | null;
    /**
     * Tên tiếng Anh
     */
    en?: string | null;
}

export interface Co_so_luu_tru_Dia_chi {
    /**
     * Mã tỉnh/TP
     */
    province_id?: IdValue | null;
    /**
     * Tên tỉnh/TP
     */
    province_name?: string | null;
    /**
     * Mã quận/huyện
     */
    district_id?: IdValue | null;
    /**
     * Tên quận/huyện
     */
    district_name?: string | null;
    /**
     * Mã quận/huyện
     */
    commune_id?: IdValue | null;
    /**
     * Tên quận/huyện
     */
    commune_name?: string | null;
    /**
     * Địa chỉ đầy đủ
     */
    dia_chi?: string | null;
}

export interface Co_so_luu_tru_Dien_thoai {
    /**
     * Mã vùng điện thoại
     */
    ma_vung?: string | null;
    /**
     * Điện thoại cố định
     */
    tel?: string | null;
    /**
     * Số fax
     */
    fax?: string | null;
}

export interface Co_so_luu_tru_Gia {
    /**
     * Giá phòng thấp nhất
     */
    thap_nhat?: number | null;
    /**
     * Giá phòng cao nhất
     */
    cao_nhat?: number | null;
}

export interface Co_so_luu_tru___version {
    /**
     * Mã băm
     */
    hashCode?: number | null;
    /**
     * Mã dữ liệu tại nguồn
     */
    srcId?: string | null;
}

defineAsyncResource<Co_so_luu_tru>({"name":"co_so_luu_tru","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updateOne":{},"updatePartially":{}},"views":{}}, mushroom);

export interface Cslt_xep_hang {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Tên Xếp hạng Cơ sở lưu trú
     */
    ten?: Cslt_xep_hang_Ten | null;
    /**
     * Đường dẫn ảnh icon trên trang tổng cục du lịch
     */
    icon?: string | null;
    /**
     * [Dùng cho tool import dữ liệu] Version của dữ liệu
     */
    __version?: Cslt_xep_hang___version | null;
}

export interface Cslt_xep_hang_Ten {
    /**
     * Tên tiếng Việt
     */
    vi?: string | null;
    /**
     * Tên tiếng Anh
     */
    en?: string | null;
}

export interface Cslt_xep_hang___version {
    /**
     * Mã băm
     */
    hashCode?: number | null;
    /**
     * Mã dữ liệu tại nguồn
     */
    srcId?: string | null;
}

defineAsyncResource<Cslt_xep_hang>({"name":"cslt_xep_hang","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{}},"views":{}}, mushroom);

export interface Cslt_loai_hinh {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Tên Loại hình Cơ sở lưu trú
     */
    ten?: Cslt_loai_hinh_Ten | null;
    /**
     * Đường dẫn ảnh icon trên trang tổng cục du lịch
     */
    icon?: string | null;
    /**
     * Thứ tự sắp xếp
     */
    thu_tu?: number | null;
    /**
     * [Dùng cho tool import dữ liệu] Version của dữ liệu
     */
    __version?: Cslt_loai_hinh___version | null;
}

export interface Cslt_loai_hinh_Ten {
    /**
     * Tên tiếng Việt
     */
    vi?: string | null;
    /**
     * Tên tiếng Anh
     */
    en?: string | null;
}

export interface Cslt_loai_hinh___version {
    /**
     * Mã băm
     */
    hashCode?: number | null;
    /**
     * Mã dữ liệu tại nguồn
     */
    srcId?: string | null;
}

defineAsyncResource<Cslt_loai_hinh>({"name":"cslt_loai_hinh","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{}},"views":{}}, mushroom);

export interface Cslt_dich_vu {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Tên Dịch vụ của Cơ sở lưu trú
     */
    ten?: Cslt_dich_vu_Ten | null;
    /**
     * Đường dẫn ảnh icon trên trang tổng cục du lịch
     */
    icon?: string | null;
    /**
     * Thứ tự sắp xếp
     */
    thu_tu?: number | null;
    /**
     * [Dùng cho tool import dữ liệu] Version của dữ liệu
     */
    __version?: Cslt_dich_vu___version | null;
}

export interface Cslt_dich_vu_Ten {
    /**
     * Tên tiếng Việt
     */
    vi?: string | null;
    /**
     * Tên tiếng Anh
     */
    en?: string | null;
}

export interface Cslt_dich_vu___version {
    /**
     * Mã băm
     */
    hashCode?: number | null;
    /**
     * Mã dữ liệu tại nguồn
     */
    srcId?: string | null;
}

export interface Cslt_dich_vu$ViewsResource_get_allView_Parameters {};
export interface Cslt_dich_vu$ViewsResource {
    views: {
        get_allAsync: MushroomViewFunction<any, Cslt_dich_vu$ViewsResource_get_allView_Parameters>;
    }
}
defineAsyncResource<Cslt_dich_vu>({"name":"cslt_dich_vu","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{}},"views":{"get_all":{"clientCache":true}}}, mushroom);

export interface Diem_den_an_toan {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Thông tin duyệt
     */
    duyet?: Diem_den_an_toan_Duyet | null;
    /**
     * Thông tin hoạt động
     */
    hoat_dong?: Diem_den_an_toan_Hoat_dong | null;
    /**
     * Loại điểm đến
     */
    loai_diem_den?: string | null;
    /**
     * Thông tin chung
     */
    thong_tin_chung?: Diem_den_an_toan_Thong_tin_chung | null;
    /**
     * Dữ liệu khai báo khi đăng ký điểm đến an toàn
     */
    du_lieu_khai_bao?: Diem_den_an_toan_Du_lieu_khai_bao | null;
    /**
     * Tiêu chí khai báo ngày mới nhất
     */
    tieu_chi_khai_bao_ngay?: string | null;
    /**
     * Album ảnh của điểm đến an toàn
     */
    album?: Array<Diem_den_an_toan_Album | null | undefined> | null;
    /**
     * Nội dung hiển thị
     */
    noi_dung_hien_thi?: Array<Diem_den_an_toan_Noi_dung_hien_thi | null | undefined> | null;
    /**
     * Mã người tạo
     */
    nguoi_tao_id?: IdValue | null;
    /**
     * Thời điểm tạo
     */
    thoi_diem_tao?: ISODateValue | null;
    /**
     * Thời điểm cập nhật cuối
     */
    thoi_diem_cap_nhat_cuoi?: ISODateValue | null;
    /**
     * Thông tin merchant
     */
    merchant?: Diem_den_an_toan_Merchant | null;
    /**
     * Thông tin khách hàng thân thiết
     */
    bankClient?: Diem_den_an_toan_BankClient | null;
    /**
     * People Code của người tạo
     */
    peopleCode?: string | null;
    /**
     * Mã bank
     */
    bankCode?: string | null;
    /**
     * Cho biết điểm đến đã đăng ký Audio Guide hay chưa
     */
    isRegisteredAudio?: boolean | null;
    /**
     * Thông tin điểm đến agm
     */
    agmPlace?: Diem_den_an_toan_AgmPlace | null;
    /**
     * Cho biết điểm đến đã tạo tài khoản trên hệ thống quản lý phòng HMS hay chưa
     */
    isRegisteredHms?: boolean | null;
}

export interface Diem_den_an_toan_Duyet {
    /**
     * Cho biết điểm đến đã được duyệt hay chưa
     */
    duoc_duyet?: boolean | null;
    /**
     * Cho biết thời điểm điểm đến đã được duyệt
     */
    thoi_diem_duoc_duyet?: ISODateValue | null;
    /**
     * Mã người duyệt
     */
    nguoi_duyet_id?: IdValue | null;
}

export interface Diem_den_an_toan_Hoat_dong {
    /**
     * Cho biết đơn vị có đang ngừng hoạt động hay không. Mặc định là đang hoạt động
     */
    ngung_hoat_dong?: boolean | null;
    /**
     * Thời điểm ngừng hoạt động/hoạt động trở lại (gần nhất) - Do người dùng SafePlace đổi
     */
    thoi_diem_thay_doi_cuoi?: ISODateValue | null;
    /**
     * Lịch sử các lần thay đổi trạng thái hoạt động
     */
    lich_su_thay_doi?: Array<Diem_den_an_toan_Hoat_dong_Lich_su_thay_doi | null | undefined> | null;
}

export interface Diem_den_an_toan_Hoat_dong_Lich_su_thay_doi {
    /**
     * Cho biết có phải trạng thái thay đổi về ngừng hoạt động hay không
     */
    ngung_hoat_dong?: boolean | null;
    /**
     * Thời điểm thay đổi
     */
    thoi_diem?: ISODateValue | null;
    /**
     * Mã người thay đổi
     */
    nguoi_thay_doi_id?: IdValue | null;
}

export interface Diem_den_an_toan_Thong_tin_chung {
    /**
     * Tên điểm đến an toàn
     */
    ten?: string | null;
    /**
     * Mã ảnh đại diện trên hệ thống survey
     */
    anh?: IdValue | null;
    /**
     * Thông tin giấy tờ định danh điểm đến
     */
    giay_to?: Diem_den_an_toan_Thong_tin_chung_Giay_to | null;
    /**
     * Thông tin địa chỉ
     */
    dia_chi?: Diem_den_an_toan_Thong_tin_chung_Dia_chi | null;
    /**
     * Thông tin người đại diện
     */
    nguoi_dai_dien?: Diem_den_an_toan_Thong_tin_chung_Nguoi_dai_dien | null;
    /**
     * Nguồn đăng ký
     */
    nguon?: string | null;
    /**
     * Cho biết điểm đến này có được duyệt trên trang vàng hay không
     */
    trang_vang?: boolean | null;
    /**
     * Loại hình ưu đãi
     */
    loai_hinh_uu_dai?: string | null;
    /**
     * Giá trị ưu đãi
     */
    gia_tri_uu_dai?: number | null;
    /**
     * Loại hình ưu đãi cư dân
     */
    loai_hinh_uu_dai_cd?: string | null;
    /**
     * Giá trị ưu đãi cư dân
     */
    gia_tri_uu_dai_cd?: number | null;
    /**
     * Xếp loại an toàn ngày. 1: An toàn; 2: Có nguy cơ; 3: Không an toàn; NULL: chưa khai báo
     */
    todayStatus?: number | null;
    /**
     * Các thông tin cho hướng dẫn viên
     */
    huong_dan_vien?: Diem_den_an_toan_Thong_tin_chung_Huong_dan_vien | null;
}

export interface Diem_den_an_toan_Thong_tin_chung_Giay_to {
    /**
     * Mã số thuế/Mã số doanh nghiệp
     */
    so_giay_to?: string | null;
    /**
     * Nơi cấp
     */
    noi_cap?: string | null;
    /**
     * Ngày cấp
     */
    ngay_cap?: ISODateValue | null;
    /**
     * Danh sách mã ảnh scan
     */
    scan?: Array<IdValue | null | undefined> | null;
    /**
     * Địa chỉ trên đăng ký kinh doanh
     */
    dia_chi?: string | null;
}

export interface Diem_den_an_toan_Thong_tin_chung_Dia_chi {
    /**
     * Quốc gia
     */
    quoc_gia?: string | null;
    /**
     * Mã quốc tịch
     */
    quoc_tich_id?: IdValue | null;
    /**
     * Tên tỉnh
     */
    tinh?: string | null;
    /**
     * Id tỉnh
     */
    tinh_id?: IdValue | null;
    /**
     * Mã tỉnh
     */
    ma_tinh?: string | null;
    /**
     * Tên huyện
     */
    huyen?: string | null;
    /**
     * Id huyện
     */
    huyen_id?: IdValue | null;
    /**
     * Mã huyện
     */
    ma_huyen?: string | null;
    /**
     * Tên xã
     */
    xa?: string | null;
    /**
     * Id xã
     */
    xa_id?: IdValue | null;
    /**
     * Mã xã
     */
    ma_xa?: string | null;
    /**
     * Địa chỉ giao dịch
     */
    dia_chi?: string | null;
    /**
     * Kinh độ
     */
    kinh_do?: number | null;
    /**
     * Vĩ độ
     */
    vi_do?: number | null;
}

export interface Diem_den_an_toan_Thong_tin_chung_Nguoi_dai_dien {
    /**
     * Họ và tên
     */
    ho_ten?: string | null;
    /**
     * Chức vụ
     */
    chuc_vu?: string | null;
    /**
     * Ngày sinh
     */
    ngay_sinh?: ISODateValue | null;
    /**
     * Số CMT/ Căn cước/ Hộ chiếu
     */
    so_giay_to?: string | null;
    /**
     * Giới tính: 1 - Nữ, 2 - Nam, 3 - Chưa có thông tin, 4 - Khác
     */
    gioi_tinh?: number | null;
    /**
     * Địa chỉ
     */
    dia_chi?: string | null;
    /**
     * Điện thoại
     */
    dien_thoai?: string | null;
    /**
     * Email
     */
    email?: string | null;
    /**
     * Thông tin hành chính - số điện thoại
     */
    tthc_dien_thoai?: string | null;
    /**
     * Thông tin hành chính - email
     */
    tthc_email?: string | null;
    /**
     * Thông tin hành chính - ngày cấp CMND/CCCD
     */
    tthc_cmnd_date?: ISODateValue | null;
    /**
     * Thông tin hành chính - số CMND/CCCD
     */
    tthc_cmnd_number?: string | null;
    /**
     * Thông tin hành chính - nơi cấp CMND/CCCD
     */
    tthc_cmnd_place?: string | null;
    /**
     * Thông tin hành chính - địa chỉ thường trú
     */
    tthc_cmnd_domicile?: string | null;
    /**
     * Thông tin hành chính - địa chỉ nơi ở hiện tại
     */
    tthc_cmnd_resident?: string | null;
    /**
     * Thông tin hành chính - chữ ký
     */
    tthc_cmnd_signature?: string | null;
}

export interface Diem_den_an_toan_Thong_tin_chung_Huong_dan_vien {
    /**
     * Thông tin ưu đãi
     */
    uu_dai?: Diem_den_an_toan_Thong_tin_chung_Huong_dan_vien_Uu_dai | null;
    /**
     * Danh sách người nhận chiết khấu
     */
    discount_recipient?: Array<Diem_den_an_toan_Thong_tin_chung_Huong_dan_vien_Discount_recipient | null | undefined> | null;
}

export interface Diem_den_an_toan_Thong_tin_chung_Huong_dan_vien_Uu_dai {
    /**
     * Loại hình ưu đãi
     */
    loai_hinh_uu_dai?: string | null;
    /**
     * Giá trị ưu đãi
     */
    gia_tri_uu_dai?: number | null;
}

export interface Diem_den_an_toan_Thong_tin_chung_Huong_dan_vien_Discount_recipient {
    /**
     * Mã người nhận chiết khấu
     */
    people_code?: string | null;
    /**
     * Tên người nhận chiết khấu
     */
    full_name?: string | null;
    /**
     * Mã người quản lý cấp trên
     */
    superior_people_code?: string | null;
    /**
     * Tỷ lệ khấu trừ trực tiếp
     */
    direct_deduction_ratio?: number | null;
    /**
     * Tỷ lệ khấu trừ gián tiếp
     */
    indirect_deduction_ratio?: number | null;
    /**
     * Thời gian thêm thông tin người nhận chiết khấu
     */
    date_insert?: ISODateValue | null;
    /**
     * Người được nhận chiết khấu
     */
    selected?: boolean | null;
}

export interface Diem_den_an_toan_Du_lieu_khai_bao {
    /**
     * account của điểm đến
     */
    user_account?: string | null;
    /**
     * Số điện thoại người quản lý
     */
    user_dien_thoai?: string | null;
}

export interface Diem_den_an_toan_Album {
    /**
     * Ngôn ngữ hiển thị
     */
    ngon_ngu?: string | null;
    /**
     * Id của ảnh hiển thị
     */
    anh_id?: IdValue | null;
    /**
     * Loại ảnh hoặc video
     */
    type?: string | null;
    /**
     * Tiêu đề của ảnh
     */
    tieu_de?: string | null;
}

export interface Diem_den_an_toan_Noi_dung_hien_thi {
    /**
     * Ngôn ngữ hiển thị
     */
    ngon_ngu?: string | null;
    /**
     * Giới thiệu thông tin
     */
    gioi_thieu?: string | null;
    /**
     * Id của ảnh hiển thị
     */
    anh_id?: IdValue | null;
    /**
     * Nội dung hiển thị
     */
    noi_dung?: string | null;
}

export interface Diem_den_an_toan_Merchant {
    /**
     * Callback Url của VpsMerchantCallback
     */
    callbackUrl?: string | null;
    /**
     * Cho biết merchant có ở trạng thái đang xử lý hay không
     */
    processingStatus?: boolean | null;
    /**
     * Cho biết merchant có hiệu lực hay không?
     */
    enabled?: boolean | null;
    /**
     * Merchant Code
     */
    merchantCode?: string | null;
    /**
     * Client Code
     */
    clientCode?: string | null;
    /**
     * SecureKey
     */
    secureKey?: string | null;
    /**
     * Loại hợp đồng đã ký. (none: chưa ký, cert: đã ký chứng chỉ, contact: đã ký hợp đồng)
     */
    signed?: string | null;
}

export interface Diem_den_an_toan_BankClient {
    /**
     * Id của bạn
     */
    id?: string | null;
    /**
     * Key của bạn
     */
    key?: string | null;
    /**
     * Cho biết ký hợp đồng hay chưa
     */
    signed?: boolean | null;
}

export interface Diem_den_an_toan_AgmPlace {
    /**
     * Mã điểm đến agm
     */
    placeCode?: string | null;
    /**
     * Tên điểm đến agm
     */
    placeName?: string | null;
    /**
     * Danh sách thuyết minh
     */
    agmGuide?: Array<Diem_den_an_toan_AgmPlace_AgmGuide | null | undefined> | null;
    /**
     * Danh sách ảnh thuyết minh
     */
    guideAlbum?: Array<Diem_den_an_toan_AgmPlace_GuideAlbum | null | undefined> | null;
}

export interface Diem_den_an_toan_AgmPlace_AgmGuide {
    /**
     * Mã thuyết minh
     */
    guideCode?: string | null;
    /**
     * Tên thuyết minh
     */
    guideName?: string | null;
    /**
     * Id ảnh thuyết minh
     */
    imageId?: IdValue | null;
    /**
     * Đường dẫn ảnh
     */
    imageUrl?: string | null;
}

export interface Diem_den_an_toan_AgmPlace_GuideAlbum {
    /**
     * Mã thuyết minh
     */
    guideId?: string | null;
    /**
     * Mã thuyết minh
     */
    guideCode?: string | null;
    /**
     * Album ảnh thuyết minh
     */
    album?: Array<Diem_den_an_toan_AgmPlace_GuideAlbum_Album | null | undefined> | null;
}

export interface Diem_den_an_toan_AgmPlace_GuideAlbum_Album {
    /**
     * Id ảnh mushroom_file
     */
    imageId?: IdValue | null;
    /**
     * Link ảnh server fss
     */
    fssImageUrl?: string | null;
    /**
     * Id ảnh server fss
     */
    fssImageId?: string | null;
}

export interface Diem_den_an_toan$CustomMethodResource {
    import_ddat_excelAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    searchAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    searchSMSAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    update_tinh_idAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    update_uu_daiAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    update_album_imageAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    update_bankCodeAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
export interface Diem_den_an_toan$ViewsResource_search_ddatView_Parameters {
    /**
     * Điểm đến là merchant hay không
     */
    is_merchant?: boolean | null;
    /**
     * Số sao
     */
    min_star?: number | null;
    /**
     * Mảng tên điểm đến an toàn đã cắt từng chữ không dấu
     */
    words?: string[] | null;
    /**
     * Loại điểm đến
     */
    loai_diem_den?: string | null;
    /**
     * Danh sách loại điểm đến
     */
    ds_loai_diem_den?: string[] | null;
    /**
     * Danh sách các trạng thái ngày hôm nay. Nếu không có nghĩa là lấy về tất cả
     */
    todayStatus?: number[] | null;
    /**
     * Tỉnh Id
     */
    tinh_id?: IdValue | null;
    /**
     * Danh sách các tỉnh muốn lọc
     */
    tinh_ids?: IdValue[] | null;
    /**
     * Tên tỉnh
     */
    tinh?: string | null;
    /**
     * Loại hình ưu đãi
     */
    loai_hinh_uu_dai?: string | null;
    /**
     * Giá trị ưu đãi (mức min)
     */
    gia_tri_uu_dai_min?: number | null;
    /**
     * Giá trị ưu đãi (mức max)
     */
    gia_tri_uu_dai_max?: number | null;
    /**
     * Loại hình ưu đãi cho hướng dẫn viên
     */
    hdv_loai_hinh_uu_dai?: string | null;
    /**
     * Giá trị ưu đãi (mức min) cho hướng dẫn viên
     */
    hdv_gia_tri_uu_dai_min?: number | null;
    /**
     * Giá trị ưu đãi (mức max) cho hướng dẫn viên
     */
    hdv_gia_tri_uu_dai_max?: number | null;
    /**
     * Tên trường sắp xếp
     */
    sortField?: string | null;
    /**
     * Loại sắp xếp
     */
    sortType?: number | null;
    /**
     * Skip
     */
    skip?: number | null;
    /**
     * Limit
     */
    limit?: number | null;
};
export interface Diem_den_an_toan$ViewsResource_total_search_ddatView_Parameters {
    /**
     * Số sao
     */
    min_star?: number | null;
    /**
     * Mảng tên điểm đến an toàn đã cắt từng chữ không dấu
     */
    words?: string[] | null;
    /**
     * Loại điểm đến
     */
    loai_diem_den?: string | null;
    /**
     * Danh sách loại điểm đến
     */
    ds_loai_diem_den?: string[] | null;
    /**
     * Danh sách các trạng thái ngày hôm nay. Nếu không có nghĩa là lấy về tất cả
     */
    todayStatus?: number[] | null;
    /**
     * Tỉnh Id
     */
    tinh_id?: IdValue | null;
    /**
     * Danh sách các tỉnh muốn lọc
     */
    tinh_ids?: IdValue[] | null;
    /**
     * Tên tỉnh
     */
    tinh?: string | null;
    /**
     * Loại hình ưu đãi
     */
    loai_hinh_uu_dai?: string | null;
    /**
     * Giá trị ưu đãi (mức min)
     */
    gia_tri_uu_dai_min?: number | null;
    /**
     * Giá trị ưu đãi (mức max)
     */
    gia_tri_uu_dai_max?: number | null;
    /**
     * Loại hình ưu đãi cho hướng dẫn viên
     */
    hdv_loai_hinh_uu_dai?: string | null;
    /**
     * Giá trị ưu đãi (mức min) cho hướng dẫn viên
     */
    hdv_gia_tri_uu_dai_min?: number | null;
    /**
     * Giá trị ưu đãi (mức max) cho hướng dẫn viên
     */
    hdv_gia_tri_uu_dai_max?: number | null;
};
export interface Diem_den_an_toan$ViewsResource_total_ddat_to_now_group_by_provinceView_Parameters {};
export interface Diem_den_an_toan$ViewsResource_total_ddat_by_day_group_by_provinceView_Parameters {
    /**
     * Từ ngày
     */
    from: ISODateValue;
    /**
     * Từ ngày
     */
    to: ISODateValue;
};
export interface Diem_den_an_toan$ViewsResource_total_ddat_to_now_group_by_typeView_Parameters {};
export interface Diem_den_an_toan$ViewsResource_total_ddat_by_day_group_by_typeView_Parameters {
    /**
     * Từ ngày
     */
    from: ISODateValue;
    /**
     * Từ ngày
     */
    to: ISODateValue;
};
export interface Diem_den_an_toan$ViewsResource_total_ddat_group_by_dayView_Parameters {
    /**
     * Từ ngày
     */
    from: ISODateValue;
    /**
     * Từ ngày
     */
    to: ISODateValue;
};
export interface Diem_den_an_toan$ViewsResource_declared_calendarView_SafePlaceParameters {
    /**
     * Tài khoản điểm đến an toàn (bắt đầu bởi dd)
     */
    dd_account: string;
    /**
     * Từ ngày
     */
    from?: ISODateValue | null;
    /**
     * Đến ngày (tính vào đầu ngày hôm sau)
     */
    to?: ISODateValue | null;
};
export interface Diem_den_an_toan$ViewsResource_declared_status_calendarView_SafePlaceParameters {
    /**
     * Tài khoản điểm đến an toàn (bắt đầu bởi dd)
     */
    dd_account: string;
    /**
     * Từ ngày
     */
    from?: ISODateValue | null;
    /**
     * Đến ngày (tính vào đầu ngày hôm sau)
     */
    to?: ISODateValue | null;
};
export interface Diem_den_an_toan$ViewsResource_ddat_not_linked_shb_merchant_tokenView_OfficerParameters {
    /**
     * Mã tài khoản DD hoặc tên điểm đến cần tìm
     */
    keyword?: string | null;
    /**
     * Số lượng bản ghi bỏ qua ở đầu danh sách
     */
    offset?: number | null;
    /**
     * Số lượng tối đa bản ghi trả về
     */
    limit?: number | null;
};
export interface Diem_den_an_toan$ViewsResource_search_smsView_OfficerParameters {
    /**
     * Số điện thoại cần tìm
     */
    sdt: string;
    /**
     * Loại tìm kiếm: all, password hoặc otp
     */
    type: string;
    /**
     * Số lượng bản ghi bỏ qua ở đầu danh sách
     */
    skip?: number | null;
    /**
     * Số lượng tối đa bản ghi trả về
     */
    limit?: number | null;
};
export interface Diem_den_an_toan$ViewsResource {
    views: {
        search_ddatAsync: MushroomViewFunction<any, Diem_den_an_toan$ViewsResource_search_ddatView_Parameters>;
        total_search_ddatAsync: MushroomViewFunction<any, Diem_den_an_toan$ViewsResource_total_search_ddatView_Parameters>;
        total_ddat_to_now_group_by_provinceAsync: MushroomViewFunction<any, Diem_den_an_toan$ViewsResource_total_ddat_to_now_group_by_provinceView_Parameters>;
        total_ddat_by_day_group_by_provinceAsync: MushroomViewFunction<any, Diem_den_an_toan$ViewsResource_total_ddat_by_day_group_by_provinceView_Parameters>;
        total_ddat_to_now_group_by_typeAsync: MushroomViewFunction<any, Diem_den_an_toan$ViewsResource_total_ddat_to_now_group_by_typeView_Parameters>;
        total_ddat_by_day_group_by_typeAsync: MushroomViewFunction<any, Diem_den_an_toan$ViewsResource_total_ddat_by_day_group_by_typeView_Parameters>;
        total_ddat_group_by_dayAsync: MushroomViewFunction<any, Diem_den_an_toan$ViewsResource_total_ddat_group_by_dayView_Parameters>;
        declared_calendarAsync: MushroomViewFunction<any, Diem_den_an_toan$ViewsResource_declared_calendarView_SafePlaceParameters>;
        declared_status_calendarAsync: MushroomViewFunction<any, Diem_den_an_toan$ViewsResource_declared_status_calendarView_SafePlaceParameters>;
        ddat_not_linked_shb_merchant_tokenAsync: MushroomViewFunction<any, Diem_den_an_toan$ViewsResource_ddat_not_linked_shb_merchant_tokenView_OfficerParameters>;
        search_smsAsync: MushroomViewFunction<any, Diem_den_an_toan$ViewsResource_search_smsView_OfficerParameters>;
    }
}
defineAsyncResource<Diem_den_an_toan>({"name":"diem_den_an_toan","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"deleteOne":{},"_raw_http_method_import_ddat_excel":{},"_raw_http_method_search":{},"_raw_http_method_searchSMS":{},"_raw_http_method_update_tinh_id":{},"_raw_http_method_update_uu_dai":{},"_raw_http_method_update_album_image":{},"_raw_http_method_update_bankCode":{}},"views":{"search_ddat":{"clientCache":true},"total_search_ddat":{"clientCache":true},"total_ddat_to_now_group_by_province":{"clientCache":true},"total_ddat_by_day_group_by_province":{"clientCache":true},"total_ddat_to_now_group_by_type":{"clientCache":true},"total_ddat_by_day_group_by_type":{"clientCache":true},"total_ddat_group_by_day":{"clientCache":true},"declared_calendar":{"clientCache":true},"declared_status_calendar":{"clientCache":true},"ddat_not_linked_shb_merchant_token":{"clientCache":true},"search_sms":{"clientCache":true}}}, mushroom);

export interface Diem_den_an_toan_check_in {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã người đến checkin
     */
    nguoi_check_in_id?: IdValue | null;
    /**
     * Mã điểm đến an toàn
     */
    diem_den_an_toan_id?: IdValue | null;
    /**
     * Thời điểm check in
     */
    thoi_diem_check_in?: ISODateValue | null;
    /**
     * Mã người tạo
     */
    nguoi_tao_id?: IdValue | null;
    /**
     * Đối tượng thực hiện checkin
     */
    doi_tuong_thuc_hien?: string | null;
    /**
     * Nguồn phát sinh
     */
    nguon?: string | null;
    /**
     * Thông tin đánh giá
     */
    danh_gia?: Diem_den_an_toan_check_in_Danh_gia | null;
    /**
     * Mã đặt phòng
     */
    booking_no?: string | null;
}

export interface Diem_den_an_toan_check_in_Danh_gia {
    /**
     * Số sao đánh giá của người dùng
     */
    gia_tri?: number | null;
    /**
     * Nội dung đánh giá
     */
    noi_dung?: string | null;
    /**
     * Danh sách các đánh giá thành phần
     */
    thanh_phan?: Array<Diem_den_an_toan_check_in_Danh_gia_Thanh_phan | null | undefined> | null;
    /**
     * Thời điểm tạo
     */
    thoi_diem_tao?: ISODateValue | null;
    /**
     * Lưu thông tin thêm của từng đánh giá
     */
    thong_tin_them?: Diem_den_an_toan_check_in_Danh_gia_Thong_tin_them | null;
}

export interface Diem_den_an_toan_check_in_Danh_gia_Thanh_phan {
    /**
     * Mã nhóm thành phần
     */
    nhom_id?: IdValue | null;
    /**
     * Giá trị đánh giá thành phần
     */
    gia_tri?: number | null;
}

export interface Diem_den_an_toan_check_in_Danh_gia_Thong_tin_them {
    /**
     * Thong tin kpi
     */
    kpis?: Array<string | null | undefined> | null;
}

export interface Diem_den_an_toan_check_in$CustomMethodResource {
    getKhachDuLichAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
export interface Diem_den_an_toan_check_in$ViewsResource_search_nguoi_check_inView_SafePlaceParameters {
    /**
     * Tên người check in
     */
    name?: string | null;
    /**
     * Điểm đến an toàn id
     */
    diem_den_an_toan_id: IdValue;
};
export interface Diem_den_an_toan_check_in$ViewsResource_search_nguoi_check_inView_OfficerParameters {
    /**
     * Tên người check in
     */
    name?: string | null;
    /**
     * Điểm đến an toàn id
     */
    diem_den_an_toan_id?: IdValue | null;
};
export interface Diem_den_an_toan_check_in$ViewsResource {
    views: {
        search_nguoi_check_inAsync: MushroomViewFunction<any, Diem_den_an_toan_check_in$ViewsResource_search_nguoi_check_inView_SafePlaceParameters> | MushroomViewFunction<any, Diem_den_an_toan_check_in$ViewsResource_search_nguoi_check_inView_OfficerParameters>;
    }
}
defineAsyncResource<Diem_den_an_toan_check_in>({"name":"diem_den_an_toan_check_in","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"_raw_http_method_getKhachDuLich":{}},"views":{"search_nguoi_check_in":{"clientCache":true}}}, mushroom);

export interface Ddat_khai_bao_ngay {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã điển đến an toàn
     */
    ddat_id?: IdValue | null;
    /**
     * Mã người quản lý điểm đến an toàn
     */
    user_id?: IdValue | null;
    /**
     * Dữ liệu khai báo
     */
    du_lieu_khai_bao?: Ddat_khai_bao_ngay_Du_lieu_khai_bao | null;
    /**
     * Mã survey token
     */
    token?: string | null;
    /**
     * Thời điểm tạo
     */
    thoi_diem_tao?: ISODateValue | null;
}

export interface Ddat_khai_bao_ngay_Du_lieu_khai_bao {
}

defineAsyncResource<Ddat_khai_bao_ngay>({"name":"ddat_khai_bao_ngay","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true}},"views":{}}, mushroom);

export interface Ddat_cap_nhat_thong_tin {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã điển đến an toàn
     */
    ddat_id?: IdValue | null;
    /**
     * Mã người quản lý điểm đến an toàn
     */
    user_id?: IdValue | null;
    /**
     * Dữ liệu khai báo
     */
    du_lieu_khai_bao?: Ddat_cap_nhat_thong_tin_Du_lieu_khai_bao | null;
    /**
     * Mã survey token
     */
    token?: string | null;
    /**
     * Thời điểm tạo
     */
    thoi_diem_tao?: ISODateValue | null;
}

export interface Ddat_cap_nhat_thong_tin_Du_lieu_khai_bao {
}

defineAsyncResource<Ddat_cap_nhat_thong_tin>({"name":"ddat_cap_nhat_thong_tin","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true}},"views":{}}, mushroom);

export interface Canh_bao_hang_ngay {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Đối tượng nhận cảnh báo, nhận một trong hai giá trị sau: kdl, hdv
     */
    doi_tuong?: string | null;
    /**
     * Cho biết cảnh báo có còn hiệu lực hay không
     */
    co_hieu_luc?: boolean | null;
    /**
     * Nội dung cảnh báo
     */
    noi_dung?: Canh_bao_hang_ngay_Noi_dung | null;
    /**
     * Thứ tự hiển thị
     */
    thu_tu?: number | null;
    /**
     * Ngày có hiệu lực, nếu không có nghĩa là thỏa mãn
     */
    tu_ngay?: ISODateValue | null;
    /**
     * Ngày hết hiệu lực, nếu không có nghĩa không có hạn
     */
    den_ngay?: ISODateValue | null;
    file_dinh_kem_ids?: Canh_bao_hang_ngay_File_dinh_kem_ids | null;
}

export interface Canh_bao_hang_ngay_Noi_dung {
    /**
     * Nội dung cảnh báo tiếng Việt
     */
    vi?: string | null;
    /**
     * Nội dung cảnh báo tiếng Anh
     */
    en?: string | null;
}

export interface Canh_bao_hang_ngay_File_dinh_kem_ids {
    /**
     * Mảng các file đính kèm - Tiếng Việt
     */
    vi?: Array<IdValue | null | undefined> | null;
    /**
     * Mảng các file đính kèm - Tiếng Anh
     */
    en?: Array<IdValue | null | undefined> | null;
}

defineAsyncResource<Canh_bao_hang_ngay>({"name":"canh_bao_hang_ngay","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{}},"views":{}}, mushroom);

export interface Chuong_trinh {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã chương trình
     */
    ma?: string | null;
    /**
     * Cho biết chương trình có hiệu lực hay không
     */
    co_hieu_luc?: boolean | null;
    /**
     * Tên chương trình
     */
    ten?: Chuong_trinh_Ten | null;
    /**
     * Nội dung chương trình
     */
    noi_dung?: Chuong_trinh_Noi_dung | null;
    /**
     * Thời điểm bắt đầu của chương trình
     */
    bat_dau?: ISODateValue | null;
    /**
     * Thời điểm kết thúc của chương trình
     */
    ket_thuc?: ISODateValue | null;
    /**
     * Thời điểm tạo
     */
    thoi_diem_tao?: ISODateValue | null;
    /**
     * Mã người tạo
     */
    nguoi_tao_id?: IdValue | null;
    /**
     * Áp dụng cho đối tượng nào
     */
    ap_dung?: Array<Chuong_trinh_Ap_dung | null | undefined> | null;
}

export interface Chuong_trinh_Ten {
    /**
     * Tên chương trình tiếng Việt
     */
    vi?: string | null;
    /**
     * Tên chương trình tiếng Anh
     */
    en?: string | null;
}

export interface Chuong_trinh_Noi_dung {
    /**
     * Nội dung chương trình tiếng Việt
     */
    vi?: string | null;
    /**
     * Nội dung chương trình tiếng Anh
     */
    en?: string | null;
}

export interface Chuong_trinh_Ap_dung {
    /**
     * Loại đối tượng với các giá trị hợp lệ: tour_guide|customer|place
     */
    loai_doi_tuong?: string | null;
    /**
     * Link survey
     */
    link_survey?: string | null;
    /**
     * Link survey, nếu không có lấy giá trị của link_survey
     */
    link_survey_vi?: string | null;
    /**
     * Link survey, nếu không có lấy giá trị của link_survey
     */
    link_survey_en?: string | null;
    /**
     * App code của survey
     */
    survey_app_code?: string | null;
    /**
     * Env của survey
     */
    survey_env?: string | null;
}

defineAsyncResource<Chuong_trinh>({"name":"chuong_trinh","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{}},"views":{}}, mushroom);

export interface Dang_ky_chuong_trinh {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Loại đối tượng với các giá trị hợp lệ: tour_guide|customer|place
     */
    loai_doi_tuong?: string | null;
    /**
     * Mã người dùng
     */
    user_id?: IdValue | null;
    /**
     * Mã người dùng
     */
    chuong_trinh_id?: IdValue | null;
    /**
     * Dữ liệu khai báo khi đăng ký chương trình
     */
    du_lieu_khai_bao?: Dang_ky_chuong_trinh_Du_lieu_khai_bao | null;
    /**
     * Thời điểm tạo
     */
    thoi_diem_tao?: ISODateValue | null;
    /**
     * Thời điểm cập nhật
     */
    thoi_diem_cap_nhat?: ISODateValue | null;
    /**
     * Mã người tạo
     */
    nguoi_tao_id?: IdValue | null;
    /**
     * đã duyệt huy hiệu
     */
    da_duyet?: boolean | null;
}

export interface Dang_ky_chuong_trinh_Du_lieu_khai_bao {
}

export interface Dang_ky_chuong_trinh$CustomMethodResource {
    duyet_thanh_tich_huy_hieuAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<Dang_ky_chuong_trinh>({"name":"dang_ky_chuong_trinh","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"deleteOne":{},"_raw_http_method_duyet_thanh_tich_huy_hieu":{}},"views":{}}, mushroom);

export interface Huy_hieu {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã huy hiệu
     */
    ma?: string | null;
    /**
     * Cho biết huy hiệu có hiệu lực hay không
     */
    co_hieu_luc?: boolean | null;
    /**
     * Tên huy hiệu
     */
    ten?: Huy_hieu_Ten | null;
    /**
     * Icon đại diện của huy hiệu
     */
    anh?: IdValue | null;
    /**
     * Thời điểm tạo
     */
    thoi_diem_tao?: ISODateValue | null;
    /**
     * Mã người tạo
     */
    nguoi_tao_id?: IdValue | null;
}

export interface Huy_hieu_Ten {
    /**
     * Tên huy hiệu tiếng Việt
     */
    vi?: string | null;
    /**
     * Tên huy hiệu tiếng Anh
     */
    en?: string | null;
}

defineAsyncResource<Huy_hieu>({"name":"huy_hieu","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{}},"views":{}}, mushroom);

export interface Thanh_tich_huy_hieu {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã người dùng được cấp huy hiệu
     */
    user_id?: IdValue | null;
    huy_hieu_id?: IdValue | null;
    dang_ky_chuong_trinh_id?: IdValue | null;
    /**
     * Ghi chú
     */
    ghi_chu?: string | null;
    /**
     * Thời điểm nhận được huy hiệu
     */
    thoi_diem_tao?: ISODateValue | null;
    /**
     * Mã cấp huy hiệu
     */
    nguoi_cap_id?: IdValue | null;
}

export interface Thanh_tich_huy_hieu$CustomMethodResource {
    view_huy_hieu_hdvAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<Thanh_tich_huy_hieu>({"name":"thanh_tich_huy_hieu","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"deleteOne":{},"updatePartially":{},"_raw_http_method_view_huy_hieu_hdv":{}},"views":{}}, mushroom);

export interface Location {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã người gửi thông tin vị trí
     */
    user_id?: IdValue | null;
    /**
     * Loại thông tin vị trí: kdl - hướng dẫn viên yêu cầu vị trí khách du lịch, hdv - hướng dẫn viên gửi thông tin vị trí của mình
     */
    type?: string | null;
    /**
     * Mã người yêu cầu thông tin vị trí
     */
    request_id?: IdValue | null;
    /**
     * Thông tin tọa độ (theo chuẩn GeoJSON)
     */
    loc?: Location_Loc | null;
    /**
     * Thời điểm tạo
     */
    created_time?: ISODateValue | null;
}

export interface Location_Loc {
    /**
     * Fix cứng là Point
     */
    type?: string | null;
    /**
     * Thông tin tọa độ
     */
    coordinates?: Array<number | null | undefined> | null;
}

defineAsyncResource<Location>({"name":"location","actions":{"findMany":{"clientCache":true,"includeTotal":true},"createOne":{}},"views":{}}, mushroom);

export interface Vung_dich {
    /**
     * Mã tự tăng
     */
    id?: IdValue | null;
    /**
     * Loại vùng dịch là 1 trong 4 giá trị TINH,HUYEN,XA,DIADIEM
     */
    type?: string | null;
    /**
     * Tỉnh id
     */
    province_id?: IdValue | null;
    /**
     * Mã tỉnh
     */
    province_code?: string | null;
    /**
     * Huyện id
     */
    district_id?: IdValue | null;
    /**
     * Mã huyện
     */
    district_code?: string | null;
    /**
     * Xã id
     */
    commune_id?: IdValue | null;
    /**
     * Mã xã
     */
    commune_code?: string | null;
    /**
     * Địa chỉ cụ thể
     */
    address?: string | null;
    /**
     * Kinh độ (longitude)
     */
    lng?: number | null;
    /**
     * Vĩ độ (latitude)
     */
    lat?: number | null;
    /**
     * Cấp độ (đang dịch/dịch đang giảm/không có người nhiễm dưới 30 ngày/dưới 60 ngày/dưới 90 ngày)
     */
    level?: string | null;
    /**
     * Trạng thái dịch
     */
    epidemic_status?: string | null;
    /**
     * Tổng số nhiễm bệnh
     */
    number_of_infections?: number | null;
    /**
     * Tổng số phục hồi
     */
    number_of_recovery?: number | null;
    /**
     * Tổng số tử vong
     */
    number_of_mortality?: number | null;
    /**
     * Thời gian tạo
     */
    created_time?: ISODateValue | null;
    /**
     * Mã người dùng
     */
    user_id?: IdValue | null;
}

defineAsyncResource<Vung_dich>({"name":"vung_dich","actions":{"findById":{"clientCache":true},"findMany":{"clientCache":true,"includeTotal":true},"createOne":{},"updatePartially":{},"deleteOne":{}},"views":{}}, mushroom);

export interface Log_update_vung_dich {
    /**
     * Id tự tăng
     */
    id?: IdValue | null;
    /**
     * Tỉnh id
     */
    province_id?: IdValue | null;
    /**
     * Mã tỉnh
     */
    province_code?: string | null;
    /**
     * Thời điểm thay đổi
     */
    time?: ISODateValue | null;
    /**
     * Trạng thái dịch trước khi thay đổi
     */
    first_epidemic_status?: string | null;
    /**
     * Trạng thái dịch sau khi thay đổi
     */
    epidemic_status?: string | null;
}

defineAsyncResource<Log_update_vung_dich>({"name":"log_update_vung_dich","actions":{"findMany":{"clientCache":true,"includeTotal":true}},"views":{}}, mushroom);

export interface Quang_cao {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Tên banner quảng cáo
     */
    ten_banner?: string | null;
    /**
     * Mã ngôn ngữ
     */
    ngon_ngu?: string | null;
    /**
     * Màn hình hiển thị. home - hiển thị ở màn hình home. login - hiển thị ở màn hình login
     */
    vi_tri?: string | null;
    /**
     * Thứ tự hiển thị
     */
    thu_tu?: number | null;
    /**
     * Ảnh quảng cáo hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Đường dẫn quảng cáo
     */
    link_quang_cao?: string | null;
    /**
     * Cho phép hiển thị
     */
    hien_thi?: boolean | null;
    /**
     * Id của người tạo quảng cáo
     */
    nguoi_tao?: IdValue | null;
    /**
     * Thời điểm tạo
     */
    thoi_diem_tao?: ISODateValue | null;
    /**
     * Id của người sửa
     */
    nguoi_sua?: IdValue | null;
    /**
     * Thời điểm sửa cuối
     */
    thoi_diem_sua?: ISODateValue | null;
}

defineAsyncResource<Quang_cao>({"name":"quang_cao","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"deleteOne":{}},"views":{}}, mushroom);

export interface Chat {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Nội dung tin nhắn
     */
    msg?: string | null;
    /**
     * File đính kèm
     */
    file?: Chat_File | null;
    /**
     * Mã người gửi
     */
    from?: IdValue | null;
    /**
     * Mã người/room nhận
     */
    to?: IdValue | null;
    /**
     * Loại đích nhận tin nhắn, nhận một trong 2 giá trị: R - room, U - user
     */
    des?: string | null;
    /**
     * Thời điểm gửi
     */
    time?: ISODateValue | null;
    /**
     * Cho biết tin nhắn có bị sửa hay không
     */
    edited?: boolean | null;
    /**
     * Thời điểm sửa cuối cùng
     */
    edited_time?: ISODateValue | null;
    /**
     * Đánh dấu tin nhắn đã đọc hay chưa
     */
    is_read?: boolean | null;
}

export interface Chat_File {
    /**
     * Mã file
     */
    id?: IdValue | null;
    /**
     * Tên file
     */
    name?: string | null;
    /**
     * Độ lớn của file
     */
    size?: number | null;
}

export interface Chat$ViewsResource_getLatestMessagesView_UserParameters {};
export interface Chat$ViewsResource_getLatestRoomMessagesView_UserParameters {};
export interface Chat$ViewsResource {
    views: {
        getLatestMessagesAsync: MushroomViewFunction<any, Chat$ViewsResource_getLatestMessagesView_UserParameters>;
        getLatestRoomMessagesAsync: MushroomViewFunction<any, Chat$ViewsResource_getLatestRoomMessagesView_UserParameters>;
    }
}
defineAsyncResource<Chat>({"name":"chat","actions":{"findMany":{"includeTotal":true},"updatePartially":{},"updateOne":{},"deleteOne":{}},"views":{"getLatestMessages":{"clientCache":true},"getLatestRoomMessages":{"clientCache":true}}}, mushroom);

export interface Notification_log {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã loại thông báo. Chi tiết xem tại: https://docs.google.com/document/d/1y_X4gFrT-Ws2cdziM00t2cE_6HJfG1JmD_uhgeEZhgs/edit
     */
    type?: string | null;
    /**
     * Mã ngôn ngữ (vi, en)
     */
    language?: string | null;
    /**
     * Tiêu đề thông báo
     */
    title?: string | null;
    /**
     * Mô tả ngắn của thông báo, định dạng plain text
     */
    intro?: string | null;
    /**
     * Đường dẫn
     */
    link?: string | null;
    /**
     * Mã của nguồn phát sinh ra thông báo gửi. Ví dụ: user_id...
     */
    from?: IdValue | null;
    tos?: Array<Notification_log_Tos | null | undefined> | null;
    tours?: Array<Notification_log_Tours | null | undefined> | null;
    /**
     * Thời điểm tạo
     */
    createdTime?: ISODateValue | null;
    /**
     * Thời hết hạn
     */
    expiredTime?: ISODateValue | null;
    /**
     * Thông tin đích của thông báo
     */
    target?: Notification_log_Target | null;
}

export interface Notification_log_Tos {
    /**
     * Mã người nhận
     */
    to_id?: IdValue | null;
    /**
     * Tên người nhận
     */
    to_name?: string | null;
}

export interface Notification_log_Tours {
    /**
     * Mã tour
     */
    tour_id?: IdValue | null;
    /**
     * Tên tour
     */
    tour_name?: string | null;
}

export interface Notification_log_Target {
    /**
     * Dữ liệu text của đích, ví dụ: url...
     */
    value?: string | null;
    /**
     * Mã tham chiếu của đích trong nội bộ, ví dụ: tour_id, phieu_dieu_tour_id...
     */
    targetId?: IdValue | null;
}

defineAsyncResource<Notification_log>({"name":"notification_log","actions":{"findMany":{"includeTotal":true},"findById":{},"createOne":{},"deleteOne":{},"deleteMany":{}},"views":{}}, mushroom);

export interface Notification {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã loại thông báo. Chi tiết xem tại: https://docs.google.com/document/d/1y_X4gFrT-Ws2cdziM00t2cE_6HJfG1JmD_uhgeEZhgs/edit
     */
    type?: string | null;
    /**
     * Mã nhóm thông báo. (Officer, Services, Others)
     */
    group_type?: string | null;
    /**
     * Mã ngôn ngữ (vi, en)
     */
    language?: string | null;
    /**
     * Tiêu đề thông báo
     */
    title?: string | null;
    /**
     * Mô tả ngắn của thông báo, định dạng plain text
     */
    intro?: string | null;
    /**
     * Đường dẫn
     */
    link?: string | null;
    /**
     * Mã của nguồn phát sinh ra thông báo gửi. Ví dụ: user_id...
     */
    from?: IdValue | null;
    /**
     * Mã người nhận
     */
    to?: IdValue | null;
    /**
     * Cho biết người dùng đã đọc hay chưa
     */
    isRead?: boolean | null;
    /**
     * Thời điểm tạo
     */
    createdTime?: ISODateValue | null;
    /**
     * Thời hết hạn
     */
    expiredTime?: ISODateValue | null;
    /**
     * Thông tin đích của thông báo
     */
    target?: Notification_Target | null;
    /**
     * Các dữ liệu thêm, định dạng json
     */
    metadata?: string | null;
    /**
     * Mã notification_log
     */
    log_id?: IdValue | null;
}

export interface Notification_Target {
    /**
     * Dữ liệu text của đích, ví dụ: url...
     */
    value?: string | null;
    /**
     * Mã tham chiếu của đích trong nội bộ, ví dụ: tour_id, phieu_dieu_tour_id...
     */
    targetId?: IdValue | null;
}

export interface Notification$CustomMethodResource {
    mask_all_notify_as_readAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<Notification>({"name":"notification","actions":{"findMany":{"includeTotal":true},"findById":{},"createOne":{},"updatePartially":{},"deleteOne":{},"deleteMany":{},"_raw_http_method_mask_all_notify_as_read":{}},"views":{}}, mushroom);

export interface Notification_status {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã người dùng
     */
    user_id?: IdValue | null;
    /**
     * notification
     */
    notification_id?: IdValue | null;
    /**
     * Đã đọc hay chưa
     */
    isRead?: boolean | null;
    /**
     * Thời gian tạo
     */
    created_time?: ISODateValue | null;
}

defineAsyncResource<Notification_status>({"name":"notification_status","actions":{"findMany":{"includeTotal":true},"createOne":{},"updatePartially":{}},"views":{}}, mushroom);

export interface Device {
    /**
     * Mã tự tăng
     */
    id?: IdValue | null;
    /**
     * Mã người dùng
     */
    user_id?: IdValue | null;
    /**
     * Firebase token của thiết bị
     */
    device_token?: string | null;
    /**
     * Loại thiết bị
     */
    device_type?: string | null;
    /**
     * Id thiết bị
     */
    device_id?: string | null;
    /**
     * Mã ngôn ngữ
     */
    language?: string | null;
    /**
     * Thời gian tạo
     */
    created_time?: ISODateValue | null;
    /**
     * Thời gian sửa cuối
     */
    last_modified_time?: ISODateValue | null;
}

export interface Device$CustomMethodResource {
    delete_by_device_idAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    delete_by_userAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    save_deviceAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<Device>({"name":"device","actions":{"findMany":{"clientCache":true,"includeTotal":true},"_raw_http_method_delete_by_device_id":{},"_raw_http_method_delete_by_user":{},"_raw_http_method_save_device":{}},"views":{}}, mushroom);

export interface Config {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã của cấu hình
     */
    code?: string | null;
    /**
     * Danh sách quyền được phép lấy về thông tin cấu hình
     */
    roles?: Array<string | null | undefined> | null;
    /**
     * Giá trị cấu hình
     */
    value?: string | null;
}

defineAsyncResource<Config>({"name":"config","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{}},"views":{}}, mushroom);

export interface Version {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã của nền tảng
     */
    platform?: string | null;
    /**
     * Phiên bản hiện thời
     */
    current?: number | null;
    /**
     * Phiên bản thấp nhất còn chạy tốt. Nếu nhỏ hơn thì client cần cập nhật
     */
    min?: number | null;
    /**
     * Đường dẫn cập nhật
     */
    link?: string | null;
}

defineAsyncResource<Version>({"name":"version","actions":{"findById":{"clientCache":true},"findMany":{"clientCache":true,"includeTotal":true},"updatePartially":{}},"views":{}}, mushroom);

export interface Config_notification {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Id người dùng
     */
    user_id?: IdValue | null;
    /**
     * Có nhận thông báo phản ánh hay không
     */
    has_feedback?: boolean | null;
    /**
     * Có nhận thông báo dịch vụ hay không
     */
    has_service?: boolean | null;
    /**
     * Có nhận thông báo thẻ hay không
     */
    has_card?: boolean | null;
    /**
     * Có nhận thông báo tin tức hay không
     */
    has_news?: boolean | null;
}

defineAsyncResource<Config_notification>({"name":"config_notification","actions":{"findById":{"clientCache":true},"findMany":{"clientCache":true,"includeTotal":true},"createOne":{},"updatePartially":{}},"views":{}}, mushroom);

export interface Province {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Cho biết tỉnh, thành phố còn tồn tại hay không
     */
    disabled?: boolean | null;
    /**
     * Mã tỉnh, thành phố (theo tổng cục thống kê)
     */
    code?: string | null;
    /**
     * Tên tỉnh, thành phố
     */
    name?: string | null;
    /**
     * Thứ tự sắp xếp của tỉnh, thành phố
     */
    index?: number | null;
    /**
     * Loại (Tỉnh hoặc Thành phố)
     */
    type?: string | null;
    center?: Province_Center | null;
    /**
     * Mã an toàn covid
     */
    atcId?: number | null;
    /**
     * Tên với ngôn ngữ cụ thể
     */
    lang?: Province_Lang | null;
}

export interface Province_Center {
    lng?: number | null;
    lat?: number | null;
}

export interface Province_Lang {
    /**
     * Tên tiếng Việt
     */
    vi?: Province_Lang_Vi | null;
    /**
     * Tên tiếng Anh
     */
    en?: Province_Lang_En | null;
}

export interface Province_Lang_Vi {
    /**
     * Tên tỉnh, thành phố (tiếng Việt)
     */
    name?: string | null;
    /**
     * Loại (tiếng Việt)
     */
    type?: string | null;
    /**
     * Tên đầy đủ tỉnh, thành phố (tiếng Việt)
     */
    fullname?: string | null;
}

export interface Province_Lang_En {
    /**
     * Tên tỉnh, thành phố (tiếng Anh)
     */
    name?: string | null;
    /**
     * Loại (tiếng Anh)
     */
    type?: string | null;
    /**
     * Tên đầy đủ tỉnh, thành phố (tiếng Anh)
     */
    fullname?: string | null;
}

defineAsyncResource<Province>({"name":"province","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true}},"views":{}}, mushroom);

export interface District {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Cho biết tỉnh, thành phố còn tồn tại hay không
     */
    disabled?: boolean | null;
    /**
     * Mã quận, huyện, thị xã (theo tổng cục thống kê)
     */
    code?: string | null;
    /**
     * Tên quận, huyện, thị xã
     */
    name?: string | null;
    /**
     * Mã tỉnh
     */
    provinceId?: IdValue | null;
    /**
     * Thứ tự sắp xếp của quận, huyện, thị xã
     */
    index?: number | null;
    /**
     * Loại (Quận, Huyện, Thị xã hoặc Thành phố)
     */
    type?: string | null;
    center?: District_Center | null;
    /**
     * Mã an toàn covid
     */
    atcId?: number | null;
    /**
     * Tên với ngôn ngữ cụ thể
     */
    lang?: District_Lang | null;
}

export interface District_Center {
    lng?: number | null;
    lat?: number | null;
}

export interface District_Lang {
    /**
     * Tên tiếng Việt
     */
    vi?: District_Lang_Vi | null;
    /**
     * Tên tiếng Anh
     */
    en?: District_Lang_En | null;
}

export interface District_Lang_Vi {
    /**
     * Tên quận, huyện, thị xã (tiếng Việt)
     */
    name?: string | null;
    /**
     * Loại (tiếng Việt)
     */
    type?: string | null;
    /**
     * Tên đầy đủ quận, huyện, thị xã (tiếng Việt)
     */
    fullname?: string | null;
}

export interface District_Lang_En {
    /**
     * Tên quận, huyện, thị xã (tiếng Anh)
     */
    name?: string | null;
    /**
     * Loại (tiếng Anh)
     */
    type?: string | null;
    /**
     * Tên đầy đủ quận, huyện, thị xã (tiếng Anh)
     */
    fullname?: string | null;
}

defineAsyncResource<District>({"name":"district","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true}},"views":{}}, mushroom);

export interface Commune {
    /**
     * Mã xã tự sinh
     */
    id?: IdValue | null;
    /**
     * Cho biết tỉnh, thành phố còn tồn tại hay không
     */
    disabled?: boolean | null;
    /**
     * Mã tỉnh
     */
    provinceId?: IdValue | null;
    /**
     * [DEPRECATED] Mã huyện
     */
    districtId?: IdValue | null;
    /**
     * Tên phường, xã, đặc khu
     */
    name?: string | null;
    /**
     * Mã phường, xã
     */
    code?: string | null;
    /**
     * Thứ tự sắp xếp
     */
    index?: number | null;
    /**
     * Loại (Xã, Phường, Đặc khu)
     */
    type?: string | null;
    center?: Commune_Center | null;
    /**
     * Mã an toàn covid
     */
    atcId?: number | null;
    /**
     * Tên với ngôn ngữ cụ thể
     */
    lang?: Commune_Lang | null;
}

export interface Commune_Center {
    lng?: number | null;
    lat?: number | null;
}

export interface Commune_Lang {
    /**
     * Tên tiếng Việt
     */
    vi?: Commune_Lang_Vi | null;
    /**
     * Tên tiếng Anh
     */
    en?: Commune_Lang_En | null;
}

export interface Commune_Lang_Vi {
    /**
     * Tên phường, xã (tiếng Việt)
     */
    name?: string | null;
    /**
     * Loại (tiếng Việt)
     */
    type?: string | null;
    /**
     * Tên đầy đủ phường, xã (tiếng Việt)
     */
    fullname?: string | null;
}

export interface Commune_Lang_En {
    /**
     * Tên phường, xã (tiếng Anh)
     */
    name?: string | null;
    /**
     * Loại (tiếng Anh)
     */
    type?: string | null;
    /**
     * Tên đầy phường, xã (tiếng Anh)
     */
    fullname?: string | null;
}

defineAsyncResource<Commune>({"name":"commune","actions":{"findMany":{"clientCache":true},"findById":{"clientCache":true}},"views":{}}, mushroom);

export interface File {
    /**
     * Mã file
     */
    id?: IdValue | null;
    /**
     * Tên file
     */
    name?: string | null;
    /**
     * Phần mở rộng (đuôi file)
     */
    extension?: string | null;
    /**
     * Dung lượng file (đơn vị byte)
     */
    length?: number | null;
    /**
     * Mã băm md5 của file
     */
    md5?: string | null;
}

defineAsyncResource<File>({"name":"file","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true}},"views":{}}, mushroom);

export interface Otp_mobile_register_captcha {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã session của captcha
     */
    session?: string | null;
    /**
     * Giá trị captcha
     */
    value?: string | null;
    /**
     * Base64 của ảnh captcha
     */
    img?: string | null;
    /**
     * Thời điểm tạo
     */
    created_time?: ISODateValue | null;
}

defineAsyncResource<Otp_mobile_register_captcha>({"name":"otp_mobile_register_captcha","actions":{"findById":{"clientCache":true},"createOne":{}},"views":{}}, mushroom);

export interface Dashboard {
    id?: IdValue | null;
}

export interface Dashboard$ViewsResource_ddat_countView_Parameters {
    /**
     * Đến ngày (giá trị là đầu ngày hôm sau)
     */
    to?: ISODateValue | null;
};
export interface Dashboard$ViewsResource_ddat_count_daily_declaredView_Parameters {
    /**
     * Đến ngày (giá trị là đầu ngày hôm sau)
     */
    to: ISODateValue;
};
export interface Dashboard$ViewsResource_ddat_statistic_dailyView_Parameters {
    /**
     * Ngày cần thống kê (giá trị là đầu ngày hôm sau)
     */
    to: ISODateValue;
};
export interface Dashboard$ViewsResource_ddat_total_declared_province_countView_Parameters {
    /**
     * Từ ngày
     */
    from?: ISODateValue | null;
    /**
     * Đến ngày (giá trị là đầu ngày hôm sau)
     */
    to?: ISODateValue | null;
};
export interface Dashboard$ViewsResource_stats_total_declared_provincesView_Parameters {
    /**
     * Từ ngày
     */
    from?: ISODateValue | null;
    /**
     * Đến ngày (giá trị là đầu ngày hôm sau)
     */
    to?: ISODateValue | null;
};
export interface Dashboard$ViewsResource {
    views: {
        ddat_countAsync: MushroomViewFunction<any, Dashboard$ViewsResource_ddat_countView_Parameters>;
        ddat_count_daily_declaredAsync: MushroomViewFunction<any, Dashboard$ViewsResource_ddat_count_daily_declaredView_Parameters>;
        ddat_statistic_dailyAsync: MushroomViewFunction<any, Dashboard$ViewsResource_ddat_statistic_dailyView_Parameters>;
        ddat_total_declared_province_countAsync: MushroomViewFunction<any, Dashboard$ViewsResource_ddat_total_declared_province_countView_Parameters>;
        stats_total_declared_provincesAsync: MushroomViewFunction<any, Dashboard$ViewsResource_stats_total_declared_provincesView_Parameters>;
    }
}
defineAsyncResource<Dashboard>({"name":"dashboard","actions":{},"views":{"ddat_count":{"clientCache":true},"ddat_count_daily_declared":{"clientCache":true},"ddat_statistic_daily":{"clientCache":true},"ddat_total_declared_province_count":{"clientCache":true},"stats_total_declared_provinces":{"clientCache":true}}}, mushroom);

export interface Foreigner {
    /**
     * Mã người dùng
     */
    id?: IdValue | null;
    /**
     * Thông tin trên hộ chiếu
     */
    ho_chieu?: Foreigner_Ho_chieu | null;
    /**
     * Email
     */
    email?: string | null;
    /**
     * Mã ảnh chân dung
     */
    anh_chan_dung_id?: IdValue | null;
    /**
     * Mã các hình ảnh đính kèm
     */
    anh_chan_dung_ids?: Array<IdValue | null | undefined> | null;
    /**
     * Thời điểm tạo
     */
    thoi_diem_tao?: ISODateValue | null;
}

export interface Foreigner_Ho_chieu {
    /**
     * Loại hộ chiếu
     */
    loai?: string | null;
    /**
     * Mã số
     */
    ma_so?: string | null;
    /**
     * Số hộ chiếu
     */
    so_ho_chieu?: string | null;
    /**
     * Họ và tên
     */
    ho_ten?: string | null;
    /**
     * Mã quốc tịch
     */
    quoc_tich_id?: IdValue | null;
    /**
     * Ngày sinh
     */
    ngay_sinh?: ISODateValue | null;
    /**
     * Nơi sinh
     */
    noi_sinh?: string | null;
    /**
     * Giới tính. 1 - Nam, 2 - Nữ, 3 - Chưa có thông tin, 4 - Khác
     */
    gioi_tinh?: number | null;
    /**
     * Số chứng minh thư nhân dân
     */
    cmnd?: string | null;
    /**
     * Ngày cấp
     */
    ngay_cap?: ISODateValue | null;
    /**
     * Hiệu lực đến
     */
    hieu_luc_den?: ISODateValue | null;
    /**
     * Nơi cấp
     */
    noi_cap?: string | null;
    /**
     * Mã ảnh hộ chiếu
     */
    anh_id?: IdValue | null;
}

export interface Foreigner$CustomMethodResource {
    ocrAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    verifyFaceAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    registerForeignerAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    check_required_change_passwordAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    clear_required_change_passwordAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    sendEmailAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<Foreigner>({"name":"foreigner","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"updatePartially":{},"_raw_http_method_ocr":{},"_raw_http_method_verifyFace":{},"_raw_http_method_registerForeigner":{},"_raw_http_method_check_required_change_password":{},"_raw_http_method_clear_required_change_password":{},"_raw_http_method_sendEmail":{}},"views":{}}, mushroom);

export interface Foreigner_qr {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã khách du lịch nước ngoài
     */
    foreigner_id?: IdValue | null;
    /**
     * Mã QR dùng để checkin
     */
    qr?: string | null;
    /**
     * Thái thái mã qr
     */
    trang_thai?: string | null;
    /**
     * Thông tin liên quan đến khai báo
     */
    khai_bao?: Foreigner_qr_Khai_bao | null;
    /**
     * Thông tin xét duyệt visa
     */
    visa?: Foreigner_qr_Visa | null;
    /**
     * Nội dung xét nghiệm
     */
    xet_nghiem?: Array<Foreigner_qr_Xet_nghiem | null | undefined> | null;
    /**
     * Thông tin nhập cảnh
     */
    nhap_canh?: Foreigner_qr_Nhap_canh | null;
    /**
     * Thông tin xuất cảnh
     */
    xuat_canh?: Foreigner_qr_Xuat_canh | null;
    /**
     * Thời điểm tạo
     */
    thoi_diem_tao?: ISODateValue | null;
}

export interface Foreigner_qr_Khai_bao {
    /**
     * Cho biết có yêu cầu visa hay không
     */
    yeu_cau_visa?: boolean | null;
    /**
     * Ảnh visa (nếu có)
     */
    anh_visa_id?: IdValue | null;
    /**
     * Thông tin khai báo y tế
     */
    y_te?: Foreigner_qr_Khai_bao_Y_te | null;
    /**
     * Xác nhận tiêm chủng
     */
    tiem_chung?: Foreigner_qr_Khai_bao_Tiem_chung | null;
    /**
     * Thời điểm hoàn thành khai báo
     */
    thoi_diem_khai_bao?: ISODateValue | null;
}

export interface Foreigner_qr_Khai_bao_Y_te {
    /**
     * Danh sách quốc gia đã đến
     */
    danh_sach_quoc_gia_da_den?: Array<IdValue | null | undefined> | null;
    /**
     * Các dấu hiệu. Nhận các giá trị: "ho", "sot", "kho_tho", "viem_phoi", "dau_hong", "met_moi"
     */
    danh_sach_dau_hieu?: Array<string | null | undefined> | null;
    /**
     * Danh sách tiếp xúc
     */
    danh_sach_tiep_xuc?: Array<IdValue | null | undefined> | null;
    /**
     * Các bệnh hiện tại
     */
    danh_sach_benh?: Array<IdValue | null | undefined> | null;
    /**
     * Thân nhiệt
     */
    than_nhiet?: number | null;
}

export interface Foreigner_qr_Khai_bao_Tiem_chung {
    /**
     * Loại vaccine
     */
    vaccine?: string | null;
    /**
     * Thông tin các lượt tiêm
     */
    luot_tiem?: Array<Foreigner_qr_Khai_bao_Tiem_chung_Luot_tiem | null | undefined> | null;
    /**
     * Có giá trị đến
     */
    gia_tri_den?: ISODateValue | null;
    /**
     * Số giấy chứng nhận
     */
    so_giay_chung_nhan?: string | null;
    /**
     * Ảnh chụp xác nhận tiêm chủng
     */
    anh_id?: IdValue | null;
    /**
     * Mã các hình ảnh đính kèm
     */
    anh_ids?: Array<IdValue | null | undefined> | null;
    /**
     * Nội dung mã qr xác nhận tiêm chủng
     */
    qr?: string | null;
    /**
     * Linh xác nhận tiêm chủng
     */
    link?: string | null;
    /**
     * Mã quốc gia
     */
    quoc_gia_id?: IdValue | null;
}

export interface Foreigner_qr_Khai_bao_Tiem_chung_Luot_tiem {
    /**
     * Thời gian tiêm
     */
    thoi_gian_tiem?: ISODateValue | null;
    /**
     * Địa điểm tiêm
     */
    dia_diem_tiem?: string | null;
}

export interface Foreigner_qr_Visa {
    /**
     * Cho biết QR có được duyệt hay không
     */
    duoc_duyet?: boolean | null;
    /**
     * Người dùng xét duyệt visa
     */
    nguoi_duyet?: IdValue | null;
    /**
     * Thời điểm xét duyệt
     */
    thoi_diem_duyet?: ISODateValue | null;
}

export interface Foreigner_qr_Xet_nghiem {
    /**
     * Loại xét nghiệm. LP6464-4 - test PCR, LP217198-3 - test nhanh
     */
    loai_xet_nghiem?: string | null;
    /**
     * Tên xét nghiệm
     */
    ten_xet_nghiem?: string | null;
    /**
     * Ngày xét nghiệm
     */
    ngay_xet_nghiem?: ISODateValue | null;
    /**
     * Kết quả xét nghiệm. 260415000 - Âm tính, 260373001 - Dương tính
     */
    ket_qua_test?: string | null;
    /**
     * Nơi xét nghiệm
     */
    noi_xet_nghiem?: string | null;
    /**
     * QR code xét nghiệm
     */
    qr_code?: string | null;
    /**
     * Id của quốc gia
     */
    quoc_gia_id?: IdValue | null;
    /**
     * Cho biết xét nghiệm đã được duyệt hay chưa. False: từ chối. true: Đã duyệt. Nullable: Chưa duyệt
     */
    duoc_duyet?: boolean | null;
    /**
     * Ảnh chụp xác nhận xét nghiệm
     */
    anh_id?: IdValue | null;
}

export interface Foreigner_qr_Nhap_canh {
    /**
     * Thời điểm nhập cảnh
     */
    thoi_diem_nhap_canh?: ISODateValue | null;
    /**
     * Mã nhân viên hải quan
     */
    hai_quan?: IdValue | null;
    /**
     * Cho biết QR có được duyệt hay không
     */
    duoc_duyet?: boolean | null;
    /**
     * Mã thẻ du lịch
     */
    ma_the_du_lich?: string | null;
}

export interface Foreigner_qr_Xuat_canh {
    /**
     * Thời điểm xuất cảnh
     */
    thoi_diem_xuat_canh?: ISODateValue | null;
    /**
     * Mã nhân viên hải quan
     */
    hai_quan?: IdValue | null;
    /**
     * Cho biết QR có được duyệt hay không
     */
    duoc_duyet?: boolean | null;
}

export interface Foreigner_qr$CustomMethodResource {
    submitDeclarationAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    approveVaccineAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    rejectVaccineAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    approveQrAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    rejectQrAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    approveCheckInAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    rejectCheckInAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    approveCheckOutAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    rejectCheckOutAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    check_qrcodeAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
export interface Foreigner_qr$ViewsResource_count_existed_qr_codeView_Parameters {
    /**
     * Mã QR code
     */
    qr: string;
};
export interface Foreigner_qr$ViewsResource {
    views: {
        count_existed_qr_codeAsync: MushroomViewFunction<any, Foreigner_qr$ViewsResource_count_existed_qr_codeView_Parameters>;
    }
}
defineAsyncResource<Foreigner_qr>({"name":"foreigner_qr","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"_raw_http_method_submitDeclaration":{},"_raw_http_method_approveVaccine":{},"_raw_http_method_rejectVaccine":{},"_raw_http_method_approveQr":{},"_raw_http_method_rejectQr":{},"_raw_http_method_approveCheckIn":{},"_raw_http_method_rejectCheckIn":{},"_raw_http_method_approveCheckOut":{},"_raw_http_method_rejectCheckOut":{},"_raw_http_method_check_qrcode":{}},"views":{"count_existed_qr_code":{"clientCache":true}}}, mushroom);

export interface Quoc_gia {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Tên quốc gia
     */
    ten_quoc_gia?: Quoc_gia_Ten_quoc_gia | null;
    /**
     * Tên quốc tịch
     */
    ten_quoc_tich?: Quoc_gia_Ten_quoc_tich | null;
    /**
     * Mã quốc gia. Xem tại: https://en.wikipedia.org/wiki/List_of_ISO_3166_country_codes
     */
    ma?: Quoc_gia_Ma | null;
    /**
     * Cho biết có miễn visa khi vào Việt Nam hay không
     */
    mien_visa?: boolean | null;
}

export interface Quoc_gia_Ten_quoc_gia {
    /**
     * Tên tiếng Việt
     */
    vi?: string | null;
    /**
     * Tên tiếng Anh
     */
    en?: string | null;
}

export interface Quoc_gia_Ten_quoc_tich {
    /**
     * Tên tiếng Việt
     */
    vi?: string | null;
    /**
     * Tên tiếng Anh
     */
    en?: string | null;
}

export interface Quoc_gia_Ma {
    /**
     * Mã quốc gia. Mã ISO 3166-1 (Alpha 2) https://en.wikipedia.org/wiki/List_of_ISO_3166_country_codes
     */
    alpha_2?: string | null;
    /**
     * Mã quốc gia. Mã ISO 3166-1 (Alpha 3) https://en.wikipedia.org/wiki/List_of_ISO_3166_country_codes
     */
    alpha_3?: string | null;
    /**
     * Mã quốc gia. Mã ISO 3166-1 (Numeric) https://en.wikipedia.org/wiki/List_of_ISO_3166_country_codes
     */
    numeric?: string | null;
}

defineAsyncResource<Quoc_gia>({"name":"quoc_gia","actions":{"findMany":{"clientCache":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{}},"views":{}}, mushroom);

export interface Vaccine {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Tên vaccine
     */
    ten?: string | null;
    /**
     * Mã vaccine
     */
    ma_vaccine?: string | null;
    /**
     * Mã nhà sản xuất vaccine
     */
    ma_nha_san_xuat_vaccine?: string | null;
    /**
     * Số lần tiêm của vaccince
     */
    so_lan_tiem?: number | null;
}

defineAsyncResource<Vaccine>({"name":"vaccine","actions":{"findMany":{"clientCache":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{}},"views":{}}, mushroom);

export interface Kbyt_tiep_xuc {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Tên tiếp xúc
     */
    ten?: Kbyt_tiep_xuc_Ten | null;
}

export interface Kbyt_tiep_xuc_Ten {
    /**
     * Tên tiếng Việt
     */
    vi?: string | null;
    /**
     * Tên tiếng Anh
     */
    en?: string | null;
}

defineAsyncResource<Kbyt_tiep_xuc>({"name":"kbyt_tiep_xuc","actions":{"findMany":{"clientCache":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{}},"views":{}}, mushroom);

export interface Kbyt_benh {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Tên bệnh
     */
    ten?: Kbyt_benh_Ten | null;
}

export interface Kbyt_benh_Ten {
    /**
     * Tên tiếng Việt
     */
    vi?: string | null;
    /**
     * Tên tiếng Anh
     */
    en?: string | null;
}

defineAsyncResource<Kbyt_benh>({"name":"kbyt_benh","actions":{"findMany":{"clientCache":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{}},"views":{}}, mushroom);

export interface Map_item {
    /**
     * Mã điểm
     */
    id?: IdValue | null;
    /**
     * Tên địa điểm
     */
    ten_dia_diem?: string | null;
    /**
     * Mã điểm đến
     */
    ma_dia_diem?: string | null;
    /**
     * Loại địa điểm
     */
    loai_dia_diem?: string | null;
    /**
     * Địa chỉ đầy đủ
     */
    dia_chi?: string | null;
    /**
     * Mã tỉnh
     */
    provinceId?: IdValue | null;
    /**
     * Mã huyện
     */
    districtId?: IdValue | null;
    /**
     * Mã xã
     */
    communeId?: IdValue | null;
    /**
     * Tọa độ
     */
    toa_do?: Map_item_Toa_do | null;
    ngay_danh_gia_cuoi?: ISODateValue | null;
    /**
     * Xếp loại an toàn: 1 - An toàn; 2 - Có nguy cơ; 3 - Không an toàn; NULL - Chưa đánh giá
     */
    xep_loai_cuoi?: number | null;
    /**
     * Xếp loại an toàn ngày hôm nay: 1 - An toàn; 2 - Có nguy cơ; 3 - Không an toàn; NULL - Chưa đánh giá ngày hôm nay
     */
    xep_loai_ngay?: number | null;
    /**
     * Dữ liệu nguồn
     */
    nguon?: Map_item_Nguon | null;
    /**
     * Thời điểm cập nhật cuối cùng
     */
    cap_nhat_cuoi?: ISODateValue | null;
}

export interface Map_item_Toa_do {
    /**
     * Kinh độ
     */
    kinh_do?: number | null;
    /**
     * Vĩ độ
     */
    vi_do?: number | null;
}

export interface Map_item_Nguon {
    maphuongxa?: string | null;
    maquanhuyen?: string | null;
    matinh?: string | null;
    phuongxa?: string | null;
    quanhuyen?: string | null;
    tinh?: string | null;
    sonha?: string | null;
}

defineAsyncResource<Map_item>({"name":"map_item","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"updatePartially":{}},"views":{}}, mushroom);

export interface Bao_hiem {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã hãng bảo hiểm
     */
    hang_bao_hiem_id?: IdValue | null;
    /**
     * Mã khách du lịch
     */
    khach_du_lich_id?: IdValue | null;
    /**
     * Trạng thái đơn
     */
    trang_thai?: string | null;
    /**
     * Danh cash các lịch sử chuyển trạng thái
     */
    lich_su?: Array<Bao_hiem_Lich_su | null | undefined> | null;
    /**
     * Thông tin thanh toán
     */
    thanh_toan?: Bao_hiem_Thanh_toan | null;
    /**
     * Thông tin đơn hàng bảo hiểm. MIC cần cung cấp schema
     */
    thong_tin_don_hang?: Bao_hiem_Thong_tin_don_hang | null;
    /**
     * Thời điểm tạo
     */
    thoi_diem_tao?: ISODateValue | null;
    /**
     * Mã người tạo đơn
     */
    nguoi_tao_id?: IdValue | null;
}

export interface Bao_hiem_Lich_su {
    /**
     * Trạng thái đơn hàng
     */
    trang_thai?: string | null;
    /**
     * Thời điểm chuyển trạng thái
     */
    thoi_diem?: ISODateValue | null;
    /**
     * Thông tin Nội dung thêm
     */
    noi_dung?: string | null;
}

export interface Bao_hiem_Thanh_toan {
    /**
     * Trạng thái đơn hàng
     */
    trang_thai?: string | null;
    /**
     * Danh cash các lịch sử chuyển trạng thái thanh toán
     */
    lich_su?: Array<Bao_hiem_Thanh_toan_Lich_su | null | undefined> | null;
}

export interface Bao_hiem_Thanh_toan_Lich_su {
    /**
     * Trạng thái đơn hàng
     */
    trang_thai?: string | null;
    /**
     * Thời điểm chuyển trạng thái
     */
    thoi_diem?: ISODateValue | null;
    /**
     * Thông tin Nội dung thêm
     */
    noi_dung?: string | null;
}

export interface Bao_hiem_Thong_tin_don_hang {
    /**
     * Họ tên người mua bảo hiểm
     */
    ho_ten?: string | null;
    /**
     * Số CMND người mua bảo hiểm
     */
    cmnd?: string | null;
    /**
     * Giới tính người mua bảo hiểm
     */
    gioi_tinh?: number | null;
    /**
     * Số liên hệ người mua bảo hiểm
     */
    so_lien_he?: string | null;
    /**
     * Địa chỉ người mua bảo hiểm
     */
    dia_chi?: string | null;
    /**
     * Email người mua bảo hiểm
     */
    email?: string | null;
    /**
     * Mã gói bảo hiểm
     */
    goi_bh?: string | null;
    /**
     * Tên gói bảo hiểm
     */
    ten_goi?: string | null;
    /**
     * Số hợp đồng
     */
    so_hd?: string | null;
    /**
     * Ngày cập nhật hợp đồng lên hệ thống
     */
    ngay_mua?: ISODateValue | null;
    /**
     * Ngày hợp đồng có hiệu lực
     */
    ngay_hl?: ISODateValue | null;
    /**
     * Ngày hợp đồng hết hiệu lực
     */
    ngay_kt?: ISODateValue | null;
    /**
     * Tổng số tiền phí người mua phải trả
     */
    tong_phi?: number | null;
    /**
     * Tiền bảo hiểm (Mức trách nhiệm)
     */
    tien_bh?: number | null;
    /**
     * Mã nghiệp vụ sản phẩm
     */
    nv?: string | null;
    /**
     * Tình trạng hợp đồng. 4-Đã thanh toán/ 2-Chưa thanh toán
     */
    ttrang?: number | null;
    /**
     * Tên tình trạng đã thanh toán chưa. Chưa thanh toán/Đã thanh toán
     */
    ten_ttrang?: string | null;
    /**
     * Người thụ hưởng
     */
    nguoi_thu_huong?: string | null;
}

export interface Bao_hiem$CustomMethodResource {
    getCustomerInfoAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    update_infoAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<Bao_hiem>({"name":"bao_hiem","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"_raw_http_method_getCustomerInfo":{},"_raw_http_method_update_info":{}},"views":{}}, mushroom);

export interface Hang_bao_hiem {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Tên hãng bảo hiểm
     */
    ten?: Hang_bao_hiem_Ten | null;
    /**
     * Mã bảo hiểm
     */
    code?: string | null;
    /**
     * Logo hãng bảo hiểm
     */
    logo?: IdValue | null;
    /**
     * Danh sách người quản lý
     */
    nguoi_quan_ly_ids?: Array<IdValue | null | undefined> | null;
    /**
     * Cho biết hãng bảo hiểm có bị ẩn trên hệ thống hay không
     */
    het_hieu_luc?: boolean | null;
    /**
     * Thời điểm tạo
     */
    thoi_diem_tao?: ISODateValue | null;
}

export interface Hang_bao_hiem_Ten {
    /**
     * Tên tiếng Việt
     */
    vi?: string | null;
    /**
     * Tên tiếng Anh
     */
    en?: string | null;
}

defineAsyncResource<Hang_bao_hiem>({"name":"hang_bao_hiem","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true}},"views":{}}, mushroom);

export interface Tokhaiyte {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * id xác định gói tin nào ứng với id tờ khai được sinh ra
     */
    syncId?: string | null;
    /**
     * Loại khai báo. 0 - Tự khai, 1 - Khai hộ
     */
    type?: number | null;
    /**
     * Số điện thoại của người khai
     */
    phone?: string | null;
    /**
     * Thông tin người được khai báo
     */
    user?: Tokhaiyte_User | null;
    /**
     * Tình trạng sức khỏe
     */
    healthStatus?: Tokhaiyte_HealthStatus | null;
    /**
     * Lịch sử tiếp xúc
     */
    contactHistory?: Tokhaiyte_ContactHistory | null;
    /**
     * Lịch sử di chuyển
     */
    travelHistory?: Tokhaiyte_TravelHistory | null;
    /**
     * Hiện có đang ở vùng dịch
     */
    historyInEpidemicArea?: Tokhaiyte_HistoryInEpidemicArea | null;
    /**
     * Mở rộng
     */
    extend?: Tokhaiyte_Extend | null;
    /**
     * Thời gian khai báo (Dạng Timespan(Miliseconds))
     */
    createdTime?: number | null;
    /**
     * Thong tin khai báo
     */
    tokhaiyte_info?: Tokhaiyte_Tokhaiyte_info | null;
}

export interface Tokhaiyte_User {
    /**
     * Họ tên người được khai báo
     */
    fullname?: string | null;
    /**
     * Năm sinh
     */
    year_of_birthday?: ISODateValue | null;
    /**
     * Giới tính. 1 - nữ, 2 - nam, 3 - khác
     */
    gender?: number | null;
    /**
     * Mã code quốc gia
     */
    countryId?: string | null;
    /**
     * Mã code tỉnh
     */
    provinceId?: string | null;
    /**
     * Mã code huyện
     */
    districtId?: string | null;
    /**
     * Mã code phường xã
     */
    townId?: string | null;
    /**
     * Tên quốc gia
     */
    country?: string | null;
    /**
     * Tên tỉnh/thành phố
     */
    province?: string | null;
    /**
     * Tên quận/huyện
     */
    district?: string | null;
    /**
     * Tên phường/xã
     */
    town?: string | null;
    /**
     * Địa chỉ
     */
    address?: string | null;
    /**
     * Số điện thoại
     */
    phone?: string | null;
    /**
     * Số thẻ bảo hiểm y tế
     */
    healthInsuranceNumber?: string | null;
    /**
     * Số chứng minh nhân dân
     */
    cmnd?: string | null;
    /**
     * Email
     */
    email?: string | null;
    /**
     * Mở rộng
     */
    extend?: Tokhaiyte_User_Extend | null;
}

export interface Tokhaiyte_User_Extend {
}

export interface Tokhaiyte_HealthStatus {
    /**
     * Tình trạng sức khỏe. 0 - Bình thường, 1 - Lo lắng về sức khỏe
     */
    healthStatus?: number | null;
    /**
     * Mô tả tình trạng sức khỏe
     */
    description?: string | null;
}

export interface Tokhaiyte_ContactHistory {
    /**
     * Từng tiếp xúc với người nghi nhiễm
     */
    contactWithPatient?: boolean | null;
    /**
     * Người bệnh nghi ngờ tiếp xúc với người mắc bệnh Covid-19
     */
    nguoi_nghi_ngo_tiep_xuc?: boolean | null;
    /**
     * Người đến từ quốc gia có bệnh
     */
    nguoi_den_tu_quoc_gia_covid?: boolean | null;
    /**
     * Người có biểu hiện(Sốt, ho, khó thở, viêm phổi)
     */
    nguoi_co_bieu_hien?: boolean | null;
}

export interface Tokhaiyte_TravelHistory {
    /**
     * Có từng di chuyển trong 14 ngày
     */
    travel?: boolean | null;
    /**
     * Danh sách các điểm từng đến
     */
    items?: Array<Tokhaiyte_TravelHistory_Items | null | undefined> | null;
}

export interface Tokhaiyte_TravelHistory_Items {
    /**
     * Id của quốc gia
     */
    travel_country_id?: IdValue | null;
    /**
     * Mã code quốc gia
     */
    travelCountryId?: string | null;
    /**
     * Tên quốc gia
     */
    travelCountry?: string | null;
    /**
     * Id của tỉnh
     */
    travel_province_id?: IdValue | null;
    /**
     * Mã code tỉnh
     */
    travelProvinceId?: string | null;
    /**
     * Tên tỉnh
     */
    travelProvince?: string | null;
    /**
     * Id của huyện
     */
    travel_district_id?: IdValue | null;
    /**
     * Mã code huyện
     */
    travelDistrictId?: string | null;
    /**
     * Tên huyện
     */
    travelDistrict?: string | null;
    /**
     * Id của xã
     */
    travel_town_id?: IdValue | null;
    /**
     * Mã code xã
     */
    travelTownId?: string | null;
    /**
     * Tên xã
     */
    travelTown?: string | null;
    /**
     * Địa chỉ
     */
    travelAddress?: string | null;
    /**
     * Thời gian
     */
    travelTime?: ISODateValue | null;
}

export interface Tokhaiyte_HistoryInEpidemicArea {
    /**
     * Có đang ở vùng dịch không
     */
    inEpidemicArea?: boolean | null;
    /**
     * Mã tỉnh
     */
    epidemicProvinceId?: string | null;
    /**
     * Tên tỉnh
     */
    epidemicProvince?: string | null;
    /**
     * Địa chỉ
     */
    epidemicAddress?: string | null;
    /**
     * Thời gian đi đến đó
     */
    epidemicAreaTravelTime?: ISODateValue | null;
}

export interface Tokhaiyte_Extend {
}

export interface Tokhaiyte_Tokhaiyte_info {
    /**
     * Mã quốc gia của người khai báo
     */
    quocgiaId?: IdValue | null;
    /**
     * Mã tỉnh của người khai báo
     */
    provinceId?: IdValue | null;
    /**
     * Mã huyện của người khai báo
     */
    districtId?: IdValue | null;
    /**
     * Mã xã của người khai báo
     */
    communeId?: IdValue | null;
    syncId?: string | null;
    /**
     * Mã user khai báo
     */
    userId?: string | null;
    /**
     * Mã y tế
     */
    medicalDeclarationId?: string | null;
    /**
     * Thời gian tạo
     */
    thoi_gian_tao?: ISODateValue | null;
    /**
     * Mã người tạo
     */
    nguoi_tao_id?: IdValue | null;
}

export interface Tokhaiyte$CustomMethodResource {
    get_provincesTKYTAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    get_locationTKYTAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    get_qr_TKYTAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    get_info_TKYTAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<Tokhaiyte>({"name":"tokhaiyte","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"_raw_http_method_get_provincesTKYT":{},"_raw_http_method_get_locationTKYT":{},"_raw_http_method_get_qr_TKYT":{},"_raw_http_method_get_info_TKYT":{}},"views":{}}, mushroom);

export interface Tv_cong_ty_lu_hanh {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Các thông tin cho hướng dẫn viên
     */
    huong_dan_vien?: Tv_cong_ty_lu_hanh_Huong_dan_vien | null;
}

export interface Tv_cong_ty_lu_hanh_Huong_dan_vien {
    /**
     * Thông tin ưu đãi
     */
    uu_dai?: Tv_cong_ty_lu_hanh_Huong_dan_vien_Uu_dai | null;
}

export interface Tv_cong_ty_lu_hanh_Huong_dan_vien_Uu_dai {
    /**
     * Loại hình ưu đãi
     */
    loai_hinh_uu_dai?: string | null;
    /**
     * Giá trị ưu đãi
     */
    gia_tri_uu_dai?: number | null;
}

defineAsyncResource<Tv_cong_ty_lu_hanh>({"name":"tv_cong_ty_lu_hanh","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true}},"views":{}}, mushroom);

export interface Tv_dich_vu {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Điểm đến an toàn id
     */
    diem_den_an_toan_id?: IdValue | null;
    /**
     * Loại dịch vụ du lịch
     */
    loai?: string | null;
    /**
     * Cho phép dịch vụ ẩn/ hiện
     */
    visible?: boolean | null;
    duyet?: Tv_dich_vu_Duyet | null;
    /**
     * Lưu trú
     */
    luu_tru?: Tv_dich_vu_Luu_tru | null;
    /**
     * Ẩm thực
     */
    am_thuc?: Tv_dich_vu_Am_thuc | null;
    /**
     * Vé điện tử
     */
    ve_dien_tu?: Tv_dich_vu_Ve_dien_tu | null;
    /**
     * Điểm đến
     */
    diem_den?: Tv_dich_vu_Diem_den | null;
    /**
     * Giải trí
     */
    giai_tri?: Tv_dich_vu_Giai_tri | null;
    thoi_gian_tao?: ISODateValue | null;
    nguoi_tao?: IdValue | null;
    /**
     * Thời gian lần sửa bản ghi cuối cùng
     */
    thoi_gian_sua_cuoi?: ISODateValue | null;
    /**
     * Mã người sửa cuối
     */
    nguoi_sua_cuoi?: IdValue | null;
    link_dich_vu?: Array<Tv_dich_vu_Link_dich_vu | null | undefined> | null;
    /**
     * Giá trị ưu đãi
     */
    uu_dai?: string | null;
    /**
     * Ngôn ngữ hiển thị. vi - Tiếng việt, en - Tiếng anh
     */
    ngon_ngu?: string | null;
    /**
     * Số lượt xem
     */
    luot_xem?: number | null;
}

export interface Tv_dich_vu_Duyet {
    /**
     * Cho biết dịch vụ đã được duyệt hay chưa. true: đã duyệt, false: từ chối, null: chờ duyệt
     */
    duoc_duyet?: boolean | null;
    /**
     * Cho biết thời điểm dịch vụ đã được duyệt hoặc từ chối
     */
    thoi_diem_duyet?: ISODateValue | null;
    /**
     * Mã người duyệt
     */
    nguoi_duyet_id?: IdValue | null;
    /**
     * Lý do từ chối
     */
    ly_do_tu_choi?: string | null;
}

export interface Tv_dich_vu_Luu_tru {
    /**
     * Tên lưu trú
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Số giường người lớn
     */
    so_giuong_nguoi_lon?: number | null;
    /**
     * Số giường trẻ em
     */
    so_giuong_tre_em?: number | null;
    /**
     * Số ngày đặt phòng
     */
    so_ngay_dat_phong?: number | null;
    /**
     * Mô tả lưu trú
     */
    mo_ta?: string | null;
    /**
     * Chi tiết lưu trú
     */
    chi_tiet?: string | null;
}

export interface Tv_dich_vu_Am_thuc {
    /**
     * Tên ẩm thực
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Mô tả ẩm thực
     */
    mo_ta?: string | null;
    /**
     * Chi tiết ẩm thực
     */
    chi_tiet?: string | null;
    /**
     * Giờ mở cửa
     */
    gio_mo_cua?: string | null;
    /**
     * Giá tiền
     */
    gia_tien?: string | null;
}

export interface Tv_dich_vu_Ve_dien_tu {
    /**
     * Tên vé điệnt tử
     */
    ten?: string | null;
    /**
     * Loại vé điện tử. air_plain_ticket: Vé máy bay, show_ticket: Vé nghệ thuật, transport_ticket: vé giao thông
     */
    loai?: string | null;
    /**
     * Đường dẫn vé điện tử
     */
    url?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
}

export interface Tv_dich_vu_Diem_den {
    /**
     * Tên điểm đến
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Giới thiệu điểm đến
     */
    mo_ta?: string | null;
    /**
     * Chi tiết điểm đến
     */
    chi_tiet?: string | null;
}

export interface Tv_dich_vu_Giai_tri {
    /**
     * Tên địa điểm giải trí
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Giới thiệu về khu giải trí
     */
    mo_ta?: string | null;
    /**
     * Chi tiết về khi giải trí
     */
    chi_tiet?: string | null;
}

export interface Tv_dich_vu_Link_dich_vu {
    /**
     * id của dịch vụ
     */
    id?: IdValue | null;
    /**
     * Tên dịch vụ
     */
    link?: string | null;
}

defineAsyncResource<Tv_dich_vu>({"name":"tv_dich_vu","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true}},"views":{}}, mushroom);

export interface Tv_dich_vu_tour {
    /**
     * Mã người dùng
     */
    id?: IdValue | null;
    /**
     * Tên tour
     */
    ten_tour?: string | null;
    /**
     * Mô tả tour
     */
    mo_ta?: string | null;
    /**
     * Chi tiết tour
     */
    chi_tiet?: string | null;
    /**
     * Thông tin chung
     */
    thong_tin_chung?: Tv_dich_vu_tour_Thong_tin_chung | null;
    /**
     * Hành trình tour
     */
    hanh_trinh?: Tv_dich_vu_tour_Hanh_trinh | null;
    duyet?: Tv_dich_vu_tour_Duyet | null;
    /**
     * id của công ty lữ hành
     */
    cong_ty_lu_hanh_id?: IdValue | null;
    thoi_gian_tao?: ISODateValue | null;
    nguoi_tao?: IdValue | null;
    /**
     * Thời gian lần sửa bản ghi cuối cùng
     */
    thoi_gian_sua_cuoi?: ISODateValue | null;
    /**
     * Mã người sửa cuối
     */
    nguoi_sua_cuoi?: IdValue | null;
    /**
     * id media
     */
    mediaId?: string | null;
    /**
     * Giá trị ưu đãi
     */
    uu_dai?: string | null;
    /**
     * Ngôn ngữ hiển thị. vi - Việt Nam, en - English
     */
    ngon_ngu?: string | null;
    /**
     * Cho biết có muốn hiển thị không
     */
    visible?: boolean | null;
    /**
     * Số lượt xem
     */
    luot_xem?: number | null;
}

export interface Tv_dich_vu_tour_Thong_tin_chung {
    /**
     * Kinh độ
     */
    kinh_do?: number | null;
    /**
     * Vĩ độ
     */
    vi_do?: number | null;
    /**
     * Đường dẫn bên Traveloka
     */
    url_traveloka?: string | null;
    /**
     * Đường dẫn bên Ivivu
     */
    url_ivivu?: string | null;
    /**
     * Đường dẫn bên Agoda
     */
    url_agoda?: string | null;
    /**
     * Đường dẫn bên Vntrip
     */
    url_vntrip?: string | null;
    /**
     * Đường dẫn bên chudu24
     */
    url_chudu24?: string | null;
    link_dich_vu?: Array<Tv_dich_vu_tour_Thong_tin_chung_Link_dich_vu | null | undefined> | null;
}

export interface Tv_dich_vu_tour_Thong_tin_chung_Link_dich_vu {
    /**
     * id của dịch vụ
     */
    id?: IdValue | null;
    /**
     * Tên dịch vụ
     */
    link?: string | null;
}

export interface Tv_dich_vu_tour_Hanh_trinh {
    /**
     * Thời gian bắt đầu
     */
    thoi_gian_bat_dau?: ISODateValue | null;
    /**
     * Thời gian kết thúc
     */
    thoi_gian_ket_thuc?: ISODateValue | null;
    /**
     * Địa điểm bắt đầu
     */
    dia_diem_bat_dau?: IdValue | null;
    /**
     * Địa điểm kết thúc
     */
    dia_diem_ket_thuc?: IdValue | null;
}

export interface Tv_dich_vu_tour_Duyet {
    /**
     * Cho biết dịch vụ đã được duyệt hay chưa. true: đã duyệt, false: từ chối, null: chờ duyệt
     */
    duoc_duyet?: boolean | null;
    /**
     * Cho biết thời điểm dịch vụ đã được duyệt hoặc từ chối
     */
    thoi_diem_duyet?: ISODateValue | null;
    /**
     * Mã người duyệt
     */
    nguoi_duyet_id?: IdValue | null;
}

defineAsyncResource<Tv_dich_vu_tour>({"name":"tv_dich_vu_tour","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true}},"views":{}}, mushroom);

export interface Tv_don_vi_cung_cap {
    /**
     * Mã điểm đến an toàn
     */
    id?: IdValue | null;
    /**
     * Loại dịch vụ của đơn vị cung cấp
     */
    loai?: string | null;
    /**
     * Dữ liệu khai báo khi đăng ký điểm đến an toàn
     */
    du_lieu_khai_bao?: Tv_don_vi_cung_cap_Du_lieu_khai_bao | null;
    duyet?: Tv_don_vi_cung_cap_Duyet | null;
    /**
     * Lưu trú
     */
    luu_tru?: Tv_don_vi_cung_cap_Luu_tru | null;
    /**
     * Ẩm thực
     */
    am_thuc?: Tv_don_vi_cung_cap_Am_thuc | null;
    /**
     * Vé điện tử
     */
    ve_dien_tu?: Tv_don_vi_cung_cap_Ve_dien_tu | null;
    /**
     * Điểm đến
     */
    diem_den?: Tv_don_vi_cung_cap_Diem_den | null;
    /**
     * Giải trí
     */
    giai_tri?: Tv_don_vi_cung_cap_Giai_tri | null;
    /**
     * Vận tải khách
     */
    van_tai_khach?: Tv_don_vi_cung_cap_Van_tai_khach | null;
    /**
     * Lữ hành nội địa
     */
    lu_hanh_noi_dia?: Tv_don_vi_cung_cap_Lu_hanh_noi_dia | null;
    /**
     * Lữ hành quốc tế
     */
    lu_hanh_quoc_te?: Tv_don_vi_cung_cap_Lu_hanh_quoc_te | null;
    /**
     * Khu du lịch
     */
    khu_du_lich?: Tv_don_vi_cung_cap_Khu_du_lich | null;
    /**
     * Điểm du lịch
     */
    diem_du_lich?: Tv_don_vi_cung_cap_Diem_du_lich | null;
    /**
     * Điểm mua sắm
     */
    diem_mua_sam?: Tv_don_vi_cung_cap_Diem_mua_sam | null;
    /**
     * Cơ quan quản lý nhà nước
     */
    co_quan_nha_nuoc?: Tv_don_vi_cung_cap_Co_quan_nha_nuoc | null;
    /**
     * Dịch vụ liên quan khác phục vụ khách du lịch
     */
    dich_vu_khac?: Tv_don_vi_cung_cap_Dich_vu_khac | null;
    thoi_gian_tao?: ISODateValue | null;
    nguoi_tao?: IdValue | null;
    /**
     * Thời gian lần sửa bản ghi cuối cùng
     */
    thoi_gian_sua_cuoi?: ISODateValue | null;
    /**
     * Mã người sửa cuối
     */
    nguoi_sua_cuoi?: IdValue | null;
}

export interface Tv_don_vi_cung_cap_Du_lieu_khai_bao {
    /**
     * account của điểm đến
     */
    user_account?: string | null;
    /**
     * user_ten của điểm đến
     */
    user_ten?: string | null;
    /**
     * dia_chi_tinh_id của điểm đến
     */
    dia_chi_tinh_id?: IdValue | null;
}

export interface Tv_don_vi_cung_cap_Duyet {
    /**
     * Cho biết dịch vụ đã được duyệt hay chưa. true: đã duyệt, false: từ chối, null: chờ duyệt
     */
    duoc_duyet?: boolean | null;
    /**
     * Cho biết thời điểm dịch vụ đã được duyệt hoặc từ chối
     */
    thoi_diem_duyet?: ISODateValue | null;
    /**
     * Mã người duyệt
     */
    nguoi_duyet_id?: IdValue | null;
    /**
     * Lý do từ chối
     */
    ly_do_tu_choi?: string | null;
}

export interface Tv_don_vi_cung_cap_Luu_tru {
    /**
     * Số sao
     */
    so_sao?: number | null;
}

export interface Tv_don_vi_cung_cap_Am_thuc {
    dich_vu?: Array<IdValue | null | undefined> | null;
}

export interface Tv_don_vi_cung_cap_Ve_dien_tu {
    /**
     * Loại vé điện tử. air_plain_ticket: Vé máy bay, show_ticket: Vé nghệ thuật, transport_ticket: vé giao thông
     */
    loai?: string | null;
}

export interface Tv_don_vi_cung_cap_Diem_den {
}

export interface Tv_don_vi_cung_cap_Giai_tri {
}

export interface Tv_don_vi_cung_cap_Van_tai_khach {
}

export interface Tv_don_vi_cung_cap_Lu_hanh_noi_dia {
}

export interface Tv_don_vi_cung_cap_Lu_hanh_quoc_te {
}

export interface Tv_don_vi_cung_cap_Khu_du_lich {
}

export interface Tv_don_vi_cung_cap_Diem_du_lich {
}

export interface Tv_don_vi_cung_cap_Diem_mua_sam {
}

export interface Tv_don_vi_cung_cap_Co_quan_nha_nuoc {
}

export interface Tv_don_vi_cung_cap_Dich_vu_khac {
}

defineAsyncResource<Tv_don_vi_cung_cap>({"name":"tv_don_vi_cung_cap","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true}},"views":{}}, mushroom);

export interface Thedulich {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Thông tin cá nhân
     */
    thong_tin_ca_nhan?: Thedulich_Thong_tin_ca_nhan | null;
    /**
     * Số cmnd/cccd
     */
    cmnd?: Thedulich_Cmnd | null;
    /**
     * Hộ chiếu
     */
    passport?: Thedulich_Passport | null;
    /**
     * Verify
     */
    verify?: Thedulich_Verify | null;
    /**
     * Thông tin thẻ
     */
    card?: Thedulich_Card | null;
    /**
     * Thông tin người giám hộ
     */
    nguoi_giam_ho?: Thedulich_Nguoi_giam_ho | null;
    /**
     * Thời gian tạo
     */
    thoi_gian_tao?: ISODateValue | null;
}

export interface Thedulich_Thong_tin_ca_nhan {
    /**
     * Tên khách du lịch
     */
    first_name?: string | null;
    /**
     * Họ tên đệm khách du lịch
     */
    last_name?: string | null;
    /**
     * Ngày sinh
     */
    dob?: ISODateValue | null;
    /**
     * Giới tính. 1- nữ, 2- nam
     */
    gender?: number | null;
    /**
     * Email khách du lịch
     */
    email?: string | null;
    /**
     * Số điện thoại khách du lịch
     */
    dien_thoai?: string | null;
    /**
     * Dân tộc của khách du lịch
     */
    dan_toc?: string | null;
    /**
     * Nơi làm việc
     */
    noi_lam_viec?: string | null;
    /**
     * Ảnh chân dung
     */
    anh_chan_dung?: IdValue | null;
    /**
     * Địa chỉ hiện tại
     */
    dia_chi_hien_tai?: Thedulich_Thong_tin_ca_nhan_Dia_chi_hien_tai | null;
}

export interface Thedulich_Thong_tin_ca_nhan_Dia_chi_hien_tai {
    /**
     * Id của tỉnh theo địa chỉ hiện tại
     */
    province_id?: IdValue | null;
    /**
     * Id của huyện theo địa chỉ hiện tại
     */
    district_id?: IdValue | null;
    /**
     * Id của xã theo địa chỉ hiện tại
     */
    commune_id?: IdValue | null;
    /**
     * Mã tỉnh theo địa chỉ hiện tại
     */
    province_code?: string | null;
    /**
     * Mã huyện theo địa chỉ hiện tại
     */
    district_code?: string | null;
    /**
     * Mã xã theo địa chỉ hiện tại
     */
    commune_code?: string | null;
    /**
     * Tên tỉnh theo địa chỉ hiện tại
     */
    ten_tinh?: string | null;
    /**
     * Tên huyện theo địa chỉ hiện tại
     */
    ten_huyen?: string | null;
    ten_xa?: string | null;
    /**
     * Địa chỉ hiện tại
     */
    dia_chi?: string | null;
}

export interface Thedulich_Cmnd {
    /**
     * Số thẻ cmnd/cccd
     */
    so_the?: string | null;
    /**
     * Ngày cấp cmnd/cccd
     */
    ngay_cap?: ISODateValue | null;
    /**
     * Ngày hết hạn cmnd/cccd
     */
    ngay_het_han?: ISODateValue | null;
    /**
     * Nơi cấp cmnd/cccd
     */
    noi_cap?: string | null;
    /**
     * Ảnh cmnd/cccd mặt trước
     */
    anh_cmnd_mat_truoc?: IdValue | null;
    /**
     * Ảnh cmnd/cccd mặt sau
     */
    anh_cmnd_mat_sau?: IdValue | null;
    /**
     * Địa chỉ
     */
    dia_chi?: Thedulich_Cmnd_Dia_chi | null;
}

export interface Thedulich_Cmnd_Dia_chi {
    /**
     * Id của tỉnh theo cmnd/cccd
     */
    province_id?: IdValue | null;
    /**
     * Id của huyện theo cmnd/cccd
     */
    district_id?: IdValue | null;
    /**
     * Id của xã theo cmnd/cccd
     */
    commune_id?: IdValue | null;
    /**
     * Mã tỉnh theo cmnd/cccd
     */
    province_code?: string | null;
    /**
     * Mã huyện theo cmnd/cccd
     */
    district_code?: string | null;
    /**
     * Mã xã theo cmnd/cccd
     */
    commune_code?: string | null;
    /**
     * Tên tỉnh theo cmnd/cccd
     */
    ten_tinh?: string | null;
    /**
     * Tên huyện theo cmnd/cccd
     */
    ten_huyen?: string | null;
    /**
     * Tên xã theo cmnd/cccd
     */
    ten_xa?: string | null;
    /**
     * Địa chỉ theo cmnd/cccd
     */
    dia_chi?: string | null;
}

export interface Thedulich_Passport {
    /**
     * Số thẻ hộ chiếu
     */
    so_the?: string | null;
    /**
     * Mã quốc gia trên passport
     */
    national_code?: string | null;
    /**
     * Tên quốc gia trên passport
     */
    ten_quoc_gia?: string | null;
    /**
     * Ngày cấp passport
     */
    ngay_cap?: ISODateValue | null;
    /**
     * Ngày hết hạn passport
     */
    ngay_het_han?: ISODateValue | null;
    /**
     * Ảnh passport mặt ngoài
     */
    anh_passport_mat_ngoai?: IdValue | null;
    /**
     * Ảnh passport mặt trong
     */
    anh_passport_mat_trong?: IdValue | null;
}

export interface Thedulich_Verify {
    /**
     * Mã kết quả verify khuôn mặt của VVN
     */
    ma_verify?: string | null;
    /**
     * Tỉ lệ giống nhau khi verify khuôn mặt của VVN
     */
    ti_le_verify?: number | null;
}

export interface Thedulich_Card {
    /**
     * Số thẻ
     */
    card_code?: string | null;
    /**
     * Mã chủ thẻ
     */
    people_code?: string | null;
    /**
     * Bank card code
     */
    bank_card_code?: string | null;
    /**
     * Mật khẩu thẻ
     */
    password?: string | null;
}

export interface Thedulich_Nguoi_giam_ho {
    /**
     * Mã chủ thẻ người giám hộ
     */
    ma_the?: string | null;
    /**
     * Quan hệ với người giám hộ
     */
    quan_he?: string | null;
}

export interface Thedulich$CustomMethodResource {
    voice_livenessAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    check_exist_cccd_dienthoaiAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    create_thedulich_hdvAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    acs_otpAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    cos_verify_otpAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    cos_register_issue_cardAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    cos_register_issue_card_hdvAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    cos_get_nguoi_duoc_giam_hoAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    cos_get_info_by_card_or_serviceAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    cos_people_register_userAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    cos_people_vst_ekycAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    cos_people_get_tqrcodeAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    cos_people_check_qrcode_expirationAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    cos_people_check_qrcodeAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    vps_paymentAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    vps_update_log_paymentAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    vps_payment_account_payAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    check_discount_for_tour_guideAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    cos_get_my_cardAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    cos_order_request_cardAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    aos_link_request_requestAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    aos_link_request_confirmAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    aos_link_account_unlinkAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    aos_account_get_bank_balance_for_peopleAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    aos_account_get_by_cardAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    ckt_cashin_requestAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    ckt_cashin_confirmAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    vps_merchant_requestAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    vps_merchant_callbackAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    vps_merchant_callback_tokenAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    cos_card_request_request_openAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    cos_card_request_callback_requestAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    cos_card_request_callback_tokenAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    cos_card_get_cards_by_peopleAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    pms_get_placeAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    agm_get_guideAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    agm_suggest_searchAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    agm_guide_get_audio_urlAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    ckt_cashin_request_pvcAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    ckt_cashin_recharge_pvcAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    agm_guide_integration_registerAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    agm_guide_integration_updateAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    agm_guide_integration_change_lockAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    agm_guide_integration_deleteAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    agm_guide_create_image_albumAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    agm_guide_translation_deleteAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    agm_image_get_by_guideAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    agm_audio_integration_registerAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    agm_place_integration_registerAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    vps_lucky_draw_get_my_codeAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    referralPushNotificationAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    cos_people_get_introAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    cos_lucky_draw_get_by_peopleAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    vps_merchant_generate_qrAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    cos_people_get_agent_inforAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    cos_people_gen_bank_contractAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    vps_payment_historyAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
export interface Thedulich$ViewsResource_cos_card_get_my_cardView_UserParameters {};
export interface Thedulich$ViewsResource_aos_link_account_get_viewView_UserParameters {
    /**
     * Mã thẻ
     */
    card_code: string;
};
export interface Thedulich$ViewsResource_aos_bank_getView_UserParameters {};
export interface Thedulich$ViewsResource {
    views: {
        cos_card_get_my_cardAsync: MushroomViewFunction<any, Thedulich$ViewsResource_cos_card_get_my_cardView_UserParameters>;
        aos_link_account_get_viewAsync: MushroomViewFunction<any, Thedulich$ViewsResource_aos_link_account_get_viewView_UserParameters>;
        aos_bank_getAsync: MushroomViewFunction<any, Thedulich$ViewsResource_aos_bank_getView_UserParameters>;
    }
}
defineAsyncResource<Thedulich>({"name":"thedulich","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"_raw_http_method_voice_liveness":{},"_raw_http_method_check_exist_cccd_dienthoai":{},"_raw_http_method_create_thedulich_hdv":{},"_raw_http_method_acs_otp":{},"_raw_http_method_cos_verify_otp":{},"_raw_http_method_cos_register_issue_card":{},"_raw_http_method_cos_register_issue_card_hdv":{},"_raw_http_method_cos_get_nguoi_duoc_giam_ho":{},"_raw_http_method_cos_get_info_by_card_or_service":{},"_raw_http_method_cos_people_register_user":{},"_raw_http_method_cos_people_vst_ekyc":{},"_raw_http_method_cos_people_get_tqrcode":{},"_raw_http_method_cos_people_check_qrcode_expiration":{},"_raw_http_method_cos_people_check_qrcode":{},"_raw_http_method_vps_payment":{},"_raw_http_method_vps_update_log_payment":{},"_raw_http_method_vps_payment_account_pay":{},"_raw_http_method_check_discount_for_tour_guide":{},"_raw_http_method_cos_get_my_card":{},"_raw_http_method_cos_order_request_card":{},"_raw_http_method_aos_link_request_request":{},"_raw_http_method_aos_link_request_confirm":{},"_raw_http_method_aos_link_account_unlink":{},"_raw_http_method_aos_account_get_bank_balance_for_people":{},"_raw_http_method_aos_account_get_by_card":{},"_raw_http_method_ckt_cashin_request":{},"_raw_http_method_ckt_cashin_confirm":{},"_raw_http_method_vps_merchant_request":{},"_raw_http_method_vps_merchant_callback":{},"_raw_http_method_vps_merchant_callback_token":{},"_raw_http_method_cos_card_request_request_open":{},"_raw_http_method_cos_card_request_callback_request":{},"_raw_http_method_cos_card_request_callback_token":{},"_raw_http_method_cos_card_get_cards_by_people":{},"_raw_http_method_pms_get_place":{},"_raw_http_method_agm_get_guide":{},"_raw_http_method_agm_suggest_search":{},"_raw_http_method_agm_guide_get_audio_url":{},"_raw_http_method_ckt_cashin_request_pvc":{},"_raw_http_method_ckt_cashin_recharge_pvc":{},"_raw_http_method_agm_guide_integration_register":{},"_raw_http_method_agm_guide_integration_update":{},"_raw_http_method_agm_guide_integration_change_lock":{},"_raw_http_method_agm_guide_integration_delete":{},"_raw_http_method_agm_guide_create_image_album":{},"_raw_http_method_agm_guide_translation_delete":{},"_raw_http_method_agm_image_get_by_guide":{},"_raw_http_method_agm_audio_integration_register":{},"_raw_http_method_agm_place_integration_register":{},"_raw_http_method_vps_lucky_draw_get_my_code":{},"_raw_http_method_referralPushNotification":{},"_raw_http_method_cos_people_get_intro":{},"_raw_http_method_cos_lucky_draw_get_by_people":{},"_raw_http_method_vps_merchant_generate_qr":{},"_raw_http_method_cos_people_get_agent_infor":{},"_raw_http_method_cos_people_gen_bank_contract":{},"_raw_http_method_vps_payment_history":{}},"views":{"cos_card_get_my_card":{"clientCache":true},"aos_link_account_get_view":{"clientCache":true},"aos_bank_get":{"clientCache":true}}}, mushroom);

export interface Log_register_user {
    /**
     * Mã tự động
     */
    id?: IdValue | null;
    /**
     * Số điện thoại đăng ký
     */
    dien_thoai?: string | null;
    /**
     * Mã giới thiệu
     */
    ma_gioi_thieu?: string | null;
    /**
     * Password
     */
    password?: string | null;
    /**
     * Mã người dùng
     */
    people_code?: string | null;
    /**
     * Thời điểm tạo
     */
    thoi_diem_tao?: ISODateValue | null;
    /**
     * Bước thực hiện đăng ký tài khoản du lịch. 1 - Đăng ký tài khoản du lịch. 2 - Ekyc thành công
     */
    buoc_thuc_hien?: number | null;
    /**
     * Thời điểm cập nhật cuối
     */
    thoi_diem_cap_nhat_cuoi?: ISODateValue | null;
}

defineAsyncResource<Log_register_user>({"name":"log_register_user","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true}},"views":{}}, mushroom);

export interface Log_payment {
    /**
     * Mã thanh toán
     */
    id?: IdValue | null;
    /**
     * Trạng thái
     */
    trang_thai?: string | null;
    /**
     * Tiền
     */
    tien?: number | null;
    /**
     * Phí
     */
    phi?: number | null;
    /**
     * Nội dung
     */
    noi_dung?: string | null;
    /**
     * Loại ưu đãi
     */
    loai_uu_dai?: string | null;
    /**
     * Giá trị ưu đãi
     */
    gia_tri_uu_dai?: number | null;
    /**
     * Mã người dùng
     */
    user_id?: IdValue | null;
    /**
     * Card code
     */
    card_code?: string | null;
    /**
     * Số tiền chiết khấu
     */
    discount_amount?: Log_payment_Discount_amount | null;
    /**
     * Service code
     */
    service_code?: string | null;
    /**
     * Mã giao dịch QR code
     */
    order_id?: string | null;
    /**
     * Danh sách mã ảnh
     */
    image_ids?: Array<IdValue | null | undefined> | null;
    /**
     * Merchant code
     */
    merchant_code?: string | null;
    /**
     * Client code
     */
    client_code?: string | null;
    /**
     * Thời điểm tạo
     */
    created_time?: ISODateValue | null;
    /**
     * Client request body string
     */
    client_request_data?: string | null;
    /**
     * Thời điểm gửi sang vps
     */
    sendTime?: ISODateValue | null;
    /**
     * Vps request body string
     */
    vps_request_data?: string | null;
    /**
     * Thời điểm nhận response
     */
    responseTime?: ISODateValue | null;
    /**
     * Vps response body code
     */
    vps_response_code?: number | null;
    /**
     * Vps response body string
     */
    vps_response_data?: string | null;
    /**
     * Mã thanh toán
     */
    paymentCode?: string | null;
}

export interface Log_payment_Discount_amount {
    /**
     * Số tiền chiết khấu, tích điểm cho thẻ du lịch
     */
    travel_card?: number | null;
    /**
     * Số tiền chiết khấu cho HDV dẫn khách
     */
    tour_guide?: number | null;
}

defineAsyncResource<Log_payment>({"name":"log_payment","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true}},"views":{}}, mushroom);

export interface Gotadi {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
}

export interface Gotadi$CustomMethodResource {
    get_webview_urlAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    get_user_infoAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    get_gotadi_sso_urlAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    search_airportsAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    air_tickets_low_fare_searchAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    air_tickets_filter_optionsAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    air_tickets_filter_availabilityAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    air_tickets_filter_group_itinerary_findByIdAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    air_tickets_farerulesAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    air_tickets_revalidateAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    air_tickets_draft_bookingAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    products_booking_detailAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    air_tickets_ssr_offer_findBy_booking_numberAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    air_tickets_add_booking_travellerAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    booking_searchAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    partner_query_transAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    purchaseAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<Gotadi>({"name":"gotadi","actions":{"_raw_http_method_get_webview_url":{},"_raw_http_method_get_user_info":{},"_raw_http_method_get_gotadi_sso_url":{},"_raw_http_method_search_airports":{},"_raw_http_method_air_tickets_low_fare_search":{},"_raw_http_method_air_tickets_filter_options":{},"_raw_http_method_air_tickets_filter_availability":{},"_raw_http_method_air_tickets_filter_group_itinerary_findById":{},"_raw_http_method_air_tickets_farerules":{},"_raw_http_method_air_tickets_revalidate":{},"_raw_http_method_air_tickets_draft_booking":{},"_raw_http_method_products_booking_detail":{},"_raw_http_method_air_tickets_ssr_offer_findBy_booking_number":{},"_raw_http_method_air_tickets_add_booking_traveller":{},"_raw_http_method_booking_search":{},"_raw_http_method_partner_query_trans":{},"_raw_http_method_purchase":{}},"views":{}}, mushroom);

export interface Hotel {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Id đặt phòng
     */
    booking_id?: number | null;
    /**
     * Số đặt phòng
     */
    booking_no?: string | null;
    /**
     * Email khách du lịch
     */
    cust_email?: string | null;
    /**
     * Điện thoại khách du lịch
     */
    cust_phone?: string | null;
    /**
     * Tên khách du lịch
     */
    cust_name?: string | null;
    /**
     * Số lượng người lớn
     */
    adult?: number | null;
    /**
     * Số lượng trẻ em
     */
    child?: number | null;
    /**
     * Id công ty
     */
    company_id?: string | null;
    /**
     * Tên công ty
     */
    company_name?: string | null;
    /**
     * Id điểm đến
     */
    company_gp_id?: IdValue | null;
    /**
     * Số thẻ khách du lịch
     */
    theviet_id?: string | null;
    /**
     * Ngày tạo
     */
    created_date?: ISODateValue | null;
    /**
     * Ngày bắt đầu thuê
     */
    from_date?: ISODateValue | null;
    /**
     * Ngày kết thúc thuê
     */
    to_date?: ISODateValue | null;
    /**
     * Là giá trị room_categ_id, được lấy từ kết quả trả về của “API Check Room
     */
    rid?: number | null;
    /**
     * Tổng tiền
     */
    total_money?: number | null;
    /**
     * Vị trí
     */
    location?: string | null;
    /**
     * Tên loại phòng
     */
    categ_name?: string | null;
    /**
     * Ảnh phòng
     */
    image?: string | null;
    /**
     * Thông tin response
     */
    response_data?: string | null;
}

export interface Hotel$CustomMethodResource {
    auth_app_loginAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    checkroomAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    room_bookingAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    room_cancelAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    room_checkinAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    push_notificationAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
export interface Hotel$ViewsResource_booking_historyView_UserParameters {
    /**
     * Số thẻ khách du lịch
     */
    card_code?: string | null;
};
export interface Hotel$ViewsResource {
    views: {
        booking_historyAsync: MushroomViewFunction<any, Hotel$ViewsResource_booking_historyView_UserParameters>;
    }
}
defineAsyncResource<Hotel>({"name":"hotel","actions":{"_raw_http_method_auth_app_login":{},"_raw_http_method_checkroom":{},"_raw_http_method_room_booking":{},"_raw_http_method_room_cancel":{},"_raw_http_method_room_checkin":{},"_raw_http_method_push_notification":{}},"views":{"booking_history":{"clientCache":true}}}, mushroom);

export interface Van_mieu {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã người mua vé
     */
    user_id?: IdValue | null;
    /**
     * Thời điểm tạo
     */
    created_time?: ISODateValue | null;
    /**
     * Loại vé
     */
    type?: string | null;
    /**
     * Số lượng vé
     */
    amount?: number | null;
    /**
     * Card code
     */
    card_code?: string | null;
    /**
     * Mã payment
     */
    payment_id?: IdValue | null;
    /**
     * Mã serial_number của vé
     */
    serial_number?: string | null;
    /**
     * JSON dữ liệu chi tiết
     */
    data?: string | null;
}

export interface Van_mieu$CustomMethodResource {
    vtq_ticket_guest_printAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    get_ticketAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    vtq_ticket_get_by_peopleAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    vtq_ticket_get_my_ticketAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    vtq_visit_place_get_inforAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    vtq_ticket_people_change_effectiveAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    vtq_einvoice_lookupAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    vtq_einvoice_lookup_export_pdfAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    translate_languageAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    vtq_white_list_get_my_peopleAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    vtq_white_list_registerAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    vtq_white_list_rechargeAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    vtq_white_list_cancelAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    vtq_tity_place_get_ticket_typeAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    vtq_tity_place_get_ticket_infoAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    pms_get_ticket_placesAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<Van_mieu>({"name":"van_mieu","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"_raw_http_method_vtq_ticket_guest_print":{},"_raw_http_method_get_ticket":{},"_raw_http_method_vtq_ticket_get_by_people":{},"_raw_http_method_vtq_ticket_get_my_ticket":{},"_raw_http_method_vtq_visit_place_get_infor":{},"_raw_http_method_vtq_ticket_people_change_effective":{},"_raw_http_method_vtq_einvoice_lookup":{},"_raw_http_method_vtq_einvoice_lookup_export_pdf":{},"_raw_http_method_translate_language":{},"_raw_http_method_vtq_white_list_get_my_people":{},"_raw_http_method_vtq_white_list_register":{},"_raw_http_method_vtq_white_list_recharge":{},"_raw_http_method_vtq_white_list_cancel":{},"_raw_http_method_vtq_tity_place_get_ticket_type":{},"_raw_http_method_vtq_tity_place_get_ticket_info":{},"_raw_http_method_pms_get_ticket_places":{}},"views":{}}, mushroom);

export interface Van_mieu_booking {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã người dùng
     */
    user_id?: IdValue | null;
    /**
     * Mã địa điểm
     */
    place_code?: string | null;
    /**
     * Loại vé
     */
    ticket_type?: string | null;
    /**
     * Số lượng vé
     */
    ticket_count?: number | null;
    /**
     * Số tiền
     */
    amount?: number | null;
    /**
     * Mã thanh toán
     */
    payment_id?: IdValue | null;
    /**
     * Thông tin vé
     */
    ticket_id?: IdValue | null;
    /**
     * Thời điểm tạo
     */
    created_time?: ISODateValue | null;
}

defineAsyncResource<Van_mieu_booking>({"name":"van_mieu_booking","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{}},"views":{}}, mushroom);

export interface Vnpt_qn_ve_dien_tu {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã yêu cầu
     */
    request_code?: string | null;
    /**
     * Mã người mua vé
     */
    user_id?: IdValue | null;
    /**
     * Thời điểm tạo
     */
    created_time?: ISODateValue | null;
    /**
     * Tên người mua
     */
    ten_nguoi_mua?: string | null;
    /**
     * Mã số thuế
     */
    ma_so_thue?: string | null;
    /**
     * Địa chỉ
     */
    dia_chi?: string | null;
    /**
     * Ngân hàng
     */
    ngan_hang?: string | null;
    /**
     * Số tài khoản
     */
    so_tai_khoan?: string | null;
    /**
     * Số tài khoản
     */
    thoi_gian_het_han?: ISODateValue | null;
    /**
     * Mã thanh toán
     */
    payment_id?: IdValue | null;
    /**
     * Danh sách thông tin chi tiết vé
     */
    chi_tiet_ves?: Array<Vnpt_qn_ve_dien_tu_Chi_tiet_ves | null | undefined> | null;
}

export interface Vnpt_qn_ve_dien_tu_Chi_tiet_ves {
    /**
     * Id vé
     */
    ve_id?: string | null;
    /**
     * Mã vé
     */
    ma_ve?: string | null;
    /**
     * Tên vé
     */
    ten_ve?: string | null;
    /**
     * Số lượng vé
     */
    so_luong?: number | null;
    /**
     * Thời gian sử dụng vé
     */
    thoi_gian_su_dung?: ISODateValue | null;
    /**
     * Cho biết vé đã được sử dụng hay chưa
     */
    is_su_dung?: boolean | null;
    /**
     * Thời gian hết hạn vé
     */
    thoi_gian_het_han?: ISODateValue | null;
    /**
     * Thời gian mua vé
     */
    thoi_gian_mua?: ISODateValue | null;
}

export interface Vnpt_qn_ve_dien_tu$CustomMethodResource {
    tickets_onlineAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    create_ticket_onlineAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    get_ticket_onlineAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    view_ticket_receiptAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
export interface Vnpt_qn_ve_dien_tu$ViewsResource_ticket_historyView_UserParameters {
    /**
     * Id người dùng khách du lịch
     */
    user_id?: string | null;
};
export interface Vnpt_qn_ve_dien_tu$ViewsResource {
    views: {
        ticket_historyAsync: MushroomViewFunction<any, Vnpt_qn_ve_dien_tu$ViewsResource_ticket_historyView_UserParameters>;
    }
}
defineAsyncResource<Vnpt_qn_ve_dien_tu>({"name":"vnpt_qn_ve_dien_tu","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"_raw_http_method_tickets_online":{},"_raw_http_method_create_ticket_online":{},"_raw_http_method_get_ticket_online":{},"_raw_http_method_view_ticket_receipt":{}},"views":{"ticket_history":{"clientCache":true}}}, mushroom);

export interface Log_infor_visit_place {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Thời điểm tạo
     */
    created_time?: ISODateValue | null;
    /**
     * Thời điểm update
     */
    updated_time?: ISODateValue | null;
    /**
     * Mã điểm tham quan
     */
    place_code?: string | null;
    /**
     * Tên điểm tham quan
     */
    place_name?: string | null;
    /**
     * Dùng để cấu hình thanh toán bằng thẻ khi mua trực tiếp tại điểm
     */
    is_using_card?: boolean | null;
    /**
     * Nếu là điểm dùng vé định dạnh yêu cầu người dùng nhập thông tin người mua vé 
     */
    is_identity_ticket?: boolean | null;
    /**
     * Bắt buộc chọn ngày sử dụng (ngày hiệu lực) nếu điểm tham quan có ticket_option = 2
     */
    ticket_option?: number | null;
    /**
     * Số tiền phí khi thực hiện đổi ngày hiệu lực vé
     */
    effective_fee_amount?: string | null;
    /**
     * Tỷ lệ phí khi thực hiện đổi ngày hiệu lực vé
     */
    effective_fee_ratio?: string | null;
    /**
     * Số tiền phí khi thực hiện hủy vé
     */
    cancel_fee_amount?: string | null;
    /**
     * Tỷ lệ phí khi thực hiện hủy vé
     */
    cancel_fee_ratio?: string | null;
    /**
     * Giá vé
     */
    normal_ticket_price?: string | null;
    /**
     * JSON dữ liệu chi tiết
     */
    data?: string | null;
}

export interface Log_infor_visit_place$CustomMethodResource {
    find_by_place_codeAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<Log_infor_visit_place>({"name":"log_infor_visit_place","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"_raw_http_method_find_by_place_code":{}},"views":{}}, mushroom);

export interface Doanh_nghiep {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã số thuế/Mã số doanh nghiệp
     */
    so_giay_to?: string | null;
    /**
     * Số điện thoại doanh nghiệp
     */
    dien_thoai?: string | null;
    /**
     * Email doanh nghiệp
     */
    email?: string | null;
    /**
     * Thông tin hoạt động
     */
    hoat_dong?: Doanh_nghiep_Hoat_dong | null;
    /**
     * Loại hình doanh nghiệp
     */
    loai_hinh?: string | null;
    /**
     * Thông tin chung
     */
    thong_tin_chung?: Doanh_nghiep_Thong_tin_chung | null;
    /**
     * Thông tin quản lý
     */
    thong_tin_quan_ly?: Doanh_nghiep_Thong_tin_quan_ly | null;
    /**
     * Thông tin người đại diện
     */
    nguoi_dai_dien?: Doanh_nghiep_Nguoi_dai_dien | null;
    /**
     * Thông tin người điều hành, người quản lý
     */
    nguoi_dieu_hanh?: Doanh_nghiep_Nguoi_dieu_hanh | null;
    /**
     * Thị trường khách
     */
    thi_truong_khach?: Array<Doanh_nghiep_Thi_truong_khach | null | undefined> | null;
    /**
     * Thông tin cơ sở lưu trú
     */
    co_so_luu_tru?: Doanh_nghiep_Co_so_luu_tru | null;
    /**
     * Cơ sở vật chất kỹ thuật
     */
    co_so_vat_chat?: Doanh_nghiep_Co_so_vat_chat | null;
    /**
     * Dịch vụ cung cấp
     */
    dich_vu?: Array<string | null | undefined> | null;
    /**
     * Thông tin nhân sự
     */
    nhan_su?: Doanh_nghiep_Nhan_su | null;
    /**
     * Mã người tạo
     */
    nguoi_tao_id?: IdValue | null;
    /**
     * Thời điểm tạo
     */
    thoi_diem_tao?: ISODateValue | null;
    /**
     * Thời điểm cập nhật cuối
     */
    thoi_diem_cap_nhat_cuoi?: ISODateValue | null;
    /**
     * Danh sách id file ảnh, video, logo
     */
    album?: Array<Doanh_nghiep_Album | null | undefined> | null;
}

export interface Doanh_nghiep_Hoat_dong {
    /**
     * Cho biết đơn vị có đang ngừng hoạt động hay không. Mặc định là đang hoạt động
     */
    ngung_hoat_dong?: boolean | null;
    /**
     * Thời điểm ngừng hoạt động/hoạt động trở lại (gần nhất) - Do người dùng SafePlace đổi
     */
    thoi_diem_thay_doi_cuoi?: ISODateValue | null;
    /**
     * Lịch sử các lần thay đổi trạng thái hoạt động
     */
    lich_su_thay_doi?: Array<Doanh_nghiep_Hoat_dong_Lich_su_thay_doi | null | undefined> | null;
}

export interface Doanh_nghiep_Hoat_dong_Lich_su_thay_doi {
    /**
     * Cho biết có phải trạng thái thay đổi về ngừng hoạt động hay không
     */
    ngung_hoat_dong?: boolean | null;
    /**
     * Thời điểm thay đổi
     */
    thoi_diem?: ISODateValue | null;
    /**
     * Mã người thay đổi
     */
    nguoi_thay_doi_id?: IdValue | null;
}

export interface Doanh_nghiep_Thong_tin_chung {
    /**
     * Tên Tỉnh/Thành phố
     */
    tinh_thanh?: string | null;
    /**
     * Tên tiếng việt
     */
    ten_vi?: string | null;
    /**
     * Tên tiếng anh
     */
    ten_en?: string | null;
    /**
     * Tên viết tắt
     */
    ten_tat?: string | null;
    /**
     * Mã ảnh đại diện trên hệ thống
     */
    anh?: IdValue | null;
    /**
     * Thông tin giấy tờ
     */
    giay_to?: Array<Doanh_nghiep_Thong_tin_chung_Giay_to | null | undefined> | null;
    /**
     * Thông tin liên hệ
     */
    lien_he?: Doanh_nghiep_Thong_tin_chung_Lien_he | null;
    /**
     * Vận tải khách du lịch
     */
    van_tai?: Doanh_nghiep_Thong_tin_chung_Van_tai | null;
    /**
     * Diện tích
     */
    dien_tich?: string | null;
    /**
     * Mô tả vị trí
     */
    mo_ta_vi_tri?: string | null;
    /**
     * Tài khoản ký quỹ
     */
    tai_khoan_ky_quy?: string | null;
    /**
     * Tên ngân hàng
     */
    ngan_hang?: string | null;
    /**
     * Cấp quản lý
     */
    cap_quan_ly?: string | null;
    /**
     * Quyết định xếp hạng
     */
    quyet_dinh_xep_hang?: Doanh_nghiep_Thong_tin_chung_Quyet_dinh_xep_hang | null;
    /**
     * Thông tin đánh giá
     */
    danh_gia?: Doanh_nghiep_Thong_tin_chung_Danh_gia | null;
}

export interface Doanh_nghiep_Thong_tin_chung_Giay_to {
    /**
     * Mã số thuế/Mã số doanh nghiệp/Mã giấy phép kinh doanh
     */
    so_giay_to?: string | null;
    /**
     * Nơi cấp
     */
    noi_cap?: string | null;
    /**
     * Ngày cấp
     */
    ngay_cap?: ISODateValue | null;
    /**
     * Danh sách mã ảnh scan
     */
    scan?: Array<IdValue | null | undefined> | null;
    /**
     * Địa chỉ trên đăng ký kinh doanh
     */
    dia_chi?: string | null;
    /**
     * Loại giấy tờ
     */
    loai_giay_to?: string | null;
}

export interface Doanh_nghiep_Thong_tin_chung_Lien_he {
    /**
     * Địa chỉ
     */
    dia_chi?: string | null;
    /**
     * Điện thoại
     */
    dien_thoai?: string | null;
    /**
     * Điện thoại cố định
     */
    dien_thoai_co_dinh?: string | null;
    /**
     * Điện thoại di động
     */
    dien_thoai_di_dong?: string | null;
    /**
     * Số fax
     */
    fax?: string | null;
    /**
     * Email
     */
    email?: string | null;
    /**
     * Website
     */
    website?: string | null;
}

export interface Doanh_nghiep_Thong_tin_chung_Van_tai {
    /**
     * Phương tiện vận tải
     */
    phuong_tien?: Array<Doanh_nghiep_Thong_tin_chung_Van_tai_Phuong_tien | null | undefined> | null;
    /**
     * Giá lớn nhất
     */
    gia_max?: number | null;
    /**
     * Giá nhỏ nhất
     */
    gia_min?: number | null;
    /**
     * Hành trình
     */
    hanh_trinh?: Doanh_nghiep_Thong_tin_chung_Van_tai_Hanh_trinh | null;
    /**
     * Năng lực phục vụ
     */
    nang_luc_phuc_vu?: string | null;
    /**
     * Yêu cầu riêng
     */
    yeu_cau_rieng?: string | null;
    /**
     * Bài viết, hình ảnh, video
     */
    file_id?: IdValue | null;
}

export interface Doanh_nghiep_Thong_tin_chung_Van_tai_Phuong_tien {
    /**
     * Số thứ tự
     */
    stt?: number | null;
    /**
     * Số phương tiện
     */
    so_phuong_tien?: string | null;
    /**
     * Loại phương tiện
     */
    loai_phuong_tien?: string | null;
    /**
     * Biển số/Số hiệu phương tiện
     */
    bien_so?: string | null;
}

export interface Doanh_nghiep_Thong_tin_chung_Van_tai_Hanh_trinh {
    /**
     * Điểm đón
     */
    diem_don?: string | null;
    /**
     * Danh sách điểm dừng
     */
    diem_dung?: Array<Doanh_nghiep_Thong_tin_chung_Van_tai_Hanh_trinh_Diem_dung | null | undefined> | null;
    /**
     * Điểm trả khách
     */
    diem_tra_khach?: string | null;
}

export interface Doanh_nghiep_Thong_tin_chung_Van_tai_Hanh_trinh_Diem_dung {
    /**
     * Số thứ tự điểm dừng
     */
    stt?: number | null;
    /**
     * Vị trí điểm dừng
     */
    vi_tri?: string | null;
}

export interface Doanh_nghiep_Thong_tin_chung_Quyet_dinh_xep_hang {
    /**
     * Ngày ký
     */
    ngay_ky?: ISODateValue | null;
    /**
     * Ngày có hiệu lực
     */
    ngay_co_hieu_luc?: ISODateValue | null;
    /**
     * Xếp hạng
     */
    xep_hang?: number | null;
}

export interface Doanh_nghiep_Thong_tin_chung_Danh_gia {
    /**
     * Số sao đánh giá của người dùng
     */
    gia_tri?: number | null;
    /**
     * Nội dung đánh giá
     */
    noi_dung?: string | null;
    /**
     * Danh sách các đánh giá thành phần
     */
    thanh_phan?: Array<Doanh_nghiep_Thong_tin_chung_Danh_gia_Thanh_phan | null | undefined> | null;
    /**
     * Thời điểm tạo
     */
    thoi_diem_tao?: ISODateValue | null;
    /**
     * Lưu thông tin thêm của từng đánh giá
     */
    thong_tin_them?: Doanh_nghiep_Thong_tin_chung_Danh_gia_Thong_tin_them | null;
}

export interface Doanh_nghiep_Thong_tin_chung_Danh_gia_Thanh_phan {
    /**
     * Mã nhóm thành phần
     */
    nhom_id?: IdValue | null;
    /**
     * Giá trị đánh giá thành phần
     */
    gia_tri?: number | null;
}

export interface Doanh_nghiep_Thong_tin_chung_Danh_gia_Thong_tin_them {
    /**
     * Thong tin kpi
     */
    kpis?: Array<string | null | undefined> | null;
}

export interface Doanh_nghiep_Thong_tin_quan_ly {
    /**
     * Quyết định công nhận
     */
    quyet_dinh?: Doanh_nghiep_Thong_tin_quan_ly_Quyet_dinh | null;
    /**
     * Cấp quản lý
     */
    cap_quan_ly?: string | null;
    /**
     * Nơi quản lý
     */
    noi_quan_ly?: string | null;
    /**
     * Cơ quan quản lý
     */
    co_quan_quan_ly?: Doanh_nghiep_Thong_tin_quan_ly_Co_quan_quan_ly | null;
    /**
     * Đơn vị quản lý trực tiếp
     */
    don_vi_quan_ly?: Doanh_nghiep_Thong_tin_quan_ly_Don_vi_quan_ly | null;
    /**
     * Thông tin quy hoạch khu du lịch
     */
    quy_hoach_khu_du_lich?: string | null;
    /**
     * Đầu tư kinh doanh
     */
    dau_tu_kinh_doanh?: Doanh_nghiep_Thong_tin_quan_ly_Dau_tu_kinh_doanh | null;
    /**
     * Trạng thái hoạt động
     */
    trang_thai_hoat_dong?: boolean | null;
    /**
     * Hình thức doanh nghiệp
     */
    hinh_thuc_doanh_nghiep?: string | null;
    /**
     * Phạm vi kinh doanh
     */
    pham_vi_kinh_doanh?: string | null;
}

export interface Doanh_nghiep_Thong_tin_quan_ly_Quyet_dinh {
    /**
     * Số quyết định
     */
    so_quyet_dinh?: string | null;
    /**
     * Năm công nhận
     */
    nam_cong_nhan?: ISODateValue | null;
    /**
     * Ngày ký
     */
    ngay_ky?: ISODateValue | null;
    /**
     * Cơ quan công nhận
     */
    co_quan_cong_nhan?: string | null;
    /**
     * Thời hạn
     */
    thoi_han?: ISODateValue | null;
    /**
     * Xếp hạng
     */
    xep_hang?: string | null;
    /**
     * File quyết định
     */
    file_quyet_dinh_id?: IdValue | null;
}

export interface Doanh_nghiep_Thong_tin_quan_ly_Co_quan_quan_ly {
    /**
     * Tên cơ quan quản lý
     */
    ten_co_quan?: string | null;
    /**
     * Cấp quản lý
     */
    cap_quan_ly?: string | null;
    /**
     * Địa chỉ
     */
    dia_chi?: string | null;
    /**
     * Số điện thoại
     */
    dien_thoai?: string | null;
    /**
     * Email
     */
    email?: string | null;
    /**
     * Website
     */
    website?: string | null;
}

export interface Doanh_nghiep_Thong_tin_quan_ly_Don_vi_quan_ly {
    /**
     * Tên đơn vị
     */
    ten_don_vi?: string | null;
    /**
     * Địa chỉ
     */
    dia_chi?: string | null;
    /**
     * Điện thoại
     */
    dien_thoai?: string | null;
    /**
     * Email
     */
    email?: string | null;
    /**
     * Website
     */
    website?: string | null;
}

export interface Doanh_nghiep_Thong_tin_quan_ly_Dau_tu_kinh_doanh {
    /**
     * Tổng mức đầu tư
     */
    tong_muc_dau_tu?: number | null;
    /**
     * Thời gian khai thác
     */
    thoi_gian_khai_thac?: ISODateValue | null;
}

export interface Doanh_nghiep_Nguoi_dai_dien {
    /**
     * Họ và tên
     */
    ho_ten?: string | null;
    /**
     * Chức vụ
     */
    chuc_vu?: string | null;
    /**
     * Hộ khẩu thường chú
     */
    ho_khau_thuong_chu?: string | null;
    /**
     * Ngày sinh
     */
    ngay_sinh?: ISODateValue | null;
    /**
     * Giới tính: 1 - Nữ, 2 - Nam, 3 - Chưa có thông tin, 4 - Khác
     */
    gioi_tinh?: number | null;
    /**
     * Địa chỉ
     */
    dia_chi?: string | null;
    /**
     * Điện thoại
     */
    dien_thoai?: string | null;
    /**
     * Email
     */
    email?: string | null;
    /**
     * Dân tộc
     */
    dan_toc?: string | null;
    /**
     * Quốc tịch
     */
    quoc_tich?: string | null;
    /**
     * Số CMT/ Căn cước/ Hộ chiếu
     */
    so_giay_to?: string | null;
    /**
     * Ngày cấp CMT/ Căn cước/ Hộ chiếu
     */
    ngay_cap?: ISODateValue | null;
    /**
     * Nơi cấp CMT/ Căn cước/ Hộ chiếu
     */
    nơi_cap?: string | null;
}

export interface Doanh_nghiep_Nguoi_dieu_hanh {
    /**
     * Họ và tên
     */
    ho_ten?: string | null;
    /**
     * Chức vụ
     */
    chuc_vu?: string | null;
    /**
     * Hộ khẩu thường chú
     */
    ho_khau_thuong_chu?: string | null;
    /**
     * Ngày sinh
     */
    ngay_sinh?: ISODateValue | null;
    /**
     * Giới tính: 1 - Nữ, 2 - Nam, 3 - Chưa có thông tin, 4 - Khác
     */
    gioi_tinh?: number | null;
    /**
     * Địa chỉ
     */
    dia_chi?: string | null;
    /**
     * Điện thoại
     */
    dien_thoai?: string | null;
    /**
     * Email
     */
    email?: string | null;
    /**
     * Dân tộc
     */
    dan_toc?: string | null;
    /**
     * Quốc tịch
     */
    quoc_tich?: string | null;
    /**
     * Số CMT/ Căn cước/ Hộ chiếu
     */
    so_giay_to?: string | null;
    /**
     * Ngày cấp CMT/ Căn cước/ Hộ chiếu
     */
    ngay_cap?: ISODateValue | null;
    /**
     * Nơi cấp CMT/ Căn cước/ Hộ chiếu
     */
    nơi_cap?: string | null;
}

export interface Doanh_nghiep_Thi_truong_khach {
    /**
     * Tên khu vực
     */
    khu_vuc?: string | null;
    /**
     * Tên quốc gia
     */
    ten_nuoc?: string | null;
    /**
     * Loại thị trường
     */
    loai?: string | null;
}

export interface Doanh_nghiep_Co_so_luu_tru {
    /**
     * Cam kết giấy chứng nhận về
     */
    cam_ket_chung_nhan?: Array<string | null | undefined> | null;
    /**
     * Thời gian phục vụ
     */
    thoi_gian_phuc_vu?: Doanh_nghiep_Co_so_luu_tru_Thoi_gian_phuc_vu | null;
    /**
     * Thông tin tóm tắt
     */
    thong_tin_tom_tat?: string | null;
    /**
     * Thông tin chi tiết
     */
    thong_tin_chi_tiet?: string | null;
}

export interface Doanh_nghiep_Co_so_luu_tru_Thoi_gian_phuc_vu {
    /**
     * Thời gian mở
     */
    mo?: ISODateValue | null;
    /**
     * Thời gian đóng
     */
    dong?: ISODateValue | null;
}

export interface Doanh_nghiep_Co_so_vat_chat {
    /**
     * Tổng số phòng
     */
    tong_so_phong?: number | null;
    /**
     * Sức chứa
     */
    suc_chua?: number | null;
    /**
     * Tổng số vốn đầu tư ban đầu (vốn VND)
     */
    tong_so_von_ban_dau?: number | null;
    /**
     * Vốn ngoại tệ (nếu có)
     */
    von_ngoai_te?: number | null;
    /**
     * Tổng số vốn đầu tư nâng cấp (vốn VND)
     */
    tong_so_von_nang_cap?: number | null;
    /**
     * Tổng diện tích mặt bằng (m^2)
     */
    dien_tich_mat_bang?: number | null;
    /**
     * Tổng diện tích mặt bằng xây dựng (m^2)
     */
    dien_tich_mat_bang_xay_dung?: number | null;
}

export interface Doanh_nghiep_Nhan_su {
    /**
     * Tổng số nhân sự
     */
    tong_so?: number | null;
    /**
     * Số nhân sự ban giám đốc
     */
    ban_giam_doc?: number | null;
    /**
     * Số nhân sự lễ tân
     */
    le_tan?: number | null;
    /**
     * Số nhân sự bếp
     */
    bep?: number | null;
    /**
     * Số nhân sự bàn/bar
     */
    ban_bar?: number | null;
    /**
     * Số nhân sự bộ phận khác
     */
    bo_phan_khac?: number | null;
    /**
     * Trình độ
     */
    trinh_do?: Array<Doanh_nghiep_Nhan_su_Trinh_do | null | undefined> | null;
}

export interface Doanh_nghiep_Nhan_su_Trinh_do {
    /**
     * Số nhân sự
     */
    so_nhan_su?: number | null;
    /**
     * Loại trình độ
     */
    loai?: string | null;
}

export interface Doanh_nghiep_Album {
    /**
     * Id file ảnh, video, logo
     */
    file_id?: IdValue | null;
    /**
     * Tiêu đề
     */
    title?: string | null;
    /**
     * Nội dung bài viết
     */
    content?: string | null;
    /**
     * Ngôn ngữ hiển thị
     */
    ngon_ngu?: string | null;
    /**
     * Loại album
     */
    album_type?: string | null;
}

export interface Doanh_nghiep$CustomMethodResource {
    check_account_existAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    registerAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<Doanh_nghiep>({"name":"doanh_nghiep","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"updatePartially":{},"_raw_http_method_check_account_exist":{},"_raw_http_method_register":{}},"views":{}}, mushroom);

export interface Dang_ky_trang_vang {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Thông tin mã yêu cầu
     */
    request_id?: string | null;
    /**
     * Thông tin đơn vị
     */
    thong_tin_don_vi?: Dang_ky_trang_vang_Thong_tin_don_vi | null;
    /**
     * Ảnh điểm đến
     */
    anh_diem_den?: Dang_ky_trang_vang_Anh_diem_den | null;
    /**
     * Mã người tạo
     */
    nguoi_tao_id?: IdValue | null;
    /**
     * Thời điểm tạo
     */
    thoi_diem_tao?: ISODateValue | null;
    /**
     * Thời điểm cập nhật cuối
     */
    thoi_diem_cap_nhat_cuoi?: ISODateValue | null;
    /**
     * Step hoàn thành nhập thông tin
     */
    step_current?: number | null;
    /**
     * Cho biết điểm đến đã chấp nhận điều khoản hay chưa
     */
    is_confirm_rules?: boolean | null;
    /**
     * Thông tin các trường cần cập nhật (dùng cho cập nhật thông tin đơn vị sau hậu kiểm)
     */
    fields_need_update?: Dang_ky_trang_vang_Fields_need_update | null;
}

export interface Dang_ky_trang_vang_Thong_tin_don_vi {
    /**
     * Tên cơ sở kinh doanh
     */
    ten_cskd?: string | null;
    /**
     * Loại hình cơ sở kinh doanh
     */
    loai_hinh?: string | null;
    /**
     * Tên sản phẩm kinh doanh
     */
    san_pham?: string | null;
    /**
     * Số điện thoại
     */
    dien_thoai?: string | null;
    /**
     * Email
     */
    email?: string | null;
    /**
     * Địa chỉ
     */
    dia_chi?: Dang_ky_trang_vang_Thong_tin_don_vi_Dia_chi | null;
    /**
     * Mã số thuế
     */
    ma_so_thue?: string | null;
    /**
     * Mã giới thiệu
     */
    ma_gioi_thieu?: string | null;
}

export interface Dang_ky_trang_vang_Thong_tin_don_vi_Dia_chi {
    /**
     * Mã tỉnh/TP
     */
    province_id?: IdValue | null;
    /**
     * Mã tỉnh/TP
     */
    province_code?: string | null;
    /**
     * Tên tỉnh/TP
     */
    province_name?: string | null;
    /**
     * Mã quận/huyện
     */
    district_id?: IdValue | null;
    /**
     * Mã quận/huyện
     */
    district_code?: string | null;
    /**
     * Tên quận/huyện
     */
    district_name?: string | null;
    /**
     * Mã phường/xã
     */
    commune_id?: IdValue | null;
    /**
     * Mã phường/xã
     */
    commune_code?: string | null;
    /**
     * Tên phường/xã
     */
    commune_name?: string | null;
    /**
     * Địa chỉ đầy đủ
     */
    dia_chi?: string | null;
    /**
     * Kinh độ
     */
    longitude?: number | null;
    /**
     * Vĩ độ
     */
    latitude?: number | null;
}

export interface Dang_ky_trang_vang_Anh_diem_den {
    /**
     * Url ảnh cơ sở kinh doanh
     */
    anh_cskd?: string | null;
    /**
     * Url ảnh quầy thanh toán
     */
    anh_qtt?: string | null;
    /**
     * Url ảnh menu cơ sở kinh doanh
     */
    anh_menu_cskd?: string | null;
    /**
     * Url ảnh sản phẩm kinh doanh
     */
    anh_san_pham?: string | null;
    /**
     * Id ảnh cơ sở kinh doanh
     */
    anh_cskd_id?: IdValue | null;
    /**
     * Id ảnh quầy thanh toán
     */
    anh_qtt_id?: IdValue | null;
    /**
     * Id ảnh menu cơ sở kinh doanh
     */
    anh_menu_cskd_id?: IdValue | null;
    /**
     * Id ảnh sản phẩm kinh doanh
     */
    anh_san_pham_id?: string | null;
    /**
     * Cho biết tất cả ảnh đã được upload lên server FSS chưa
     */
    is_upload?: boolean | null;
}

export interface Dang_ky_trang_vang_Fields_need_update {
}

export interface Dang_ky_trang_vang$CustomMethodResource {
    confirm_rulesAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    update_safe_placeAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    inforFormRegisterAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    pushNotificationAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    sdk_update_processing_statusAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    cos_people_register_referralAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    cos_people_get_referral_inforAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    vps_merchant_get_referral_by_meAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    updateMerchantNotificationAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    vps_merchant_update_infoAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    vps_merchant_cert_tempAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    vps_merchant_sign_certAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    vps_merchant_contract_tempAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    vps_merchant_sign_contractAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    vps_merchant_update_clientAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<Dang_ky_trang_vang>({"name":"dang_ky_trang_vang","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"_raw_http_method_confirm_rules":{},"_raw_http_method_update_safe_place":{},"_raw_http_method_inforFormRegister":{},"_raw_http_method_pushNotification":{},"_raw_http_method_sdk_update_processing_status":{},"_raw_http_method_cos_people_register_referral":{},"_raw_http_method_cos_people_get_referral_infor":{},"_raw_http_method_vps_merchant_get_referral_by_me":{},"_raw_http_method_updateMerchantNotification":{},"_raw_http_method_vps_merchant_update_info":{},"_raw_http_method_vps_merchant_cert_temp":{},"_raw_http_method_vps_merchant_sign_cert":{},"_raw_http_method_vps_merchant_contract_temp":{},"_raw_http_method_vps_merchant_sign_contract":{},"_raw_http_method_vps_merchant_update_client":{}},"views":{}}, mushroom);

export interface Dsvn {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
}

export interface Dsvn$CustomMethodResource {
    hethong_getsettingAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    hethong_getdanhmucAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    khuyenmai_getkhuyenmaidisplayAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    khuyenmai_getkhuyenmaionlyAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    muave_timkiemtauAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    muave_timkiemchoAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    muave_timkiemchobytoaxeAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    muave_xinveAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    muave_xinvelistAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    muave_nhaveAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    muave_nhavelistAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    muave_savebookingsAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    muave_getbookinginfosAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    payment_finishpaymentAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<Dsvn>({"name":"dsvn","actions":{"_raw_http_method_hethong_getsetting":{},"_raw_http_method_hethong_getdanhmuc":{},"_raw_http_method_khuyenmai_getkhuyenmaidisplay":{},"_raw_http_method_khuyenmai_getkhuyenmaionly":{},"_raw_http_method_muave_timkiemtau":{},"_raw_http_method_muave_timkiemcho":{},"_raw_http_method_muave_timkiemchobytoaxe":{},"_raw_http_method_muave_xinve":{},"_raw_http_method_muave_xinvelist":{},"_raw_http_method_muave_nhave":{},"_raw_http_method_muave_nhavelist":{},"_raw_http_method_muave_savebookings":{},"_raw_http_method_muave_getbookinginfos":{},"_raw_http_method_payment_finishpayment":{}},"views":{}}, mushroom);

export interface Dsvn_booking {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã người dùng
     */
    user_id?: IdValue | null;
    /**
     * Mã đối soát
     */
    code?: string | null;
    /**
     * Mã booking
     */
    booking_code?: string | null;
    /**
     * Thông tin body của savebooking
     */
    save_booking_info?: string | null;
    /**
     * Thông tin booking
     */
    booking_info?: string | null;
    /**
     * Thông tin kết quả booking
     */
    booking_result_info?: string | null;
    /**
     * Trạng thái booking do DSVN trả về. NULL - không rõ, 0 - Lỗi; 1 - Thành công; Khác - Không thành công
     */
    status?: number | null;
    /**
     * Mã giao dịch do DSVN trả về
     */
    payment_id?: number | null;
    /**
     * Thời điểm tạo
     */
    created_time?: ISODateValue | null;
    /**
     * Tổng tiền thanh toán
     */
    amount?: number | null;
    /**
     * Trạng thái thanh toán
     */
    payment_status?: string | null;
    /**
     * Nội dung ghi chú thanh toán
     */
    payment_message?: string | null;
    /**
     * Thời điểm thanh toán
     */
    paid_time?: ISODateValue | null;
    /**
     * Cho biết đã gọi FinishPayment chưa
     */
    is_calling_finish_payment?: boolean | null;
    /**
     * Cho biết đã gọi FinishPayment thành công chưa
     */
    finished?: boolean | null;
    /**
     * Thời điểm gọi FinishPayment thành công
     */
    finished_time?: ISODateValue | null;
    /**
     * Nội dung kết quả DSVN trả về khi gọi FinishPayment
     */
    finish_payment_data?: string | null;
    /**
     * Mã hoàn tiền
     */
    refund_code?: string | null;
    /**
     * Danh sách vé
     */
    ticket_files?: Array<Dsvn_booking_Ticket_files | null | undefined> | null;
    /**
     * Danh sách các lịch sử cập nhật
     */
    history?: Array<Dsvn_booking_History | null | undefined> | null;
}

export interface Dsvn_booking_Ticket_files {
    /**
     * Mã vé
     */
    ticket_id?: number | null;
    /**
     * Mã booking info
     */
    info_id?: number | null;
    /**
     * File vé định dạng pdf kích thước A4 nếu vé đã được xuất
     */
    ticket_file_id?: IdValue | null;
    /**
     * Đường dẫn gốc của file vé kích thước A4
     */
    ticket_file_url?: string | null;
    /**
     * File vé định dạng pdf kích thước mobile nếu vé đã được xuất
     */
    ticket_mobile_file_id?: IdValue | null;
    /**
     * Đường dẫn gốc của file vé kích thước mobile
     */
    ticket_mobile_file_url?: string | null;
    /**
     * Cho biết vé đã bị hủy hay chưa
     */
    is_cancelled?: boolean | null;
}

export interface Dsvn_booking_History {
    /**
     * Thời điểm cập nhật
     */
    time?: ISODateValue | null;
    /**
     * Nội dung ghi chú cập nhật
     */
    content?: string | null;
}

defineAsyncResource<Dsvn_booking>({"name":"dsvn_booking","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true}},"views":{}}, mushroom);

export interface Pmt_session {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã đơn vị cung cấp dịch vụ
     */
    merchant_id?: IdValue | null;
    /**
     * Mã code của merchant
     */
    merchant_code?: string | null;
    /**
     * Mã cổng thanh toán
     */
    paygate_id?: IdValue | null;
    /**
     * Mã code của cổng thanh toán
     */
    paygate_code?: string | null;
    /**
     * Mã người dùng
     */
    user_id?: IdValue | null;
    /**
     * Mã thanh toán do hệ thống Du lịch sinh ra
     */
    transaction_id?: string | null;
    /**
     * Mã của đơn hàng tham chiếu trong hệ thống
     */
    ref_id?: string | null;
    /**
     * Tiền
     */
    amount?: number | null;
    /**
     * payment description
     */
    description?: string | null;
    /**
     * Thời điểm tạo
     */
    created_time?: ISODateValue | null;
    /**
     * Trạng thái thanh toán
     */
    payment_status?: string | null;
    /**
     * Nội dung ghi chú thanh toán
     */
    payment_message?: string | null;
    /**
     * Dữ liệu xác thực thanh toán bổ sung
     */
    payment_auth?: Pmt_session_Payment_auth | null;
    /**
     * Thời điểm thanh toán
     */
    paid_time?: ISODateValue | null;
    /**
     * Mã hoàn tiền
     */
    refund_code?: string | null;
    /**
     * Danh sách các lịch sử cập nhật
     */
    history?: Array<Pmt_session_History | null | undefined> | null;
    /**
     * Đánh dấu phiên thanh toán offline
     */
    is_offline?: boolean | null;
    /**
     * Dữ liệu bổ sung
     */
    data?: Pmt_session_Data | null;
    /**
     * Số điện thoại người dùng (dùng cho trường hợp user_id = null)
     */
    phone_number?: string | null;
}

export interface Pmt_session_Payment_auth {
    /**
     * Mã tham chiếu của giao dịch thanh toán
     */
    reference_id?: string | null;
    /**
     * Phương thức xoác thực bổ sung
     */
    auth_method?: string | null;
    /**
     * Giá trị đính kèm tương ứng cho auth_method
     */
    auth_value?: string | null;
}

export interface Pmt_session_History {
    /**
     * Thời điểm cập nhật
     */
    time?: ISODateValue | null;
    /**
     * Nội dung ghi chú cập nhật
     */
    content?: string | null;
}

export interface Pmt_session_Data {
}

export interface Pmt_session_Create_payment_urlResult {
    /**
     * Mã session thanh toán
     */
    session_id: IdValue;
    /**
     * Đường dẫn trang thanh toán
     */
    url: string;
    /**
     * Mã giao dịch thanh toán
     */
    transaction_id: string;
}

export interface Pmt_session_Create_payment_urlRequest {
    /**
     * Mã phiên thanh toán (nếu có). Nếu không có, hệ thống sẽ tạo phiên thanh toán mới. Bắt buộc nếu data.type=PMT_QR:KDL
     */
    session_id?: IdValue | null;
    /**
     * Mã code của merchant
     */
    merchant: string;
    /**
     * Số tiền trước giảm giá. Bắt buộc nếu session có thông tin tour_id và data.type=PMT_QR:KDL
     */
    original_amount?: number | null;
    /**
     * Số tiền
     */
    amount: number;
    /**
     * Nội dung thanh toán
     */
    description?: string | null;
    /**
     * Mã đối tượng liên quan. Nếu không có session_id thì ref_id là bắt buộc. MYWELL/GOTADI dùng pmt_order.id
     */
    ref_id?: IdValue | null;
    /**
     * Chỉ định cổng thanh toán cụ thể. Nếu không có, sẽ dùng cổng thanh toán mặc định của merchant. Nếu merchant không có cổng thanh toán mặc định thì paygate_id là bắt buộc
     */
    paygate_id?: IdValue | null;
    /**
     * Thông tin bổ sung tùy merchant. https://docs.google.com/spreadsheets/d/1QqppiiXPzlULjHMISy6YmOXVnxBfiLUiRTUaNVCT8gk/edit?gid=1982458830#gid=1982458830
     */
    data?: Pmt_session_Create_payment_urlRequest_Data | null;
}

export interface Pmt_session_Create_payment_urlRequest_Data {
}

export interface Pmt_session_PurchaseResult {
    /**
     * Cho biết xác thực và thanh toán có thành công hay không
     */
    success: boolean;
    /**
     * Mã phiên thanh toán
     */
    session_id: IdValue;
    /**
     * Mã giao dịch thanh toán
     */
    transaction_id: string;
    /**
     * Phương thức xác thực bổ sung cho giao dịch. Nếu không có nghĩa là giao dịch được thực hiện luôn, không cần xác thực gì thêm
     */
    auth_method?: string | null;
    /**
     * Giá trị đính kèm tương ứng cho auth_method
     */
    auth_value?: string | null;
    /**
     * Thông điệp mô tả kết quả thanh toán
     */
    message?: string | null;
    /**
     * Dữ liệu bổ sung từ merchant. VM/PCT/BTMT: { ticket_id, serial_number, ticket_data }. BTQN: { ticket_id, request_code, ten_nguoi_mua, chi_tiet_ves: [{ ve_id, ma_ve, ten_ve, so_luong }] }. SANVAT: { orders: [{ order_id, ref_id, amount, status }] }. DSVN: { booking_id, payment_id, amount, payment_status }. DD (điểm đến): { ddat_payment_id, ddat_id, amount, original_amount, discount_amount }
     */
    data?: Pmt_session_PurchaseResult_Data | null;
}

export interface Pmt_session_PurchaseResult_Data {
}

export interface Pmt_session_PurchaseRequest {
    /**
     * Mã phiên thanh toán (nếu có). Nếu không có, hệ thống sẽ tạo phiên thanh toán mới. Bắt buộc nếu data.type=PMT_QR:KDL
     */
    session_id?: IdValue | null;
    /**
     * Mã code của merchant
     */
    merchant: string;
    /**
     * Số tiền
     */
    amount: number;
    /**
     * Nội dung thanh toán
     */
    description?: string | null;
    /**
     * Mã đối tượng liên quan. SANVAT, BTQN ko truyền, BTMT/VM/PCT phải truyền. MYWELL/GOTADI dùng pmt_order.id
     */
    ref_id?: IdValue | null;
    /**
     * Chỉ định cổng thanh toán cụ thể. Nếu không có, sẽ dùng cổng thanh toán mặc định của merchant. Nếu merchant không có cổng thanh toán mặc định thì paygate_id là bắt buộc
     */
    paygate_id?: IdValue | null;
    /**
     * Thông tin bổ sung tùy merchant. https://docs.google.com/spreadsheets/d/1QqppiiXPzlULjHMISy6YmOXVnxBfiLUiRTUaNVCT8gk/edit?gid=1982458830#gid=1982458830
     */
    data?: Pmt_session_PurchaseRequest_Data | null;
}

export interface Pmt_session_PurchaseRequest_Data {
}

export interface Pmt_session_Verify_purchaseResult {
    /**
     * Cho biết xác thực và thanh toán có thành công hay không
     */
    success: boolean;
    /**
     * Dữ liệu bổ sung từ merchant. VM/PCT/BTMT: { ticket_id, serial_number, ticket_data }. BTQN: { ticket_id, request_code, ten_nguoi_mua, chi_tiet_ves: [{ ve_id, ma_ve, ten_ve, so_luong }] }. SANVAT: { orders: [{ order_id, ref_id, amount, status }] }. DSVN: { booking_id, payment_id, amount, payment_status }. DD (điểm đến): { ddat_payment_id, ddat_id, amount, original_amount, discount_amount }
     */
    data?: Pmt_session_Verify_purchaseResult_Data | null;
}

export interface Pmt_session_Verify_purchaseResult_Data {
}

export interface Pmt_session_Verify_purchaseRequest {
    /**
     * Mã phiên thanh toán
     */
    session_id: IdValue;
    /**
     * Giá trị dùng để xác thực. Ví dụ: nếu auth_method là SMS thì value là OTP
     */
    value: string;
}

export interface Pmt_session_Create_payment_qrResult {
    /**
     * Mã session thanh toán
     */
    session_id: IdValue;
    /**
     * Nội dung QR code
     */
    qr: string;
    /**
     * Thời gian (tính bằng giây) còn hiệu lực của QR code
     */
    expired_in: number;
}

export interface Pmt_session_Create_payment_qrRequest {
    /**
     * Mã tour (nếu như khách du lịch đang trong tour đó)
     */
    tour_id?: IdValue | null;
}

export interface Pmt_session_Request_paymentResult {
    /**
     * Cho biết gửi yêu cầu thanh toán có thành công hay không
     */
    success?: boolean | null;
}

export interface Pmt_session_Request_paymentRequest {
    /**
     * Mã session thanh toán
     */
    session_id: IdValue;
    /**
     * Số tiền trước giảm giá. Bắt buộc nếu session có thông tin tour_id
     */
    original_amount?: number | null;
    /**
     * Số tiền
     */
    amount: number;
    /**
     * Nội dung thanh toán
     */
    description: string;
}

export interface Pmt_session_CancelRequest {
    /**
     * Mã session thanh toán
     */
    session_id: IdValue;
    /**
     * Lý do
     */
    reason?: string | null;
}

export interface Pmt_session_Purchase_offlineResult {
    /**
     * Kết quả xử lý batch
     */
    success?: boolean | null;
    /**
     * Danh sách giao dịch đã lưu thành công
     */
    items?: Array<Pmt_session_Purchase_offlineResult_Items | null | undefined> | null;
    /**
     * Danh sách giao dịch bị lỗi
     */
    errors?: Array<Pmt_session_Purchase_offlineResult_Errors | null | undefined> | null;
}

export interface Pmt_session_Purchase_offlineResult_Items {
    /**
     * Mã phiên thanh toán
     */
    session_id?: IdValue | null;
    /**
     * UUID do FE sinh
     */
    client_transaction_id?: string | null;
}

export interface Pmt_session_Purchase_offlineResult_Errors {
    /**
     * UUID do FE sinh
     */
    client_transaction_id?: string | null;
    /**
     * Mô tả lỗi
     */
    description?: string | null;
}

export interface Pmt_session_Purchase_offlineRequest {
    /**
     * Mã cổng thanh toán (SHBOFFLINE)
     */
    paygate_id: IdValue;
    /**
     * Mã merchant
     */
    merchant_code: string;
    /**
     * Danh sách giao dịch offline
     */
    data: Array<Pmt_session_Purchase_offlineRequest_Data | null | undefined>;
}

export interface Pmt_session_Purchase_offlineRequest_Data {
    /**
     * UUID do FE sinh, dùng cho idempotency và ref_id
     */
    client_transaction_id: string;
    /**
     * Số tiền thanh toán
     */
    amount: number;
    /**
     * Nội dung thanh toán
     */
    description: string;
    /**
     * Thời điểm thanh toán offline
     */
    payment_time: ISODateValue;
    /**
     * Mã thẻ cứng của khách du lịch (tra cứu từ shb_card.card_code để lấy user_id)
     */
    card_code: string;
    /**
     * HMACSHA512 hash (base64). Công thức: HMACSHA512(clientTransactionId + amount + description + paymentTime + cardCode)
     */
    hash: string;
}

export interface Pmt_session_Generate_vcs_deeplinkResult {
    /**
     * Deeplink đã ký dùng để mở app VCS
     */
    deeplink?: string | null;
}

export interface Pmt_session_Generate_vcs_deeplinkRequest {
    /**
     * Object key-value (key, value dạng string) cần ký để sinh deeplink
     */
    data: Record<string, string | null | undefined>;
}

export interface Pmt_session_Create_qrResult {
    /**
     * Kết quả
     */
    success?: boolean | null;
    /**
     * Mã phiên thanh toán
     */
    session_id?: IdValue | null;
    /**
     * Mã giao dịch
     */
    transaction_id?: string | null;
    /**
     * QR code base64 image
     */
    qr_code?: string | null;
    /**
     * Số tài khoản định danh
     */
    alias_account_no?: string | null;
    /**
     * Thời gian hiệu lực QR (giây)
     */
    qr_duration?: string | null;
}

export interface Pmt_session_Create_qrRequest {
    /**
     * Mã merchant (ví dụ: VMWEB)
     */
    merchant: string;
    /**
     * Mã tham chiếu (pmt_order.id). Amount lấy từ order.
     */
    ref_id: string;
    /**
     * Mô tả thanh toán (sẽ được chuẩn hóa bỏ dấu, in hoa). Mặc định lấy từ merchant.service_name
     */
    description?: string | null;
    /**
     * Mã cổng thanh toán (SHBQR). Mặc định lấy từ merchant
     */
    paygate_id?: IdValue | null;
    /**
     * Dữ liệu bổ sung tùy merchant
     */
    data?: Pmt_session_Create_qrRequest_Data | null;
    /**
     * Chữ ký request. Option chữ ký đọc từ merchant.data: Signature_HashAlgorithm, Signature_Separator, Signature_OutputFormat.
     */
    signature: string;
}

export interface Pmt_session_Create_qrRequest_Data {
}

export interface Pmt_session_Check_qr_configurationResult {
    /**
     * Đã đủ cấu hình được kiểm tra để tạo QR.
     */
    is_configured?: boolean | null;
    /**
     * Mã các cổng chưa đủ cấu hình
     */
    missing_paygates?: Array<string | null | undefined> | null;
    /**
     * Các trường cấu hình thiếu hoặc không hợp lệ.
     */
    configuration_errors?: Record<string, string | null | undefined> | null;
    /**
     * Kết quả kiểm tra riêng từng cổng
     */
    paygates?: Array<Pmt_session_Check_qr_configurationResult_Paygates | null | undefined> | null;
}

export interface Pmt_session_Check_qr_configurationResult_Paygates {
    code?: string | null;
    is_configured?: boolean | null;
    configuration_errors?: Record<string, string | null | undefined> | null;
}

export interface Pmt_session_Create_qr_safeplaceResult {
    /**
     * Kết quả
     */
    success?: boolean | null;
    /**
     * Mã phiên thanh toán
     */
    session_id?: IdValue | null;
    /**
     * Mã giao dịch
     */
    transaction_id?: string | null;
    /**
     * QR code base64 image
     */
    qr_code?: string | null;
    /**
     * Số tài khoản định danh
     */
    alias_account_no?: string | null;
    /**
     * Thời gian hiệu lực QR (giây)
     */
    qr_duration?: string | null;
}

export interface Pmt_session_Create_qr_safeplaceRequest {
    /**
     * Mã tham chiếu.
     */
    ref_id: string;
    /**
     * Mô tả thanh toán. Mặc định lấy từ merchant.service_name
     */
    description?: string | null;
    /**
     * Mã cổng thanh toán QR. Mặc định lấy từ merchant
     */
    paygate_id?: IdValue | null;
    /**
     * Dữ liệu bổ sung tùy luồng
     */
    data?: Pmt_session_Create_qr_safeplaceRequest_Data | null;
}

export interface Pmt_session_Create_qr_safeplaceRequest_Data {
}

export interface Pmt_session_Get_statusResult {
    /**
     * Trạng thái thanh toán: new (mới tạo), paying (đang chờ thanh toán), paid (đã thanh toán), refunding (đang hoàn tiền), refunded (đã hoàn tiền), error (lỗi), cancelled (đã hủy), timeout (hết hạn)
     */
    status?: string | null;
}

export interface Pmt_session_Get_statusRequest {
    /**
     * Mã phiên thanh toán (session_id trả về từ create_qr)
     */
    session_id: IdValue;
    /**
     * Chữ ký request (ký các field trong body trừ signature, mặc định chính là giá trị session_id). Option chữ ký đọc từ merchant.data: Signature_HashAlgorithm, Signature_Separator, Signature_OutputFormat.
     */
    signature: string;
}

export interface Pmt_session_Resolve_loyalty_payment_qrResult {
    /**
     * Mã phiên thanh toán
     */
    session_id?: IdValue | null;
    /**
     * Mã pmt_order
     */
    order_id?: IdValue | null;
    /**
     * Mã đơn phía merchant
     */
    partner_order_id?: string | null;
    /**
     * Nội dung/mô tả của pmt_order
     */
    message?: string | null;
    /**
     * Mã merchant
     */
    merchant?: string | null;
    /**
     * Tên merchant
     */
    merchant_name?: string | null;
    /**
     * Số tiền gốc
     */
    original_amount?: number | null;
    /**
     * Số tiền giảm cho khách
     */
    discount_amount?: number | null;
    /**
     * Số tiền khách cần thanh toán
     */
    pay_amount?: number | null;
    /**
     * Khách có đủ điều kiện hưởng ưu đãi không
     */
    eligible?: boolean | null;
    /**
     * Lý do không đủ điều kiện
     */
    reason?: string | null;
}

export interface Pmt_session_Resolve_loyalty_payment_qrRequest {
    /**
     * Số tài khoản định danh.
     */
    aliasAccountNo: string;
}

export interface Pmt_session_Confirm_loyalty_paymentResult {
    /**
     * Kết quả
     */
    success?: boolean | null;
    /**
     * Mã phiên thanh toán mới dùng để gọi purchase
     */
    session_id?: IdValue | null;
    /**
     * Mã phiên thanh toán QR gốc đã bị hủy
     */
    source_session_id?: IdValue | null;
    /**
     * Mã pmt_order
     */
    order_id?: IdValue | null;
    /**
     * Mã giao dịch thanh toán của session mới
     */
    transaction_id?: string | null;
    /**
     * Số tiền gốc
     */
    original_amount?: number | null;
    /**
     * Số tiền giảm cho khách
     */
    discount_amount?: number | null;
    /**
     * Số tiền khách cần thanh toán
     */
    pay_amount?: number | null;
    /**
     * Khách có đủ điều kiện hưởng ưu đãi không
     */
    eligible?: boolean | null;
    /**
     * Phương thức xác thực nếu SHB yêu cầu
     */
    auth_method?: string | null;
    /**
     * Thông tin xác thực nếu SHB trả về
     */
    auth_value?: string | null;
    /**
     * Mã lỗi nghiệp vụ từ paygate nếu có
     */
    biz_code?: string | null;
    /**
     * Thông báo lỗi nếu có
     */
    message?: string | null;
    /**
     * Dữ liệu kết quả thanh toán nếu thanh toán thành công
     */
    data?: Pmt_session_Confirm_loyalty_paymentResult_Data | null;
}

export interface Pmt_session_Confirm_loyalty_paymentResult_Data {
}

export interface Pmt_session_Confirm_loyalty_paymentRequest {
    /**
     * Mã phiên thanh toán backend trả về từ bước resolve QR
     */
    session_id: IdValue;
    /**
     * Số tiền khách xác nhận thanh toán sau ưu đãi
     */
    pay_amount: number;
}

export interface Pmt_session$CustomMethodResource {
    create_payment_urlAsync: (request: CustomMethodBodyRequest<Pmt_session_Create_payment_urlRequest>) => Promise<MushroomResponse<Pmt_session_Create_payment_urlResult>>;
    purchaseAsync: (request: CustomMethodBodyRequest<Pmt_session_PurchaseRequest>) => Promise<MushroomResponse<Pmt_session_PurchaseResult>>;
    verify_purchaseAsync: (request: CustomMethodBodyRequest<Pmt_session_Verify_purchaseRequest>) => Promise<MushroomResponse<Pmt_session_Verify_purchaseResult>>;
    create_payment_qrAsync: (request: CustomMethodBodyRequest<Pmt_session_Create_payment_qrRequest>) => Promise<MushroomResponse<Pmt_session_Create_payment_qrResult>>;
    request_paymentAsync: (request: CustomMethodBodyRequest<Pmt_session_Request_paymentRequest>) => Promise<MushroomResponse<Pmt_session_Request_paymentResult>>;
    cancelAsync: (request: CustomMethodBodyRequest<Pmt_session_CancelRequest>) => Promise<MushroomResponse<any>>;
    purchase_offlineAsync: (request: CustomMethodBodyRequest<Pmt_session_Purchase_offlineRequest>) => Promise<MushroomResponse<Pmt_session_Purchase_offlineResult>>;
    generate_vcs_deeplinkAsync: (request: CustomMethodBodyRequest<Pmt_session_Generate_vcs_deeplinkRequest>) => Promise<MushroomResponse<Pmt_session_Generate_vcs_deeplinkResult>>;
    create_qrAsync: (request: CustomMethodBodyRequest<Pmt_session_Create_qrRequest>) => Promise<MushroomResponse<Pmt_session_Create_qrResult>>;
    check_qr_configurationAsync: (request: MushroomRequest) => Promise<MushroomResponse<Pmt_session_Check_qr_configurationResult>>;
    create_qr_safeplaceAsync: (request: CustomMethodBodyRequest<Pmt_session_Create_qr_safeplaceRequest>) => Promise<MushroomResponse<Pmt_session_Create_qr_safeplaceResult>>;
    get_statusAsync: (request: CustomMethodBodyRequest<Pmt_session_Get_statusRequest>) => Promise<MushroomResponse<Pmt_session_Get_statusResult>>;
    resolve_loyalty_payment_qrAsync: (request: CustomMethodBodyRequest<Pmt_session_Resolve_loyalty_payment_qrRequest>) => Promise<MushroomResponse<Pmt_session_Resolve_loyalty_payment_qrResult>>;
    confirm_loyalty_paymentAsync: (request: CustomMethodBodyRequest<Pmt_session_Confirm_loyalty_paymentRequest>) => Promise<MushroomResponse<Pmt_session_Confirm_loyalty_paymentResult>>;
}
defineAsyncResource<Pmt_session>({"name":"pmt_session","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"_raw_http_method_create_payment_url":{},"_raw_http_method_purchase":{},"_raw_http_method_verify_purchase":{},"_raw_http_method_create_payment_qr":{},"_raw_http_method_request_payment":{},"_raw_http_method_cancel":{},"_raw_http_method_purchase_offline":{},"_raw_http_method_generate_vcs_deeplink":{},"_raw_http_method_create_qr":{},"_raw_http_method_check_qr_configuration":{},"_raw_http_method_create_qr_safeplace":{},"_raw_http_method_get_status":{},"_raw_http_method_resolve_loyalty_payment_qr":{},"_raw_http_method_confirm_loyalty_payment":{}},"views":{}}, mushroom);

export interface Pmt_merchant {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã của merchant
     */
    code?: string | null;
    /**
     * Tên của merchant
     */
    name?: string | null;
    /**
     * Tên của dịch vụ
     */
    service_name?: string | null;
    /**
     * Mã cổng thanh toán (mặc định)
     */
    paygate_id?: IdValue | null;
    /**
     * Danh sách mã cổng thanh toán được phép sử dụng
     */
    paygate_ids?: Array<IdValue | null | undefined> | null;
    /**
     * Dữ liệu bổ sung
     */
    data?: Pmt_merchant_Data | null;
}

export interface Pmt_merchant_Data {
}

export interface Pmt_merchant_Upsert_offline_merchantResult {
    /**
     * Kết quả đăng ký
     */
    success?: boolean | null;
    /**
     * Mã merchant offline vừa tạo/cập nhật
     */
    merchant_code?: string | null;
}

export interface Pmt_merchant_Upsert_offline_merchantRequest {
    /**
     * device gọi api này
     */
    device: string;
    /**
     * giá trị ngưỡng trên của 1 giao dịch
     */
    maxThreshold?: number | null;
    /**
     * giá trị ngưỡng dưới của 1 giao dịch
     */
    minThreshold?: number | null;
}

export interface Pmt_merchant$CustomMethodResource {
    upsert_offline_merchantAsync: (request: CustomMethodBodyRequest<Pmt_merchant_Upsert_offline_merchantRequest>) => Promise<MushroomResponse<Pmt_merchant_Upsert_offline_merchantResult>>;
}
defineAsyncResource<Pmt_merchant>({"name":"pmt_merchant","actions":{"findMany":{"clientCache":true},"_raw_http_method_upsert_offline_merchant":{}},"views":{}}, mushroom);

export interface Pmt_paygate {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã của cổng thanh toán
     */
    code?: string | null;
    /**
     * Tên của cổng thanh toán
     */
    name?: string | null;
    /**
     * Phương thức thanh toán
     */
    method?: string | null;
    /**
     * Loại của cổng thanh toán
     */
    type?: string | null;
    /**
     * Thứ tự hiển thị
     */
    order?: number | null;
    /**
     * Dữ liệu bổ sung
     */
    data?: Pmt_paygate_Data | null;
}

export interface Pmt_paygate_Data {
}

export interface Pmt_paygate_Generate_napas_qrResult {
    /**
     * QR code
     */
    qr: string;
}

export interface Pmt_paygate_Generate_napas_qrRequest {
    /**
     * Mã ngân hàng
     */
    bin_code: number;
    /**
     * Số tài khoản ngân hàng
     */
    account: string;
}

export interface Pmt_paygate$CustomMethodResource {
    generate_napas_qrAsync: (request: CustomMethodBodyRequest<Pmt_paygate_Generate_napas_qrRequest>) => Promise<MushroomResponse<Pmt_paygate_Generate_napas_qrResult>>;
}
defineAsyncResource<Pmt_paygate>({"name":"pmt_paygate","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"_raw_http_method_generate_napas_qr":{}},"views":{}}, mushroom);

export interface Pmt_ddat_payment {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã phiên thanh toán PMT
     */
    pmt_session_id?: IdValue | null;
    /**
     * Nội dung thanh toán
     */
    payment_message?: string | null;
    /**
     * Mã điểm đến
     */
    ddat_id?: IdValue | null;
    /**
     * Mã tài khoản quản lý điểm đến
     */
    ddat_user_id?: IdValue | null;
    /**
     * Mã khách du lịch
     */
    kdl_id?: IdValue | null;
    /**
     * Danh sách hướng dẫn viên
     */
    hdv?: Array<Pmt_ddat_payment_Hdv | null | undefined> | null;
    /**
     * Mã tour
     */
    tour_id?: IdValue | null;
    /**
     * Tiền trước giảm giá
     */
    original_amount?: number | null;
    /**
     * Tiền khách du lịch thanh toán
     */
    amount?: number | null;
    /**
     * Tiền khách du lịch được giảm giá
     */
    discount_amount?: number | null;
    /**
     * Tiền dự kiến chi hoa hồng cho hướng dẫn viên. (Tiền thực tế chi: lấy trong hdv tính sum commission_amount mà status=paid)
     */
    commission_amount?: number | null;
    /**
     * Thời điểm thanh toán
     */
    paid_time?: ISODateValue | null;
    /**
     * Ghi chú
     */
    note?: string | null;
}

export interface Pmt_ddat_payment_Hdv {
    /**
     * Mã hướng dẫn viên
     */
    hdv_id?: IdValue | null;
    /**
     * Số tiền hoa hồng
     */
    commission_amount?: number | null;
    /**
     * Trạng thái thanh toán
     */
    status?: string | null;
}

defineAsyncResource<Pmt_ddat_payment>({"name":"pmt_ddat_payment","actions":{"findMany":{"clientCache":true,"includeTotal":true}},"views":{}}, mushroom);

export interface Shb {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
}

export interface Shb_Check_customer_existedResult {
    /**
     * Mã yêu cầu
     */
    request_id: string;
    /**
     * Cho biết người dùng có thể đăng ký mở thẻ không
     */
    can_register: boolean;
    /**
     * Cho biết người dùng có phải là khách hàng của SHB hay không
     */
    is_customer: boolean;
    /**
     * Cho biết có phải là tài khoản đã liên kết hay không
     */
    is_linked: boolean;
}

export interface Shb_Check_customer_existedRequest {
    /**
     * Số CCCD
     */
    identity_number: string;
}

export interface Shb_Upload_imagesResult {
    /**
     * Cho biết thành công hay thất bại
     */
    success: boolean;
}

export interface Shb_Upload_imagesRequest {
    /**
     * SHB request Id (sinh ra ở api check_customer_existed)
     */
    request_id: string;
    /**
     * Base64 của ảnh mặt trước cccd
     */
    front: string;
    /**
     * Base64 của ảnh mặt sau cccd
     */
    back: string;
    /**
     * Base64 của ảnh khuôn mặt trong cccd
     */
    chip: string;
    /**
     * Base64 của ảnh khuôn mặt thực tế
     */
    face: string;
}

export interface Shb_Send_otpResult {
    /**
     * Otp id
     */
    otpId: string;
    /**
     * Thời gian otp expire (tính theo second)
     */
    expireTime: string;
    /**
     * Mã OTP cho môi trường test
     */
    otp?: string | null;
}

export interface Shb_Send_otpRequest {
    /**
     * SHB request Id (sinh ra ở api check_customer_existed)
     */
    request_id: string;
}

export interface Shb_Check_otpResult {
    /**
     * Cho biết OTP có hợp lệ hay không
     */
    success: boolean;
}

export interface Shb_Check_otpRequest {
    /**
     * SHB request Id (sinh ra ở api check_customer_existed)
     */
    request_id: string;
    /**
     * otpId (sinh ra ở api send_otp)
     */
    otpId: string;
    /**
     * Mã OTP
     */
    otp: string;
}

export interface Shb_Create_customerResult {
    /**
     * Cho biết mở tài khoản thành công hay không
     */
    success: boolean;
}

export interface Shb_Create_customerRequest {
    /**
     * SHB request Id (sinh ra ở api check_customer_existed)
     */
    request_id: string;
    /**
     * Email
     */
    email?: string | null;
    /**
     * Nghề nghiệp
     */
    job: string;
    /**
     * Chức vụ
     */
    jobTitle: string;
    /**
     * Địa chỉ
     */
    address?: string | null;
    /**
     * Thông tin ocr cccd
     */
    ocr: Shb_Create_customerRequest_Ocr;
    /**
     * Thông tin trên chip
     */
    nfc: Shb_Create_customerRequest_Nfc;
    /**
     * Thông tin ảnh chụp khách hàng
     */
    liveness: Shb_Create_customerRequest_Liveness;
}

export interface Shb_Create_customerRequest_Ocr {
    /**
     * Số cccd
     */
    cccd: string;
    /**
     * Họ và Tên
     */
    fullName: string;
    /**
     * Ngày sinh
     */
    birthDate: string;
    /**
     * Ngày sinh
     */
    dateProvide: string;
    /**
     * Ngày hết hạn
     */
    outOfDate?: string | null;
    /**
     * Nơi cấp
     */
    issuePlace: string;
}

export interface Shb_Create_customerRequest_Nfc {
    /**
     * Số cccd
     */
    cccd: string;
    /**
     * Loại giấy tờ
     */
    type: string;
    /**
     * Họ và Tên
     */
    fullName: string;
    /**
     * Ngày sinh
     */
    birthDate: string;
    /**
     * Giới tính
     */
    gender: string;
    /**
     * Quốc tịch
     */
    nationality: string;
    /**
     * Quê quán
     */
    homeTown: string;
    /**
     * Địa chỉ thường trú
     */
    regPlaceAddress: string;
    /**
     * Ngày hết hạn CCCD
     */
    outOfDate: string;
    /**
     * Ngày cấp
     */
    dateProvide: string;
    /**
     * Đặc điểm nhận dạng
     */
    identifyCharacteristics?: string | null;
    /**
     * Số CMND cũ (nếu có)
     */
    oldIdentify?: string | null;
    /**
     * Tôn giáo
     */
    religion?: string | null;
    /**
     * Dân tộc
     */
    ethnic?: string | null;
    /**
     * Họ tên Cha
     */
    fatherName?: string | null;
    /**
     * Họ tên Mẹ
     */
    motherName?: string | null;
    /**
     * Họ tên Vợ/chồng
     */
    husbandOrWifeName?: string | null;
    /**
     * Base64 Chữ ký trên chip
     */
    sod: string;
}

export interface Shb_Create_customerRequest_Liveness {
    /**
     * Tỉ lệ so khớp khuôn mặt KH với ảnh trên chip
     */
    score: string;
}

export interface Shb_Get_customer_contractResult {
    /**
     * Nôi dung hợp đồng
     */
    html: string;
}

export interface Shb_Get_customer_contractRequest {
    /**
     * shb_card id
     */
    card_id: IdValue;
}

export interface Shb_Get_customer_statusResult {
    /**
     * Trạng thái mở tài khoản: 0: Success; 1: Fail
     */
    accountStatus?: string | null;
    /**
     * Mô tả trạng thái mở tài khoản: 00 - SUCCESS; Khác 00 - Lỗi
     */
    accountMsg?: string | null;
    /**
     * Trạng thái liên kết ví VSS_DU_LICH: 0: Success; 1: Fail
     */
    regisStatus?: string | null;
    /**
     * Mô tả trạng thái liên kết ví: 00 - SUCCESS; Khác 00 - Lỗi
     */
    regisMsg?: string | null;
    /**
     * Trạng thái add voucher: 0: Success; 1: Fail
     */
    addVcrStatus?: string | null;
    /**
     * Thông tin tài khoản
     */
    acctInfo?: Shb_Get_customer_statusResult_AcctInfo | null;
    /**
     * Thông tin voucher
     */
    vrcInfo?: Shb_Get_customer_statusResult_VrcInfo | null;
    /**
     * Thông tin liên kết
     */
    ewalletinfo?: Shb_Get_customer_statusResult_Ewalletinfo | null;
}

export interface Shb_Get_customer_statusResult_AcctInfo {
    /**
     * CIF
     */
    cif?: string | null;
    /**
     * Số tài khoản
     */
    accountNo?: string | null;
    /**
     * Tên tài khoản
     */
    accountName?: string | null;
    /**
     * Loại tài khoản
     */
    accountType?: string | null;
    /**
     * Hạn mức tài khoản
     */
    accountLimit?: string | null;
    /**
     * Ngày mở tài khoản: DD/MM/YYYY
     */
    openDate?: string | null;
    /**
     * Ebank User: Tên đăng nhập
     */
    ebankUser?: string | null;
}

export interface Shb_Get_customer_statusResult_VrcInfo {
    /**
     * Mã voucher
     */
    voucherCode?: string | null;
    /**
     * Tên voucher
     */
    voucherName?: string | null;
    /**
     * Ngày hết hạn
     */
    expireDate?: string | null;
}

export interface Shb_Get_customer_statusResult_Ewalletinfo {
    /**
     * Token liên kết (đã được mã hoá, cần giải mã trước khi lưu)
     */
    token?: string | null;
    /**
     * Thời gian hết hạn token liên kết
     */
    tokenExpire?: string | null;
    /**
     * Thời gian liên kết
     */
    tokenIssue?: string | null;
}

export interface Shb_Get_customer_statusRequest {
    /**
     * SHB request Id (sinh ra ở api check_customer_existed)
     */
    request_id: string;
}

export interface Shb_BalanceResult {
    /**
     * Số tài khoản
     */
    accountNo?: string | null;
    /**
     * Số dư tài khoản
     */
    availableBalance?: number | null;
    /**
     * Mã truy vấn (dùng để trace)
     */
    transId?: string | null;
}

export interface Shb_BalanceRequest {
    /**
     * Mã thẻ shb
     */
    card_id: string;
}

export interface Shb_Auto_debit_registerResult {
    /**
     * transId dùng cho trường hợp cần verify OTP
     */
    transId: string;
    /**
     * Phương thức xác thực. Nếu không có thì không cần xác thực.
     */
    authMethod?: string | null;
    /**
     * Nếu authMethod=SMS: là số điện thoại nhận OTP. Nếu authMethod=TOKEN: là ChallengeCode để hiển thị cho người dùng
     */
    authValue?: string | null;
    /**
     * deeplink url
     */
    deeplinkUrl?: string | null;
}

export interface Shb_Auto_debit_registerRequest {
    /**
     * Mã thẻ shb
     */
    card_id: string;
}

export interface Shb_Verify_otp_auto_debit_registerResult {
    /**
     * Cho biết OTP có hợp lệ hay không
     */
    success: boolean;
}

export interface Shb_Verify_otp_auto_debit_registerRequest {
    /**
     * Mã thẻ shb
     */
    card_id: string;
    /**
     * transId
     */
    transId: string;
    /**
     * Mã OTP
     */
    otp: string;
}

export interface Shb_Get_auto_debit_contractResult {
    /**
     * Nôi dung hợp đồng
     */
    html: string;
}

export interface Shb_Get_auto_debit_contractRequest {
    /**
     * shb_card id
     */
    card_id: IdValue;
}

export interface Shb_Link_accountResult {
    /**
     * Cho biết liên kết tài khoản thành công hay không
     */
    success: boolean;
}

export interface Shb_Link_accountRequest {
    /**
     * SHB request Id (sinh ra ở api check_customer_existed)
     */
    request_id: string;
    /**
     * Số tài khoản cần liên kết của SHB
     */
    account_number: string;
}

export interface Shb_Validate_purchaseResult {
    /**
     * Mã lỗi. Danh sách mã lỗi: https://docs.google.com/spreadsheets/d/1oqNYJaAYzBot4Am0uSDhBdx7rFLBRxsn2fLOSOEO0XM/edit
     */
    error_code?: number | null;
    /**
     * Diễn giải lỗi
     */
    detail?: string | null;
}

export interface Shb_Validate_purchaseRequest {
    /**
     * Số tiền cần validate
     */
    amount?: number | null;
    /**
     * Cho biết có kiển tra số dư tài khoản của người dùng không
     */
    check_balance?: boolean | null;
}

export interface Shb_Slink_update_aliasResult {
    /**
     * Cho biết cập nhật có thành công hay không
     */
    success: boolean;
    /**
     * Số tài khoản định danh đã cập nhật
     */
    alias_account_no?: string | null;
    /**
     * Mã trạng thái xử lý từ SHB
     */
    status?: string | null;
    /**
     * Mô tả trạng thái / lỗi từ SHB
     */
    message?: string | null;
}

export interface Shb_Slink_update_aliasRequest {
    /**
     * ID phiên thanh toán (pmt_session.id). Bắt buộc nếu không truyền alias_account_no
     */
    session_id?: string | null;
    /**
     * Số tài khoản định danh. Bắt buộc nếu không truyền session_id
     */
    alias_account_no?: string | null;
    /**
     * Tên tài khoản định danh mới (tối đa 60 ký tự, không dấu)
     */
    alias_account_name?: string | null;
    /**
     * Mã tỉnh/thành phố
     */
    province_cd?: string | null;
    /**
     * Mã quận/huyện
     */
    district_cd?: string | null;
    /**
     * Mã xã/phường
     */
    ward_cd?: string | null;
    /**
     * Mã loại hình
     */
    sale_type_cd?: string | null;
    /**
     * Email nhận username/password truy vấn giao dịch (tối đa 5 email cách nhau bằng ;)
     */
    email_internet_banking?: string | null;
}

export interface Shb_Slink_update_alias_debt_amountResult {
    /**
     * Cho biết cập nhật có thành công hay không
     */
    success: boolean;
    /**
     * ID phiên thanh toán
     */
    session_id?: string | null;
    /**
     * Số tài khoản định danh
     */
    alias_account_no?: string | null;
    /**
     * Base64 QR code thanh toán mới ứng với số tiền đã cập nhật
     */
    qr_code?: string | null;
    /**
     * Mã trạng thái xử lý từ SHB
     */
    status?: string | null;
    /**
     * Mô tả trạng thái / lỗi từ SHB
     */
    message?: string | null;
}

export interface Shb_Slink_update_alias_debt_amountRequest {
    /**
     * ID phiên thanh toán (pmt_session.id). Bắt buộc nếu không truyền alias_account_no
     */
    session_id?: string | null;
    /**
     * Số tài khoản định danh. Bắt buộc nếu không truyền session_id
     */
    alias_account_no?: string | null;
    /**
     * Số tiền phải thu mới (>= 0)
     */
    amount: number;
    /**
     * Nội dung thanh toán hiển thị khi quét mã QR (sẽ được tự động chuẩn hóa)
     */
    description?: string | null;
    /**
     * Mã hóa đơn (mặc định = session_id nếu không truyền)
     */
    bill_code?: string | null;
}

export interface Shb_Slink_deactivate_aliasResult {
    /**
     * Cho biết đóng tài khoản có thành công hay không
     */
    success: boolean;
    /**
     * Số tài khoản định danh đã đóng
     */
    alias_account_no?: string | null;
    /**
     * Mã trạng thái xử lý từ SHB
     */
    status?: string | null;
    /**
     * Mô tả trạng thái / lỗi từ SHB
     */
    message?: string | null;
}

export interface Shb_Slink_deactivate_aliasRequest {
    /**
     * ID phiên thanh toán (pmt_session.id). Bắt buộc nếu không truyền alias_account_no
     */
    session_id?: string | null;
    /**
     * Số tài khoản định danh. Bắt buộc nếu không truyền session_id
     */
    alias_account_no?: string | null;
    /**
     * Lý do đóng tài khoản định danh (lưu vào lịch sử phiên)
     */
    reason?: string | null;
}

export interface Shb_Slink_get_alias_transactionsResult {
    /**
     * Cho biết truy vấn có thành công hay không
     */
    success: boolean;
    /**
     * Số tài khoản định danh đã truy vấn
     */
    alias_account_no?: string | null;
    /**
     * Danh sách giao dịch ghi có trong ngày
     */
    transactions?: Array<Shb_Slink_get_alias_transactionsResult_Transactions | null | undefined> | null;
}

export interface Shb_Slink_get_alias_transactionsResult_Transactions {
    /**
     * Số tài khoản định danh
     */
    alias_account_no?: string | null;
    /**
     * Số tiền giao dịch
     */
    amount?: string | null;
    /**
     * Mã tham chiếu giao dịch trên hệ thống SHB
     */
    tran_id?: string | null;
    /**
     * Thời gian giao dịch (yyyyMMddHHmmss)
     */
    tran_date?: string | null;
    /**
     * Mã hóa đơn gắn với tài khoản định danh
     */
    bill_code?: string | null;
}

export interface Shb_Slink_get_alias_transactionsRequest {
    /**
     * ID phiên thanh toán (pmt_session.id). Bắt buộc nếu không truyền alias_account_no
     */
    session_id?: string | null;
    /**
     * Số tài khoản định danh. Bắt buộc nếu không truyền session_id
     */
    alias_account_no?: string | null;
}

export interface Shb_Guarantee_registerResult {
    /**
     * Ma giao dich (dung lam otpTransId khi verify)
     */
    transId?: string | null;
    /**
     * Token khach hang
     */
    token?: string | null;
    /**
     * Phuong thuc xac thuc (SMS)
     */
    authMethod?: string | null;
    /**
     * So dien thoai nhan OTP (neu authMethod=SMS)
     */
    authValue?: string | null;
}

export interface Shb_Guarantee_registerRequest {
    /**
     * So tien dang ky bao lanh
     */
    amount: number;
    /**
     * Ma chong replay (anti-replay token, do client sinh ra)
     */
    r: string;
}

export interface Shb_Guarantee_verifyResult {
    /**
     * Ma giao dich
     */
    transId?: string | null;
    /**
     * So du bao lanh kha dung
     */
    availableBalance?: string | null;
    /**
     * So hop dong bao lanh
     */
    contractNumber?: string | null;
    /**
     * So hach toan tai CORE SHB
     */
    refNo?: string | null;
    /**
     * Dien giai giao dich
     */
    remark?: string | null;
}

export interface Shb_Guarantee_verifyRequest {
    /**
     * transId tra ve tu API guarantee_register / guarantee_modify / guarantee_cancel
     */
    otpTransId: string;
    /**
     * Ma OTP
     */
    otp: string;
    /**
     * Loai giao dich: register (dang ky), modify (thay doi han muc), cancel (huy)
     */
    type: string;
    /**
     * So tien giao dich (bat buoc voi register va modify)
     */
    amount?: number | null;
    /**
     * So hop dong (bat buoc voi modify va cancel)
     */
    contract_number?: string | null;
}

export interface Shb_Guarantee_inquiryResult {
    /**
     * Danh sach hop dong bao lanh con hieu luc
     */
    contracts?: Array<Shb_Guarantee_inquiryResult_Contracts | null | undefined> | null;
}

export interface Shb_Guarantee_inquiryResult_Contracts {
    /**
     * So hop dong
     */
    contractNumber?: string | null;
    /**
     * Ngay hieu luc
     */
    effectiveDate?: string | null;
    /**
     * So du kha dung
     */
    availableBalance?: string | null;
    /**
     * Dien giai
     */
    remark?: string | null;
}

export interface Shb_Guarantee_inquiryRequest {
    /**
     * So hop dong can truy van (khong bat buoc, neu khong truyen se tra ve tat ca hop dong con hieu luc)
     */
    contract_number?: string | null;
}

export interface Shb_Guarantee_view_fileResult {
    /**
     * Danh sach hop dong voi noi dung Base64
     */
    contracts?: Array<Shb_Guarantee_view_fileResult_Contracts | null | undefined> | null;
}

export interface Shb_Guarantee_view_fileResult_Contracts {
    /**
     * So hop dong
     */
    contractNumber?: string | null;
    /**
     * Loai hop dong
     */
    contractType?: string | null;
    /**
     * Noi dung hop dong (Base64)
     */
    contents?: string | null;
}

export interface Shb_Guarantee_view_fileRequest {
    /**
     * So hop dong can xem (khong bat buoc, neu khong truyen se tra ve tat ca)
     */
    contract_number?: string | null;
}

export interface Shb_Guarantee_modifyResult {
    /**
     * Ma giao dich (dung lam otpTransId khi verify)
     */
    transId?: string | null;
    /**
     * Phuong thuc xac thuc (SMS)
     */
    authMethod?: string | null;
    /**
     * So dien thoai nhan OTP (neu authMethod=SMS)
     */
    authValue?: string | null;
}

export interface Shb_Guarantee_modifyRequest {
    /**
     * So hop dong can thay doi
     */
    contract_number: string;
    /**
     * So tien han muc moi
     */
    amount: number;
    /**
     * Dien giai ly do thay doi
     */
    remark: string;
}

export interface Shb_Guarantee_cancelResult {
    /**
     * Ma giao dich (dung lam otpTransId khi verify)
     */
    transId?: string | null;
    /**
     * Phuong thuc xac thuc (SMS)
     */
    authMethod?: string | null;
    /**
     * So dien thoai nhan OTP (neu authMethod=SMS)
     */
    authValue?: string | null;
}

export interface Shb_Guarantee_cancelRequest {
    /**
     * So hop dong can huy
     */
    contract_number: string;
    /**
     * Dien giai ly do huy
     */
    remark: string;
}

export interface Shb$CustomMethodResource {
    check_customer_existedAsync: (request: CustomMethodBodyRequest<Shb_Check_customer_existedRequest>) => Promise<MushroomResponse<Shb_Check_customer_existedResult>>;
    upload_imagesAsync: (request: CustomMethodBodyRequest<Shb_Upload_imagesRequest>) => Promise<MushroomResponse<Shb_Upload_imagesResult>>;
    send_otpAsync: (request: CustomMethodBodyRequest<Shb_Send_otpRequest>) => Promise<MushroomResponse<Shb_Send_otpResult>>;
    check_otpAsync: (request: CustomMethodBodyRequest<Shb_Check_otpRequest>) => Promise<MushroomResponse<Shb_Check_otpResult>>;
    create_customerAsync: (request: CustomMethodBodyRequest<Shb_Create_customerRequest>) => Promise<MushroomResponse<Shb_Create_customerResult>>;
    get_customer_contractAsync: (request: CustomMethodBodyRequest<Shb_Get_customer_contractRequest>) => Promise<MushroomResponse<Shb_Get_customer_contractResult>>;
    get_customer_statusAsync: (request: CustomMethodBodyRequest<Shb_Get_customer_statusRequest>) => Promise<MushroomResponse<Shb_Get_customer_statusResult>>;
    balanceAsync: (request: CustomMethodBodyRequest<Shb_BalanceRequest>) => Promise<MushroomResponse<Shb_BalanceResult>>;
    auto_debit_registerAsync: (request: CustomMethodBodyRequest<Shb_Auto_debit_registerRequest>) => Promise<MushroomResponse<Shb_Auto_debit_registerResult>>;
    verify_otp_auto_debit_registerAsync: (request: CustomMethodBodyRequest<Shb_Verify_otp_auto_debit_registerRequest>) => Promise<MushroomResponse<Shb_Verify_otp_auto_debit_registerResult>>;
    get_auto_debit_contractAsync: (request: CustomMethodBodyRequest<Shb_Get_auto_debit_contractRequest>) => Promise<MushroomResponse<Shb_Get_auto_debit_contractResult>>;
    link_accountAsync: (request: CustomMethodBodyRequest<Shb_Link_accountRequest>) => Promise<MushroomResponse<Shb_Link_accountResult>>;
    validate_purchaseAsync: (request: CustomMethodBodyRequest<Shb_Validate_purchaseRequest>) => Promise<MushroomResponse<Shb_Validate_purchaseResult>>;
    slink_update_aliasAsync: (request: CustomMethodBodyRequest<Shb_Slink_update_aliasRequest>) => Promise<MushroomResponse<Shb_Slink_update_aliasResult>>;
    slink_update_alias_debt_amountAsync: (request: CustomMethodBodyRequest<Shb_Slink_update_alias_debt_amountRequest>) => Promise<MushroomResponse<Shb_Slink_update_alias_debt_amountResult>>;
    slink_deactivate_aliasAsync: (request: CustomMethodBodyRequest<Shb_Slink_deactivate_aliasRequest>) => Promise<MushroomResponse<Shb_Slink_deactivate_aliasResult>>;
    slink_get_alias_transactionsAsync: (request: CustomMethodBodyRequest<Shb_Slink_get_alias_transactionsRequest>) => Promise<MushroomResponse<Shb_Slink_get_alias_transactionsResult>>;
    guarantee_registerAsync: (request: CustomMethodBodyRequest<Shb_Guarantee_registerRequest>) => Promise<MushroomResponse<Shb_Guarantee_registerResult>>;
    guarantee_verifyAsync: (request: CustomMethodBodyRequest<Shb_Guarantee_verifyRequest>) => Promise<MushroomResponse<Shb_Guarantee_verifyResult>>;
    guarantee_inquiryAsync: (request: CustomMethodBodyRequest<Shb_Guarantee_inquiryRequest>) => Promise<MushroomResponse<Shb_Guarantee_inquiryResult>>;
    guarantee_view_fileAsync: (request: CustomMethodBodyRequest<Shb_Guarantee_view_fileRequest>) => Promise<MushroomResponse<Shb_Guarantee_view_fileResult>>;
    guarantee_modifyAsync: (request: CustomMethodBodyRequest<Shb_Guarantee_modifyRequest>) => Promise<MushroomResponse<Shb_Guarantee_modifyResult>>;
    guarantee_cancelAsync: (request: CustomMethodBodyRequest<Shb_Guarantee_cancelRequest>) => Promise<MushroomResponse<Shb_Guarantee_cancelResult>>;
}
defineAsyncResource<Shb>({"name":"shb","actions":{"_raw_http_method_check_customer_existed":{},"_raw_http_method_upload_images":{},"_raw_http_method_send_otp":{},"_raw_http_method_check_otp":{},"_raw_http_method_create_customer":{},"_raw_http_method_get_customer_contract":{},"_raw_http_method_get_customer_status":{},"_raw_http_method_balance":{},"_raw_http_method_auto_debit_register":{},"_raw_http_method_verify_otp_auto_debit_register":{},"_raw_http_method_get_auto_debit_contract":{},"_raw_http_method_link_account":{},"_raw_http_method_validate_purchase":{},"_raw_http_method_slink_update_alias":{},"_raw_http_method_slink_update_alias_debt_amount":{},"_raw_http_method_slink_deactivate_alias":{},"_raw_http_method_slink_get_alias_transactions":{},"_raw_http_method_guarantee_register":{},"_raw_http_method_guarantee_verify":{},"_raw_http_method_guarantee_inquiry":{},"_raw_http_method_guarantee_view_file":{},"_raw_http_method_guarantee_modify":{},"_raw_http_method_guarantee_cancel":{}},"views":{}}, mushroom);

export interface Shb_guarantee_history {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã người dùng
     */
    user_id?: IdValue | null;
    /**
     * Số tiền giao dịch
     */
    amount?: number | null;
    /**
     * Loại giao dịch
     */
    type?: string | null;
    /**
     * Số hợp đồng bảo lãnh
     */
    contract_number?: string | null;
    /**
     * Số dư hợp đồng trước khi thực hiện giao dịch (lấy từ inquiry, áp dụng cho type modify và cancel)
     */
    last_balance?: number | null;
    /**
     * Thời điểm tạo
     */
    created_time?: ISODateValue | null;
}

defineAsyncResource<Shb_guarantee_history>({"name":"shb_guarantee_history","actions":{"findMany":{"clientCache":true,"includeTotal":true}},"views":{}}, mushroom);

export interface Shb_request {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã người dùng
     */
    user_id?: IdValue | null;
    /**
     * Số CCCD
     */
    cccd?: string | null;
    /**
     * Số điện thoại
     */
    phone?: string | null;
    /**
     * Mã yêu cầu mở thẻ SHB
     */
    shb_request_id?: string | null;
    /**
     * Trạng thái
     */
    status?: string | null;
    /**
     * Loại tài khoản
     */
    account_type?: string | null;
    /**
     * Các đường dẫn upload file
     */
    presignedUrls?: Shb_request_PresignedUrls | null;
    /**
     * Thông tin customer status (lấy từ api /v1/get-customer-status)
     */
    customerStatus?: Shb_request_CustomerStatus | null;
    /**
     * Thông tin thêm
     */
    extraInfo?: Shb_request_ExtraInfo | null;
    /**
     * Danh sách lịch sử
     */
    history?: Array<Shb_request_History | null | undefined> | null;
    /**
     * Thời điểm tạo
     */
    created_time?: ISODateValue | null;
}

export interface Shb_request_PresignedUrls {
    /**
     * Mặt trước CCCD
     */
    front?: string | null;
    /**
     * Mặt sau CCCD
     */
    back?: string | null;
    /**
     * Ảnh khuôn mặt trong CCCD
     */
    chip?: string | null;
    /**
     * Ảnh chụp khuôn mặt thực tế
     */
    face?: string | null;
    /**
     * Ảnh mặt trước CCCD
     */
    front_id?: IdValue | null;
    /**
     * Ảnh mặt sau CCCD
     */
    back_id?: IdValue | null;
    /**
     * Ảnh khuôn mặt trong CCCD
     */
    chip_id?: IdValue | null;
    /**
     * Ảnh chụp khuôn mặt thực tế
     */
    face_id?: IdValue | null;
}

export interface Shb_request_CustomerStatus {
    /**
     * Bước thực hiện
     */
    status?: string | null;
    /**
     * Dữ liệu trả về từ phía SHB
     */
    responseBody?: string | null;
}

export interface Shb_request_ExtraInfo {
    /**
     * Tên khách hàng (lấy trong check_customer_existed cho trường hợp đã có tài khoản)
     */
    customerName?: string | null;
    /**
     * ebankUser (lấy trong check_customer_existed cho trường hợp đã có tài khoản)
     */
    ebankUser?: string | null;
}

export interface Shb_request_History {
    /**
     * Nội dung
     */
    message?: string | null;
    /**
     * Thời điểm thực hiện
     */
    time?: ISODateValue | null;
    /**
     * Trạng thái chuyển đến
     */
    status?: string | null;
    /**
     * Người thực hiện
     */
    user_id?: IdValue | null;
}

defineAsyncResource<Shb_request>({"name":"shb_request","actions":{"findMany":{"clientCache":true},"findById":{"clientCache":true}},"views":{}}, mushroom);

export interface Shb_card {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã người dùng
     */
    user_id?: IdValue | null;
    /**
     * Số CCCD
     */
    cccd?: string | null;
    /**
     * Số điện thoại
     */
    phone?: string | null;
    /**
     * Hợp đồng mở tài khoản (định dạng html)
     */
    contract?: string | null;
    /**
     * Mã yêu cầu mở thẻ SHB
     */
    shb_request_id?: string | null;
    /**
     * Thông tin tài khoản
     */
    accInfo?: Shb_card_AccInfo | null;
    /**
     * Thông tin VRC
     */
    vrcInfo?: Shb_card_VrcInfo | null;
    /**
     * Thông tin liên kết ví
     */
    ewalletInfo?: Shb_card_EwalletInfo | null;
    /**
     * Thông tin đăng ký thanh toán tự động
     */
    debitInfo?: Shb_card_DebitInfo | null;
    /**
     * Mã thẻ cứng cho thanh toán offline
     */
    card_code?: string | null;
    /**
     * Thời điểm tạo
     */
    created_time?: ISODateValue | null;
}

export interface Shb_card_AccInfo {
    /**
     * Số CIF
     */
    cif?: string | null;
    /**
     * Số tài khoản
     */
    accountNo?: string | null;
    /**
     * Tên tài khoản
     */
    accountName?: string | null;
    /**
     * Loại tài khoản
     */
    accountType?: string | null;
    /**
     * Hạn mức
     */
    accountLimit?: string | null;
    /**
     * Ngày mở thẻ (DD/MM/YYYY)
     */
    openDate?: string | null;
    /**
     * Tài khoản ebank
     */
    ebankUser?: string | null;
}

export interface Shb_card_VrcInfo {
    /**
     * Mã voucher
     */
    voucherCode?: string | null;
    /**
     * Tên voucher
     */
    voucherName?: string | null;
    /**
     * Ngày hết hạn
     */
    expireDate?: string | null;
}

export interface Shb_card_EwalletInfo {
    /**
     * Token liên kết
     */
    token?: string | null;
    /**
     * Thời gian hết hạn token liên kết
     */
    tokenExpire?: string | null;
    /**
     * Thời điểm liên kết
     */
    tokenIssue?: string | null;
}

export interface Shb_card_DebitInfo {
    /**
     * Phương thức xác thực
     */
    token?: string | null;
    /**
     * Mã reference khi đăng ký
     */
    referenceId?: string | null;
    /**
     * Hợp đồng đăng ký thanh toán tự động
     */
    contract?: string | null;
    /**
     * Thời điểm đăng ký
     */
    registered_time?: ISODateValue | null;
}

export interface Shb_card_Check_debit_registeredResult {
    /**
     * Cho biết user đã đăng ký trích nợ tự động chưa
     */
    isRegisteredDebit: boolean;
}

export interface Shb_card_Check_debit_registeredRequest {
    /**
     * Mã người dùng cần kiểm tra
     */
    user_id: string;
}

export interface Shb_card_Create_cardResult {
    /**
     * Tạo thẻ SHB và thiết lập merchant thành công
     */
    success: boolean;
}

export interface Shb_card_Create_cardRequest {
    /**
     * Mã người dùng cần tạo thẻ SHB
     */
    user_id: string;
    /**
     * Mã tài khoản người dùng
     */
    account: string;
    /**
     * Token liên kết ví do ngân hàng cấp
     */
    token: string;
    /**
     * Cho biết người dùng có bật trích nợ tự động hay không
     */
    debitInfo: boolean;
    /**
     * Mã số thuế cấu hình SHB thu hộ
     */
    SHB_THUHO_TaxNo: string;
    /**
     * Số tài khoản cấu hình SHB thu hộ
     */
    SHB_THUHO_AccountNo: string;
    /**
     * Prefix alias account cấu hình SHB thu hộ
     */
    SHB_THUHO_Prefix: string;
    /**
     * ClientId cấu hình SHB thu hộ
     */
    SHB_THUHO_ClientId: string;
    /**
     * ClientSecret cấu hình SHB thu hộ
     */
    SHB_THUHO_ClientSecret: string;
    /**
     * Username cấu hình SHB thu hộ
     */
    SHB_THUHO_Username: string;
    /**
     * Password cấu hình SHB thu hộ
     */
    SHB_THUHO_Password: string;
    /**
     * ConsumerKey cấu hình SHB thu hộ
     */
    SHB_THUHO_ConsumerKey: string;
    /**
     * ConsumerSecret cấu hình SHB thu hộ
     */
    SHB_THUHO_ConsumerSecret: string;
    /**
     * SaleTypeCd cấu hình SHB thu hộ
     */
    SHB_THUHO_SaleTypeCd: string;
    /**
     * ProvinceCd cấu hình SHB thu hộ
     */
    SHB_THUHO_ProvinceCd: string;
    /**
     * Thời gian hiệu lực alias/QR tính bằng giây. Giá trị mặc định là 900
     */
    SHB_THUHO_ReqTime?: string | null;
}

export interface Shb_card$CustomMethodResource {
    check_debit_registeredAsync: (request: CustomMethodBodyRequest<Shb_card_Check_debit_registeredRequest>) => Promise<MushroomResponse<Shb_card_Check_debit_registeredResult>>;
    create_cardAsync: (request: CustomMethodBodyRequest<Shb_card_Create_cardRequest>) => Promise<MushroomResponse<Shb_card_Create_cardResult>>;
}
defineAsyncResource<Shb_card>({"name":"shb_card","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"updatePartially":{},"_raw_http_method_check_debit_registered":{},"_raw_http_method_create_card":{}},"views":{}}, mushroom);

export interface Bidv {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
}

export interface Bidv_Get_billResult {
    /**
     * Mã hóa đơn
     */
    bill_id: string;
    /**
     * Số tiền thanh toán, đơn vị VND
     */
    amount: number;
    /**
     * Nội dung thanh toán
     */
    message: string;
    /**
     * Thời điểm tạo yêu cầu thanh toán, định dạng ISO 8601
     */
    time: string;
    /**
     * Tên khách hàng, mặc định trả Bán cho người tiêu dùng
     */
    customer_name: string;
    /**
     * Chữ ký response HMAC-SHA512 theo secure key.
     */
    signature: string;
}

export interface Bidv_Get_billRequest {
    /**
     * Mã hóa đơn, tương ứng với pmt_session.id
     */
    bill_id: string;
    /**
     * Chữ ký BIDV gửi sang, HMAC-SHA512 theo secure key.
     */
    signature: string;
}

export interface Bidv$CustomMethodResource {
    get_billAsync: (request: CustomMethodBodyRequest<Bidv_Get_billRequest>) => Promise<MushroomResponse<Bidv_Get_billResult>>;
}
defineAsyncResource<Bidv>({"name":"bidv","actions":{"_raw_http_method_get_bill":{}},"views":{}}, mushroom);

export interface TwoId {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã người dùng
     */
    user_id?: IdValue | null;
    /**
     * API
     */
    api?: string | null;
    /**
     * Dữ liệu gửi sang 2id
     */
    request?: string | null;
    /**
     * Dữ liệu 2id trả về
     */
    response?: string | null;
    /**
     * Thời điểm tạo
     */
    time?: ISODateValue | null;
}

export interface TwoId_OcrResult {
    /**
     * Các thông tin được trích xuất từ ảnh đầu vào
     */
    info?: TwoId_OcrResult_Info | null;
    /**
     * Giấy tờ hợp lệ/ không hợp lệ
     */
    valid?: string | null;
    /**
     * Thông báo trả về với những giấy tờ tùy thân không hợp lệ
     */
    invalidMessage?: string | null;
    /**
     * Mã cảnh báo phát hiện trên giấy tờ tùy thân
     */
    invalidCode?: string | null;
    /**
     * Loại giấy tờ tùy thân được trích xuất thông tin
     */
    type?: string | null;
}

export interface TwoId_OcrResult_Info {
}

export interface TwoId_OcrRequest {
    /**
     * base64 của ảnh mặt trước hoặc mặt sau
     */
    img1: string;
    /**
     * base64 của ảnh mặt trước hoặc mặt sau
     */
    img2: string;
    /**
     * Chuỗi validate
     */
    r: string;
}

export interface TwoId_Ocr_passportResult {
    /**
     * Địa chỉ
     */
    address?: string | null;
    /**
     * Ngày sinh
     */
    birthday?: string | null;
    /**
     * Quốc tịch
     */
    national?: string | null;
    /**
     * Giới tính
     */
    sex?: string | null;
    /**
     * Họ tên
     */
    name?: string | null;
    /**
     * Số hộ chiếu/giấy tờ
     */
    passport?: string | null;
    /**
     * Ngày hết hạn
     */
    expiry?: string | null;
    /**
     * Loại giấy tờ
     */
    type?: string | null;
    /**
     * Mã hoặc tên quốc gia
     */
    code?: string | null;
}

export interface TwoId_Ocr_passportRequest {
    /**
     * base64 của ảnh hộ chiếu
     */
    img: string;
}

export interface TwoId_Face_matching_User_Result {
    /**
     * Phần trăm giống nhau giữa hai ảnh đầu vào
     */
    matching?: string | null;
    /**
     * Ảnh khuôn mặt cmnd
     */
    face1?: string | null;
    /**
     * Ảnh khuôn mặt chân dung
     */
    face2?: string | null;
    /**
     * Độ tin cậy ảnh khuôn mặt cmnd
     */
    face1_score?: string | null;
    /**
     * Độ tin cậy ảnh khuôn mặt chân dung
     */
    face2_score?: string | null;
    /**
     * Thông báo trả về với những giấy tờ tùy thân không hợp lệ
     */
    invalidMessage?: string | null;
    /**
     * Mã cảnh báo phát hiện trên giấy tờ tùy thân
     */
    invalidCode?: string | null;
    /**
     * 1 nếu phần trăm matching > 75%, 0 nếu phần trăm matching trong khoảng [65%, 75%], ngược lại -1
     */
    match?: string | null;
}

export interface TwoId_Face_matching_User_Request {
    /**
     * base64 của ảnh giấy tờ tùy thân
     */
    img1: string;
    /**
     * base64 của ảnh khuôn mặt
     */
    img2: string;
    /**
     * Chuỗi validate
     */
    r: string;
}

export interface TwoId_Face_matching___Result {
    /**
     * Phần trăm giống nhau giữa hai ảnh đầu vào
     */
    matching?: string | null;
    /**
     * Ảnh khuôn mặt cmnd
     */
    face1?: string | null;
    /**
     * Ảnh khuôn mặt chân dung
     */
    face2?: string | null;
    /**
     * Độ tin cậy ảnh khuôn mặt cmnd
     */
    face1_score?: string | null;
    /**
     * Độ tin cậy ảnh khuôn mặt chân dung
     */
    face2_score?: string | null;
    /**
     * Thông báo trả về với những giấy tờ tùy thân không hợp lệ
     */
    invalidMessage?: string | null;
    /**
     * Mã cảnh báo phát hiện trên giấy tờ tùy thân
     */
    invalidCode?: string | null;
    /**
     * 1 nếu phần trăm matching > 75%, 0 nếu phần trăm matching trong khoảng [65%, 75%], ngược lại -1
     */
    match?: string | null;
}

export interface TwoId_Face_matching___Request {
    /**
     * base64 của ảnh giấy tờ tùy thân
     */
    img1: string;
    /**
     * base64 của ảnh khuôn mặt
     */
    img2: string;
}

export interface TwoId$CustomMethodResource {
    ocrAsync: (request: CustomMethodBodyRequest<TwoId_OcrRequest>) => Promise<MushroomResponse<TwoId_OcrResult[]>>;
    ocr_passportAsync: (request: CustomMethodBodyRequest<TwoId_Ocr_passportRequest>) => Promise<MushroomResponse<TwoId_Ocr_passportResult>>;
    face_matchingAsync: (request: CustomMethodBodyRequest<TwoId_Face_matching_User_Request> | CustomMethodBodyRequest<TwoId_Face_matching___Request>) => Promise<MushroomResponse<TwoId_Face_matching_User_Result | TwoId_Face_matching___Result>>;
}
defineAsyncResource<TwoId>({"name":"twoId","actions":{"_raw_http_method_ocr":{},"_raw_http_method_ocr_passport":{},"_raw_http_method_face_matching":{}},"views":{}}, mushroom);

export interface Security {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
}

export interface Security_Get_signature_keyResult {
    /**
     * Chuỗi ngẫu nhiên do backend sinh, client dùng tạm để tạo HMAC
     */
    secure_key: string;
    /**
     * Chữ ký/mã RSA của SecureKey do backend tạo, client gửi lại kèm chữ ký request
     */
    server_signature: string;
}

export interface Security_Get_signature_key_publicResult {
    /**
     * Chuỗi ngẫu nhiên do backend sinh, client dùng tạm để tạo HMAC
     */
    secure_key: string;
    /**
     * Chữ ký/mã RSA của SecureKey do backend tạo, client gửi lại kèm chữ ký request
     */
    server_signature: string;
}

export interface Security$CustomMethodResource {
    get_signature_keyAsync: (request: MushroomRequest) => Promise<MushroomResponse<Security_Get_signature_keyResult>>;
    get_signature_key_publicAsync: (request: MushroomRequest) => Promise<MushroomResponse<Security_Get_signature_key_publicResult>>;
}
defineAsyncResource<Security>({"name":"security","actions":{"_raw_http_method_get_signature_key":{},"_raw_http_method_get_signature_key_public":{}},"views":{}}, mushroom);

export interface Sanvat_location {
    /**
     * Mã định danh
     */
    id?: IdValue | null;
}

export interface Sanvat_location_Send_my_locationRequest {
    /**
     * Latitude
     */
    lat: number;
    /**
     * Longitude
     */
    lng: number;
}

export interface Sanvat_location$CustomMethodResource {
    send_my_locationAsync: (request: CustomMethodBodyRequest<Sanvat_location_Send_my_locationRequest>) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<Sanvat_location>({"name":"sanvat_location","actions":{"_raw_http_method_send_my_location":{}},"views":{}}, mushroom);

export interface Sanvat_tourist_order {
    /**
     * Mã định danh
     */
    id?: IdValue | null;
    /**
     * Mã người dùng đặt hàng
     */
    user_id?: IdValue | null;
    /**
     * Mã giao dịch
     */
    trans_id?: string | null;
    /**
     * Thời gian tạo đơn hàng
     */
    created_time?: ISODateValue | null;
    /**
     * Trạng thái đơn hàng tổng. Các trạng thái: waiting_for_payment, paid,waiting_for_confirmation_complete, partial_delivery, delivery_completed
     */
    status?: string | null;
    /**
     * Số điện thoại người dùng (dùng cho trường hợp user_id = null)
     */
    phone_number?: string | null;
}

export interface Sanvat_tourist_order_Create_payment_urlResult {
    /**
     * Mã session thanh toán
     */
    session_id?: string | null;
    /**
     * Đường dẫn trang thanh toán VNPAY
     */
    url?: string | null;
    /**
     * Mã giao dịch thanh toán
     */
    transaction_id?: string | null;
}

export interface Sanvat_tourist_order_Create_payment_urlRequest {
    /**
     * Số điện thoại người dùng (định dạng: 84 + 9 số)
     */
    phone_number?: string | null;
    /**
     * Nội dung thanh toán (hiển thị trên VNPAY)
     */
    description?: string | null;
    /**
     * Danh sách đơn hàng
     */
    orders: Array<Sanvat_tourist_order_Create_payment_urlRequest_Orders | null | undefined>;
    /**
     * Đường dẫn VNPAY sẽ redirect về trên Frontend (định dạng: https://…)
     */
    return_url?: string | null;
    /**
     * Mã cổng thanh toán (VNPAY, KEYPAY, ...). Mặc định: VNPAY
     */
    paygate_code?: string | null;
    /**
     * Chuỗi chữ ký (tạm thời chưa validate)
     */
    singature?: string | null;
}

export interface Sanvat_tourist_order_Create_payment_urlRequest_Orders {
    /**
     * Mã nhà cung cấp. Ví dụ: dd6969
     */
    dd_id: string;
    /**
     * Số tiền (>0)
     */
    amount: number;
    /**
     * Mã đơn hàng phía đặc sản
     */
    order_id: string;
    /**
     * Mã ga (của bên DSVN)
     */
    station_code?: string | null;
    /**
     * Nội dung thanh toán
     */
    message?: string | null;
}

export interface Sanvat_tourist_order$CustomMethodResource {
    create_payment_urlAsync: (request: CustomMethodBodyRequest<Sanvat_tourist_order_Create_payment_urlRequest>) => Promise<MushroomResponse<Sanvat_tourist_order_Create_payment_urlResult>>;
}
defineAsyncResource<Sanvat_tourist_order>({"name":"sanvat_tourist_order","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"_raw_http_method_create_payment_url":{}},"views":{}}, mushroom);

export interface Sanvat_order {
    /**
     * Mã định danh
     */
    id?: IdValue | null;
    /**
     * Mã người dùng đặt hàng
     */
    user_id?: IdValue | null;
    /**
     * Mã đơn hàng bên Sản Vật
     */
    ref_id?: string | null;
    /**
     * Số tiền đơn hàng
     */
    amount?: number | null;
    /**
     * Trạng thái hiện tại đơn hàng. Các trạng thái: waiting_for_payment, paid, waiting_for_confirmation_complete, completed, request_refund, refunded, error_refund. Còn lại tự định nghĩa
     */
    status?: string | null;
    /**
     * Lịch sử trạng thái đơn hàng
     */
    history_status?: Array<Sanvat_order_History_status | null | undefined> | null;
    /**
     * Merchant code của nhà cung cấp
     */
    ncc_code?: string | null;
    /**
     * Mã ga
     */
    station_code?: string | null;
    /**
     * Ghi chú đơn hàng
     */
    message?: string | null;
    /**
     * Số điện thoại người dùng (dùng cho trường hợp user_id = null)
     */
    phone_number?: string | null;
    order_tourist?: Sanvat_order_Order_tourist | null;
}

export interface Sanvat_order_History_status {
    /**
     * Trạng thái đơn hàng
     */
    status?: string | null;
    /**
     * Mô tả trạng thái đơn hàng
     */
    description?: string | null;
    /**
     * Thời gian cập nhật trạng thái
     */
    timestamp?: ISODateValue | null;
}

export interface Sanvat_order_Order_tourist {
    /**
     * id sanvat_tourist_order
     */
    sanvat_tourist_order_id?: IdValue | null;
    /**
     * Mã giao dịch
     */
    transaction_id?: string | null;
    /**
     * Mã phiên giao dịch
     */
    pmt_session_id?: string | null;
}

export interface Sanvat_order_Update_order_statusResult {
    /**
     * Trạng thái thành công hay thất bại
     */
    success?: boolean | null;
    /**
     * Thông báo kết quả
     */
    message?: string | null;
}

export interface Sanvat_order_Update_order_statusRequest {
    /**
     * Mã đơn hàng bên Sản Vật
     */
    ref_id: string;
    /**
     * Trạng thái mới. Các trạng thái: waiting_for_payment, paid, waiting_for_confirmation_complete, refunded, error_refund. Không được phép cập nhật completed hoặc request_refund qua API này.
     */
    status: string;
    /**
     * Mô tả trạng thái
     */
    description?: string | null;
}

export interface Sanvat_order_Request_refundResult {
    /**
     * Trạng thái thành công hay thất bại
     */
    success?: boolean | null;
    /**
     * Thông báo kết quả
     */
    message?: string | null;
    /**
     * ID của bản ghi sanvat_order_refund vừa tạo
     */
    refund_id?: string | null;
}

export interface Sanvat_order_Request_refundRequest {
    /**
     * Mã đơn hàng bên Sản Vật
     */
    ref_id: string;
    /**
     * Số tiền cần hoàn. Phải lớn hơn 0, không vượt quá amount của đơn hàng, và tổng các lần hoàn không vượt quá amount đơn hàng.
     */
    amount: number;
    /**
     * Lý do hoàn tiền
     */
    description?: string | null;
}

export interface Sanvat_order_Confirm_order_completedResult {
    /**
     * Trạng thái thành công hay thất bại
     */
    success?: boolean | null;
    /**
     * Thông báo kết quả
     */
    message?: string | null;
}

export interface Sanvat_order_Confirm_order_completedRequest {
    /**
     * Mã đơn hàng bên Sản Vật
     */
    ref_id: string;
}

export interface Sanvat_order$CustomMethodResource {
    update_order_statusAsync: (request: CustomMethodBodyRequest<Sanvat_order_Update_order_statusRequest>) => Promise<MushroomResponse<Sanvat_order_Update_order_statusResult>>;
    request_refundAsync: (request: CustomMethodBodyRequest<Sanvat_order_Request_refundRequest>) => Promise<MushroomResponse<Sanvat_order_Request_refundResult>>;
    confirm_order_completedAsync: (request: CustomMethodBodyRequest<Sanvat_order_Confirm_order_completedRequest>) => Promise<MushroomResponse<Sanvat_order_Confirm_order_completedResult>>;
}
defineAsyncResource<Sanvat_order>({"name":"sanvat_order","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"_raw_http_method_update_order_status":{},"_raw_http_method_request_refund":{},"_raw_http_method_confirm_order_completed":{}},"views":{}}, mushroom);

export interface Sanvat_station_merchant {
    /**
     * Mã liên kết với người dùng
     */
    id?: IdValue | null;
    /**
     * Danh sách ga mà user quản lý
     */
    ga?: Array<Sanvat_station_merchant_Ga | null | undefined> | null;
    /**
     * Merchant code của nhà cung cấp
     */
    ncc_code?: string | null;
    /**
     * Phần trăm hoa hồng của bản thân trong mỗi đơn hàng sản vật (0-100)
     */
    commission_percent?: number | null;
}

export interface Sanvat_station_merchant_Ga {
    /**
     * Tên ga
     */
    ten_ga?: string | null;
    /**
     * Mã ga
     */
    ma_ga?: string | null;
}

export interface Sanvat_station_merchant_Get_list_stationResult {
    /**
     * Danh sách ga Bắc Nam
     */
    ListGaBacNam?: Array<Sanvat_station_merchant_Get_list_stationResult_ListGaBacNam | null | undefined> | null;
}

export interface Sanvat_station_merchant_Get_list_stationResult_ListGaBacNam {
    /**
     * Mã id từ dsvn
     */
    Id?: number | null;
    /**
     * Tên ga
     */
    ten_ga?: string | null;
    /**
     * Mã ga
     */
    ma_ga?: string | null;
    /**
     * Key search của dsvn
     */
    SKeys?: string | null;
}

export interface Sanvat_station_merchant$CustomMethodResource {
    get_list_stationAsync: (request: MushroomRequest) => Promise<MushroomResponse<Sanvat_station_merchant_Get_list_stationResult>>;
}
defineAsyncResource<Sanvat_station_merchant>({"name":"sanvat_station_merchant","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"deleteOne":{},"_raw_http_method_get_list_station":{}},"views":{}}, mushroom);

export interface Sanvat_order_refund {
    /**
     * Mã định danh
     */
    id?: IdValue | null;
    /**
     * Mã đơn hàng sản vật liên quan
     */
    sanvat_order_id?: IdValue | null;
    /**
     * Mã đơn hàng bên Sản Vật (ref_id của sanvat_order)
     */
    order_ref?: string | null;
    /**
     * mã của người dùng có order đang được refund hiện tại
     */
    user_id?: IdValue | null;
    /**
     * Số tiền hoàn
     */
    amount?: number | null;
    /**
     * Mô tả / lý do hoàn tiền
     */
    description?: string | null;
    /**
     * Trạng thái yêu cầu hoàn tiền. Các giá trị hợp lệ: request (đang yêu cầu), refunded (đã hoàn tiền)
     */
    status?: string | null;
    /**
     * Lịch sử trạng thái yêu cầu hoàn tiền
     */
    history_status?: Array<Sanvat_order_refund_History_status | null | undefined> | null;
    /**
     * Thời gian tạo yêu cầu
     */
    created_time?: ISODateValue | null;
}

export interface Sanvat_order_refund_History_status {
    /**
     * Trạng thái
     */
    status?: string | null;
    /**
     * Thời gian cập nhật
     */
    timestamp?: ISODateValue | null;
}

defineAsyncResource<Sanvat_order_refund>({"name":"sanvat_order_refund","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"updatePartially":{}},"views":{}}, mushroom);

export interface Sanvat_pmt_order {
    /**
     * Mã định danh
     */
    id?: IdValue | null;
    /**
     * Mã đơn hàng tổng của khách du lịch
     */
    order_tourist_id?: IdValue | null;
    /**
     * Mã đơn hàng sản vật
     */
    order_sanvat_id?: IdValue | null;
    /**
     * Trạng thái thanh toán. Các trạng thái: new (mới tạo), paying (đang thanh toán), paid (đã thanh toán), error (lỗi), unsupported (nhà cung cấp chưa có phương thức thanh toán SHB)
     */
    status?: string | null;
    /**
     * Mô tả cho trạng thái (ví dụ: lý do lỗi khi status = error)
     */
    description?: string | null;
    /**
     * Merchant code của nhà cung cấp
     */
    ncc_code?: string | null;
    /**
     * Số tiền thanh toán cho nhà cung cấp
     */
    amount?: number | null;
    /**
     * Thời gian tạo
     */
    created_time?: ISODateValue | null;
    /**
     * Thời gian thanh toán thành công
     */
    paid_time?: ISODateValue | null;
    /**
     * Số điện thoại người dùng (dùng cho trường hợp user_id = null)
     */
    phone_number?: string | null;
}

defineAsyncResource<Sanvat_pmt_order>({"name":"sanvat_pmt_order","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true}},"views":{}}, mushroom);

export interface Pmt_settlement_sanvat {
    /**
     * Mã định danh
     */
    id?: IdValue | null;
    /**
     * Mã đơn hàng sản vật
     */
    order_sanvat_id?: IdValue | null;
    /**
     * Mã đơn hàng tổng của khách du lịch
     */
    order_tourist_id?: IdValue | null;
    /**
     * Merchant code của nhà cung cấp
     */
    ncc_code?: string | null;
    /**
     * Loại người nhận tiền: dulich (tài khoản chung của dulich), operator (nhân viên vận hành ga), sale (nhân viên bán hàng ga)
     */
    recipient_type?: string | null;
    /**
     * Mã người dùng nhận tiền
     */
    recipient_user_id?: IdValue | null;
    /**
     * Tổng tiền đơn hàng gốc
     */
    total_order_amount?: number | null;
    /**
     * Phần trăm hoa hồng áp dụng (0-100)
     */
    commission_percent?: number | null;
    /**
     * Số tiền thực nhận
     */
    amount?: number | null;
    /**
     * Trạng thái thanh toán: new (mới tạo), paying (đang thanh toán), paid (đã thanh toán), error (lỗi), skipped (bỏ qua do không đủ điều kiện)
     */
    status?: string | null;
    /**
     * Mô tả cho trạng thái (ví dụ: lý do lỗi, lý do bỏ qua)
     */
    description?: string | null;
    /**
     * Thời gian tạo
     */
    created_time?: ISODateValue | null;
    /**
     * Thời gian thanh toán thành công
     */
    paid_time?: ISODateValue | null;
    /**
     * Số điện thoại người dùng (dùng cho trường hợp user_id = null)
     */
    phone_number?: string | null;
}

defineAsyncResource<Pmt_settlement_sanvat>({"name":"pmt_settlement_sanvat","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"updatePartially":{}},"views":{}}, mushroom);

export interface Mywell_qr {
    /**
     * Mã định danh
     */
    id?: IdValue | null;
}

export interface Mywell_qr_Create_qrRequest {
    /**
     * Latitude
     */
    lat: number;
    /**
     * Longitude
     */
    lng: number;
}

export interface Mywell_qr_Get_qr_informationRequest {
    /**
     * Chuỗi QR MyWell
     */
    qr: string;
}

export interface Mywell_qr$CustomMethodResource {
    create_qrAsync: (request: CustomMethodBodyRequest<Mywell_qr_Create_qrRequest>) => Promise<MushroomResponse<any>>;
    get_qr_informationAsync: (request: CustomMethodBodyRequest<Mywell_qr_Get_qr_informationRequest>) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<Mywell_qr>({"name":"mywell_qr","actions":{"_raw_http_method_create_qr":{},"_raw_http_method_get_qr_information":{}},"views":{}}, mushroom);

export interface Mywell_location {
    /**
     * Mã định danh
     */
    id?: IdValue | null;
}

export interface Mywell_location_Send_my_locationRequest {
    /**
     * Latitude
     */
    lat: number;
    /**
     * Longitude
     */
    lng: number;
}

export interface Mywell_location$CustomMethodResource {
    send_my_locationAsync: (request: CustomMethodBodyRequest<Mywell_location_Send_my_locationRequest>) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<Mywell_location>({"name":"mywell_location","actions":{"_raw_http_method_send_my_location":{}},"views":{}}, mushroom);

export interface Mywell_ktv_device {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã người dùng/KTV
     */
    user_id?: IdValue | null;
    /**
     * Mã định danh thiết bị do app gửi lên
     */
    device_id?: string | null;
    /**
     * Tên thiết bị
     */
    device_name?: string | null;
    /**
     * Nền tảng thiết bị
     */
    platform?: string | null;
    /**
     * Phiên bản app hiện tại
     */
    app_version?: string | null;
    /**
     * Mã phiên eKYC gần nhất
     */
    ekyc_session_id?: string | null;
    /**
     * Mã phiên OCR dùng để xác thực thiết bị
     */
    ocr_session_id?: IdValue | null;
    /**
     * Mã phiên face matching dùng để xác thực thiết bị
     */
    face_session_id?: IdValue | null;
    /**
     * Trạng thái eKYC của thiết bị
     */
    ekyc_status?: string | null;
    /**
     * Thiết bị đang active hay không
     */
    active?: boolean | null;
    /**
     * Thời điểm tạo record
     */
    created_time?: ISODateValue | null;
    /**
     * Thời điểm eKYC thành công
     */
    verified_time?: ISODateValue | null;
    /**
     * Thời điểm thiết bị gọi API gần nhất
     */
    last_seen_time?: ISODateValue | null;
    /**
     * Thời điểm thiết bị bị hủy active
     */
    revoked_time?: ISODateValue | null;
    /**
     * Lý do hủy active thiết bị
     */
    revoked_reason?: string | null;
    /**
     * Thông tin mở rộng
     */
    data?: Mywell_ktv_device_Data | null;
}

export interface Mywell_ktv_device_Data {
}

export interface Mywell_ktv_device_Check_deviceRequest {
    device_id: string;
    device_name?: string | null;
    platform?: string | null;
    app_version?: string | null;
    data?: Mywell_ktv_device_Check_deviceRequest_Data | null;
}

export interface Mywell_ktv_device_Check_deviceRequest_Data {
}

export interface Mywell_ktv_device_Confirm_ekycRequest {
    device_id: string;
    device_name?: string | null;
    platform?: string | null;
    app_version?: string | null;
    ekyc_session_id: string;
    ocr_session_id: IdValue;
    face_session_id: IdValue;
    cccd_info?: string | null;
    data?: Mywell_ktv_device_Confirm_ekycRequest_Data | null;
}

export interface Mywell_ktv_device_Confirm_ekycRequest_Data {
}

export interface Mywell_ktv_device$CustomMethodResource {
    check_deviceAsync: (request: CustomMethodBodyRequest<Mywell_ktv_device_Check_deviceRequest>) => Promise<MushroomResponse<any>>;
    confirm_ekycAsync: (request: CustomMethodBodyRequest<Mywell_ktv_device_Confirm_ekycRequest>) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<Mywell_ktv_device>({"name":"mywell_ktv_device","actions":{"_raw_http_method_check_device":{},"_raw_http_method_confirm_ekyc":{}},"views":{}}, mushroom);

export interface Qr_hdv {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
}

export interface Qr_hdv_Create_qrRequest {
    /**
     * Vĩ độ (latitude)
     */
    lat: any;
    /**
     * Kinh độ (longitude)
     */
    lng: any;
}

export interface Qr_hdv_Get_qr_informationRequest {
    /**
     * Chuỗi QR nhận được từ mã QR của hướng dẫn viên
     */
    qr: string;
}

export interface Qr_hdv$CustomMethodResource {
    create_qrAsync: (request: CustomMethodBodyRequest<Qr_hdv_Create_qrRequest>) => Promise<MushroomResponse<any>>;
    get_qr_informationAsync: (request: CustomMethodBodyRequest<Qr_hdv_Get_qr_informationRequest>) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<Qr_hdv>({"name":"qr_hdv","actions":{"_raw_http_method_create_qr":{},"_raw_http_method_get_qr_information":{}},"views":{}}, mushroom);

export interface Pmt_order {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã order bên merchant quản lý
     */
    order_id?: string | null;
    /**
     * mã người dùng mua hàng
     */
    user_id?: IdValue | null;
    /**
     * id của merchant ứng với order
     */
    merchant_id?: IdValue | null;
    /**
     * Phần mô tả của pmt_order
     */
    message?: string | null;
    /**
     * giá của order
     */
    amount?: number | null;
    /**
     * Trạng thái hiện tại đơn hàng
     */
    status?: string | null;
    /**
     * Lịch sử trạng thái đơn hàng
     */
    history_status?: Array<Pmt_order_History_status | null | undefined> | null;
    /**
     * Dữ liệu mở rộng dạng key-value chuỗi do đối tác gửi lên; các key không cố định.
     */
    partner_data?: Pmt_order_Partner_data | null;
}

export interface Pmt_order_History_status {
    /**
     * Trạng thái đơn hàng
     */
    status?: string | null;
    /**
     * Mô tả trạng thái đơn hàng
     */
    description?: string | null;
    /**
     * Thời gian cập nhật trạng thái
     */
    timestamp?: ISODateValue | null;
}

export interface Pmt_order_Partner_data {
}

defineAsyncResource<Pmt_order>({"name":"pmt_order","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{}},"views":{}}, mushroom);


mushroom.$using(config.hostApiDuLich + "api/dulich/v1/");

(function(){
/* using all mushroom extensions */
AuthExtension.useAuth(AuthExtension.AuthLocalStorage, mushroom);
FileExtension.useFile(mushroom);
})();

export interface IApi extends IMushroom {
    /**
     * Thông tin tài khoản
     */
    user: MushroomResourceBase & MushroomListResource<User> & MushroomCountResource & MushroomFindByIdResource<User> & MushroomCreateResource<User> & MushroomPartialUpdateResource<User> & User$CustomMethodResource,
    /**
     * Mô tả sơ đồ phân cấp trong tổng cục quản lý thị trường
     */
    user_tcqltt: MushroomResourceBase & MushroomListResource<User_tcqltt> & MushroomCountResource & MushroomFindByIdResource<User_tcqltt> & MushroomCreateResource<User_tcqltt> & MushroomPartialUpdateResource<User_tcqltt>,
    /**
     * Quản lý tỉnh mà user quản lý
     */
    user_svhtt: MushroomResourceBase & MushroomListResource<User_svhtt> & MushroomCountResource & MushroomFindByIdResource<User_svhtt> & MushroomCreateResource<User_svhtt> & MushroomPartialUpdateResource<User_svhtt>,
    /**
     * Quản lý huyện mà user quản lý
     */
    user_pvhtt: MushroomResourceBase & MushroomListResource<User_pvhtt> & MushroomCountResource & MushroomFindByIdResource<User_pvhtt> & MushroomCreateResource<User_pvhtt> & MushroomPartialUpdateResource<User_pvhtt>,
    /**
     * Thông tin chung của người dùng
     */
    profile: MushroomResourceBase & MushroomListResource<Profile> & MushroomCountResource & MushroomFindByIdResource<Profile> & MushroomCreateResource<Profile> & MushroomPartialUpdateResource<Profile> & Profile$CustomMethodResource & Profile$ViewsResource,
    /**
     * Khách du lịch
     */
    khach_du_lich: MushroomResourceBase & MushroomListResource<Khach_du_lich> & MushroomCountResource & MushroomFindByIdResource<Khach_du_lich> & MushroomCreateResource<Khach_du_lich> & MushroomPartialUpdateResource<Khach_du_lich> & Khach_du_lich$CustomMethodResource & Khach_du_lich$ViewsResource,
    /**
     * Hướng dẫn viên du lịch
     */
    huong_dan_vien: MushroomResourceBase & MushroomListResource<Huong_dan_vien> & MushroomCountResource & MushroomFindByIdResource<Huong_dan_vien> & MushroomCreateResource<Huong_dan_vien> & MushroomPartialUpdateResource<Huong_dan_vien> & Huong_dan_vien$CustomMethodResource & Huong_dan_vien$ViewsResource,
    /**
     * Lượt check in của khách tại các điểm đến an toàn
     */
    huong_dan_vien_check_in: MushroomResourceBase & MushroomListResource<Huong_dan_vien_check_in> & MushroomCountResource & MushroomFindByIdResource<Huong_dan_vien_check_in> & MushroomCreateResource<Huong_dan_vien_check_in> & MushroomPartialUpdateResource<Huong_dan_vien_check_in>,
    /**
     * Danh mục Sở trường của hướng dẫn viên
     */
    so_truong: MushroomResourceBase & MushroomListResource<So_truong> & MushroomCountResource & MushroomFindByIdResource<So_truong> & MushroomCreateResource<So_truong> & MushroomPartialUpdateResource<So_truong>,
    /**
     * Danh mục Ngoại ngữ
     */
    ngoai_ngu: MushroomResourceBase & MushroomListResource<Ngoai_ngu> & MushroomCountResource & MushroomFindByIdResource<Ngoai_ngu> & MushroomCreateResource<Ngoai_ngu> & MushroomPartialUpdateResource<Ngoai_ngu>,
    /**
     * Quốc tịch
     */
    quoc_tich: MushroomResourceBase & MushroomListResource<Quoc_tich> & MushroomFindByIdResource<Quoc_tich> & MushroomCreateResource<Quoc_tich> & MushroomPartialUpdateResource<Quoc_tich>,
    /**
     * Danh sách ms của khách du lịch
     */
    ms_khach_du_lich: MushroomResourceBase & MushroomListResource<Ms_khach_du_lich> & MushroomCountResource & MushroomFindByIdResource<Ms_khach_du_lich> & Ms_khach_du_lich$CustomMethodResource,
    /**
     * Lưu thông tin token account tichhop
     */
    acs_token: MushroomResourceBase & MushroomListResource<Acs_token> & MushroomFindByIdResource<Acs_token>,
    /**
     * Đăng nhập và liên kết tài khoản bằng VNeID cho ứng dụng Khách du lịch và ứng dụng Quản trị và Kinh doanh du lịch
     */
    vneid: MushroomResourceBase & Vneid$CustomMethodResource,
    vtq: MushroomResourceBase & MushroomListResource<Vtq> & MushroomCountResource & MushroomCreateResource<Vtq> & Vtq$CustomMethodResource,
    /**
     * Công ty lữ hành
     */
    cong_ty_lu_hanh: MushroomResourceBase & MushroomListResource<Cong_ty_lu_hanh> & MushroomCountResource & MushroomFindByIdResource<Cong_ty_lu_hanh> & MushroomCreateResource<Cong_ty_lu_hanh> & MushroomPartialUpdateResource<Cong_ty_lu_hanh> & Cong_ty_lu_hanh$CustomMethodResource & Cong_ty_lu_hanh$ViewsResource,
    /**
     * Tour du lịch
     */
    tour: MushroomResourceBase & MushroomListResource<Tour> & MushroomCountResource & MushroomFindByIdResource<Tour> & MushroomCreateResource<Tour> & MushroomPartialUpdateResource<Tour> & MushroomDeleteResource & Tour$CustomMethodResource & Tour$ViewsResource,
    /**
     * Thông tin phiếu điều tour
     */
    phieu_dieu_tour: MushroomResourceBase & MushroomListResource<Phieu_dieu_tour> & MushroomCountResource & MushroomFindByIdResource<Phieu_dieu_tour> & MushroomCreateResource<Phieu_dieu_tour> & MushroomPartialUpdateResource<Phieu_dieu_tour> & MushroomDeleteResource & Phieu_dieu_tour$CustomMethodResource & Phieu_dieu_tour$ViewsResource,
    /**
     * Đoàn du lịch
     */
    tourist_group: MushroomResourceBase & MushroomListResource<Tourist_group> & MushroomCountResource & MushroomFindByIdResource<Tourist_group> & MushroomCreateResource<Tourist_group> & MushroomPartialUpdateResource<Tourist_group> & MushroomDeleteResource & Tourist_group$CustomMethodResource,
    /**
     * Danh mục nhóm phản hồi
     */
    nhom_phan_hoi: MushroomResourceBase & MushroomListResource<Nhom_phan_hoi> & MushroomCountResource & MushroomFindByIdResource<Nhom_phan_hoi> & MushroomCreateResource<Nhom_phan_hoi> & MushroomPartialUpdateResource<Nhom_phan_hoi>,
    /**
     * Thông tin phản hồi
     */
    phan_hoi: MushroomResourceBase & MushroomListResource<Phan_hoi> & MushroomCountResource & MushroomFindByIdResource<Phan_hoi> & MushroomCreateResource<Phan_hoi> & MushroomPartialUpdateResource<Phan_hoi> & MushroomDeleteResource & MushroomBatchDeleteResource & Phan_hoi$CustomMethodResource & Phan_hoi$ViewsResource,
    /**
     * Danh mục nhóm thành phần đánh giá
     */
    nhom_thanh_phan_danh_gia: MushroomResourceBase & MushroomListResource<Nhom_thanh_phan_danh_gia> & MushroomCountResource & MushroomFindByIdResource<Nhom_thanh_phan_danh_gia> & MushroomCreateResource<Nhom_thanh_phan_danh_gia> & MushroomPartialUpdateResource<Nhom_thanh_phan_danh_gia>,
    /**
     * Thông tin người dùng đánh giá
     */
    danh_gia: MushroomResourceBase & MushroomListResource<Danh_gia> & MushroomCountResource & MushroomFindByIdResource<Danh_gia> & MushroomCreateResource<Danh_gia> & MushroomPartialUpdateResource<Danh_gia> & MushroomDeleteResource & Danh_gia$ViewsResource,
    /**
     * Log thông tin người dùng đánh giá
     */
    danh_gia_log: MushroomResourceBase & MushroomListResource<Danh_gia_log> & MushroomCountResource & MushroomFindByIdResource<Danh_gia_log>,
    /**
     * Danh mục tin tức
     */
    danh_muc_tin: MushroomResourceBase & MushroomListResource<Danh_muc_tin> & MushroomCountResource & MushroomFindByIdResource<Danh_muc_tin> & MushroomCreateResource<Danh_muc_tin> & MushroomPartialUpdateResource<Danh_muc_tin>,
    /**
     * Tin bài
     */
    tin_tuc: MushroomResourceBase & MushroomListResource<Tin_tuc> & MushroomCountResource & MushroomFindByIdResource<Tin_tuc> & MushroomCreateResource<Tin_tuc> & MushroomPartialUpdateResource<Tin_tuc> & Tin_tuc$CustomMethodResource,
    /**
     * Dịch vụ du lịch chất lượng cao
     */
    dich_vu_chat_luong_cao: MushroomResourceBase & MushroomListResource<Dich_vu_chat_luong_cao> & MushroomCountResource & MushroomFindByIdResource<Dich_vu_chat_luong_cao> & MushroomCreateResource<Dich_vu_chat_luong_cao> & MushroomPartialUpdateResource<Dich_vu_chat_luong_cao>,
    /**
     * Cơ sở lưu trú
     */
    co_so_luu_tru: MushroomResourceBase & MushroomListResource<Co_so_luu_tru> & MushroomCountResource & MushroomFindByIdResource<Co_so_luu_tru> & MushroomCreateResource<Co_so_luu_tru> & MushroomUpdateResource<Co_so_luu_tru> & MushroomPartialUpdateResource<Co_so_luu_tru>,
    /**
     * Xếp hạng cơ sở lưu trú
     */
    cslt_xep_hang: MushroomResourceBase & MushroomListResource<Cslt_xep_hang> & MushroomCountResource & MushroomFindByIdResource<Cslt_xep_hang> & MushroomCreateResource<Cslt_xep_hang> & MushroomPartialUpdateResource<Cslt_xep_hang>,
    /**
     * Loại hình cơ sở lưu trú
     */
    cslt_loai_hinh: MushroomResourceBase & MushroomListResource<Cslt_loai_hinh> & MushroomCountResource & MushroomFindByIdResource<Cslt_loai_hinh> & MushroomCreateResource<Cslt_loai_hinh> & MushroomPartialUpdateResource<Cslt_loai_hinh>,
    /**
     * Dịch vụ của cơ sở lưu trú
     */
    cslt_dich_vu: MushroomResourceBase & MushroomListResource<Cslt_dich_vu> & MushroomCountResource & MushroomFindByIdResource<Cslt_dich_vu> & MushroomCreateResource<Cslt_dich_vu> & MushroomPartialUpdateResource<Cslt_dich_vu> & Cslt_dich_vu$ViewsResource,
    /**
     * Điểm đến an toàn
     */
    diem_den_an_toan: MushroomResourceBase & MushroomListResource<Diem_den_an_toan> & MushroomCountResource & MushroomFindByIdResource<Diem_den_an_toan> & MushroomCreateResource<Diem_den_an_toan> & MushroomPartialUpdateResource<Diem_den_an_toan> & MushroomDeleteResource & Diem_den_an_toan$CustomMethodResource & Diem_den_an_toan$ViewsResource,
    /**
     * Lượt check in của khách tại các điểm đến an toàn
     */
    diem_den_an_toan_check_in: MushroomResourceBase & MushroomListResource<Diem_den_an_toan_check_in> & MushroomCountResource & MushroomFindByIdResource<Diem_den_an_toan_check_in> & MushroomCreateResource<Diem_den_an_toan_check_in> & MushroomPartialUpdateResource<Diem_den_an_toan_check_in> & Diem_den_an_toan_check_in$CustomMethodResource & Diem_den_an_toan_check_in$ViewsResource,
    /**
     * Thông tin khai báo ngày của điểm đến an toàn
     */
    ddat_khai_bao_ngay: MushroomResourceBase & MushroomListResource<Ddat_khai_bao_ngay> & MushroomCountResource & MushroomFindByIdResource<Ddat_khai_bao_ngay>,
    /**
     * Thông tin khai báo ngày của điểm đến an toàn
     */
    ddat_cap_nhat_thong_tin: MushroomResourceBase & MushroomListResource<Ddat_cap_nhat_thong_tin> & MushroomCountResource & MushroomFindByIdResource<Ddat_cap_nhat_thong_tin>,
    canh_bao_hang_ngay: MushroomResourceBase & MushroomListResource<Canh_bao_hang_ngay> & MushroomCountResource & MushroomFindByIdResource<Canh_bao_hang_ngay> & MushroomCreateResource<Canh_bao_hang_ngay> & MushroomPartialUpdateResource<Canh_bao_hang_ngay>,
    chuong_trinh: MushroomResourceBase & MushroomListResource<Chuong_trinh> & MushroomCountResource & MushroomFindByIdResource<Chuong_trinh> & MushroomCreateResource<Chuong_trinh> & MushroomPartialUpdateResource<Chuong_trinh>,
    dang_ky_chuong_trinh: MushroomResourceBase & MushroomListResource<Dang_ky_chuong_trinh> & MushroomCountResource & MushroomFindByIdResource<Dang_ky_chuong_trinh> & MushroomCreateResource<Dang_ky_chuong_trinh> & MushroomDeleteResource & Dang_ky_chuong_trinh$CustomMethodResource,
    /**
     * Chứa danh sách Huy hiệu
     */
    huy_hieu: MushroomResourceBase & MushroomListResource<Huy_hieu> & MushroomCountResource & MushroomFindByIdResource<Huy_hieu> & MushroomCreateResource<Huy_hieu> & MushroomPartialUpdateResource<Huy_hieu>,
    /**
     * Chứa thông tin thành tích Huy hiệu của người dùng
     */
    thanh_tich_huy_hieu: MushroomResourceBase & MushroomListResource<Thanh_tich_huy_hieu> & MushroomCountResource & MushroomFindByIdResource<Thanh_tich_huy_hieu> & MushroomCreateResource<Thanh_tich_huy_hieu> & MushroomDeleteResource & MushroomPartialUpdateResource<Thanh_tich_huy_hieu> & Thanh_tich_huy_hieu$CustomMethodResource,
    /**
     * Thông tin vị trí của người dùng
     */
    location: MushroomResourceBase & MushroomListResource<Location> & MushroomCountResource & MushroomCreateResource<Location>,
    /**
     * Lưu thông tin các vùng dịch
     */
    vung_dich: MushroomResourceBase & MushroomFindByIdResource<Vung_dich> & MushroomListResource<Vung_dich> & MushroomCountResource & MushroomCreateResource<Vung_dich> & MushroomPartialUpdateResource<Vung_dich> & MushroomDeleteResource,
    /**
     * Log khi thay đổi trạng thái vùng dịch
     */
    log_update_vung_dich: MushroomResourceBase & MushroomListResource<Log_update_vung_dich> & MushroomCountResource,
    /**
     * Quảng cáo của các màn hình
     */
    quang_cao: MushroomResourceBase & MushroomListResource<Quang_cao> & MushroomCountResource & MushroomFindByIdResource<Quang_cao> & MushroomCreateResource<Quang_cao> & MushroomPartialUpdateResource<Quang_cao> & MushroomDeleteResource,
    /**
     * Nội dung chat
     */
    chat: MushroomResourceBase & MushroomListResource<Chat> & MushroomCountResource & MushroomPartialUpdateResource<Chat> & MushroomUpdateResource<Chat> & MushroomDeleteResource & Chat$ViewsResource,
    /**
     * Log thông báo
     */
    notification_log: MushroomResourceBase & MushroomListResource<Notification_log> & MushroomCountResource & MushroomFindByIdResource<Notification_log> & MushroomCreateResource<Notification_log> & MushroomDeleteResource & MushroomBatchDeleteResource,
    /**
     * Thông báo
     */
    notification: MushroomResourceBase & MushroomListResource<Notification> & MushroomCountResource & MushroomFindByIdResource<Notification> & MushroomCreateResource<Notification> & MushroomPartialUpdateResource<Notification> & MushroomDeleteResource & MushroomBatchDeleteResource & Notification$CustomMethodResource,
    /**
     * Trạng thái đọc thông báo
     */
    notification_status: MushroomResourceBase & MushroomListResource<Notification_status> & MushroomCountResource & MushroomCreateResource<Notification_status> & MushroomPartialUpdateResource<Notification_status>,
    /**
     * Lưu thông tin các thiết bị người dùng đang dùng
     */
    device: MushroomResourceBase & MushroomListResource<Device> & MushroomCountResource & Device$CustomMethodResource,
    /**
     * Thông tin cấu hình
     */
    config: MushroomResourceBase & MushroomListResource<Config> & MushroomCountResource & MushroomFindByIdResource<Config> & MushroomCreateResource<Config> & MushroomPartialUpdateResource<Config>,
    /**
     * Thông tin phiên bản
     */
    version: MushroomResourceBase & MushroomFindByIdResource<Version> & MushroomListResource<Version> & MushroomCountResource & MushroomPartialUpdateResource<Version>,
    /**
     * Cấu hình nhận thông báo
     */
    config_notification: MushroomResourceBase & MushroomFindByIdResource<Config_notification> & MushroomListResource<Config_notification> & MushroomCountResource & MushroomCreateResource<Config_notification> & MushroomPartialUpdateResource<Config_notification>,
    /**
     * Dữ liệu tỉnh, thành phố
     */
    province: MushroomResourceBase & MushroomListResource<Province> & MushroomCountResource & MushroomFindByIdResource<Province>,
    /**
     * [DEPRECATED] Dữ liệu quận, huyện, thị xã
     */
    district: MushroomResourceBase & MushroomListResource<District> & MushroomCountResource & MushroomFindByIdResource<District>,
    /**
     * Danh mục phường, xã
     */
    commune: MushroomResourceBase & MushroomListResource<Commune> & MushroomFindByIdResource<Commune>,
    /**
     * Thông tin file
     */
    file: MushroomResourceBase & MushroomListResource<File> & MushroomCountResource & MushroomFindByIdResource<File>,
    otp_mobile_register_captcha: MushroomResourceBase & MushroomFindByIdResource<Otp_mobile_register_captcha> & MushroomCreateResource<Otp_mobile_register_captcha>,
    /**
     * Public dashboard
     */
    dashboard: MushroomResourceBase & Dashboard$ViewsResource,
    /**
     * Khách du lịch nước ngoài
     */
    foreigner: MushroomResourceBase & MushroomListResource<Foreigner> & MushroomCountResource & MushroomFindByIdResource<Foreigner> & MushroomPartialUpdateResource<Foreigner> & Foreigner$CustomMethodResource,
    /**
     * Mã qr của khách du lịch nước ngoài
     */
    foreigner_qr: MushroomResourceBase & MushroomListResource<Foreigner_qr> & MushroomCountResource & MushroomFindByIdResource<Foreigner_qr> & MushroomCreateResource<Foreigner_qr> & MushroomPartialUpdateResource<Foreigner_qr> & Foreigner_qr$CustomMethodResource & Foreigner_qr$ViewsResource,
    /**
     * Thông tin quốc gia, quốc tịch
     */
    quoc_gia: MushroomResourceBase & MushroomListResource<Quoc_gia> & MushroomFindByIdResource<Quoc_gia> & MushroomCreateResource<Quoc_gia> & MushroomPartialUpdateResource<Quoc_gia>,
    /**
     * Thông tin vaccine
     */
    vaccine: MushroomResourceBase & MushroomListResource<Vaccine> & MushroomFindByIdResource<Vaccine> & MushroomCreateResource<Vaccine> & MushroomPartialUpdateResource<Vaccine>,
    /**
     * Khai báo y tế: tiếp xúc
     */
    kbyt_tiep_xuc: MushroomResourceBase & MushroomListResource<Kbyt_tiep_xuc> & MushroomFindByIdResource<Kbyt_tiep_xuc> & MushroomCreateResource<Kbyt_tiep_xuc> & MushroomPartialUpdateResource<Kbyt_tiep_xuc>,
    /**
     * Khai báo y tế: bệnh
     */
    kbyt_benh: MushroomResourceBase & MushroomListResource<Kbyt_benh> & MushroomFindByIdResource<Kbyt_benh> & MushroomCreateResource<Kbyt_benh> & MushroomPartialUpdateResource<Kbyt_benh>,
    /**
     * Các điểm trên bản đồ
     */
    map_item: MushroomResourceBase & MushroomListResource<Map_item> & MushroomCountResource & MushroomFindByIdResource<Map_item> & MushroomPartialUpdateResource<Map_item>,
    /**
     * Đơn hàng mua bảo hiểm du lịch
     */
    bao_hiem: MushroomResourceBase & MushroomListResource<Bao_hiem> & MushroomCountResource & MushroomFindByIdResource<Bao_hiem> & MushroomCreateResource<Bao_hiem> & MushroomPartialUpdateResource<Bao_hiem> & Bao_hiem$CustomMethodResource,
    /**
     * Danh mục các hãng bảo hiểm
     */
    hang_bao_hiem: MushroomResourceBase & MushroomListResource<Hang_bao_hiem> & MushroomCountResource & MushroomFindByIdResource<Hang_bao_hiem>,
    /**
     * Tờ khai y tế
     */
    tokhaiyte: MushroomResourceBase & MushroomListResource<Tokhaiyte> & MushroomCountResource & MushroomFindByIdResource<Tokhaiyte> & MushroomCreateResource<Tokhaiyte> & Tokhaiyte$CustomMethodResource,
    /**
     * Công ty lữ hành
     */
    tv_cong_ty_lu_hanh: MushroomResourceBase & MushroomListResource<Tv_cong_ty_lu_hanh> & MushroomCountResource & MushroomFindByIdResource<Tv_cong_ty_lu_hanh>,
    tv_dich_vu: MushroomResourceBase & MushroomListResource<Tv_dich_vu> & MushroomCountResource & MushroomFindByIdResource<Tv_dich_vu>,
    tv_dich_vu_tour: MushroomResourceBase & MushroomListResource<Tv_dich_vu_tour> & MushroomCountResource & MushroomFindByIdResource<Tv_dich_vu_tour>,
    tv_don_vi_cung_cap: MushroomResourceBase & MushroomListResource<Tv_don_vi_cung_cap> & MushroomCountResource & MushroomFindByIdResource<Tv_don_vi_cung_cap>,
    /**
     * Thẻ du lịch
     */
    thedulich: MushroomResourceBase & MushroomListResource<Thedulich> & MushroomCountResource & MushroomFindByIdResource<Thedulich> & MushroomCreateResource<Thedulich> & Thedulich$CustomMethodResource & Thedulich$ViewsResource,
    /**
     * Lưu thông tin đăng ký tài khoản du lịch
     */
    log_register_user: MushroomResourceBase & MushroomListResource<Log_register_user> & MushroomCountResource & MushroomFindByIdResource<Log_register_user>,
    /**
     * Thông tin log thanh toán
     */
    log_payment: MushroomResourceBase & MushroomListResource<Log_payment> & MushroomCountResource & MushroomFindByIdResource<Log_payment>,
    /**
     * API gotadi
     */
    gotadi: MushroomResourceBase & Gotadi$CustomMethodResource,
    /**
     * API hotel HMS
     */
    hotel: MushroomResourceBase & Hotel$CustomMethodResource & Hotel$ViewsResource,
    /**
     * API Văn Miếu
     */
    van_mieu: MushroomResourceBase & MushroomListResource<Van_mieu> & MushroomCountResource & MushroomFindByIdResource<Van_mieu> & Van_mieu$CustomMethodResource,
    van_mieu_booking: MushroomResourceBase & MushroomListResource<Van_mieu_booking> & MushroomCountResource & MushroomFindByIdResource<Van_mieu_booking> & MushroomCreateResource<Van_mieu_booking>,
    /**
     * Kết nối hệ thống vé điện tử VNPT Quảng Ninh
     */
    vnpt_qn_ve_dien_tu: MushroomResourceBase & MushroomListResource<Vnpt_qn_ve_dien_tu> & MushroomCountResource & MushroomFindByIdResource<Vnpt_qn_ve_dien_tu> & Vnpt_qn_ve_dien_tu$CustomMethodResource & Vnpt_qn_ve_dien_tu$ViewsResource,
    /**
     * Log thông tin cấu hình điểm tham quan
     */
    log_infor_visit_place: MushroomResourceBase & MushroomListResource<Log_infor_visit_place> & MushroomCountResource & MushroomFindByIdResource<Log_infor_visit_place> & Log_infor_visit_place$CustomMethodResource,
    /**
     * Doanh nghiệp
     */
    doanh_nghiep: MushroomResourceBase & MushroomListResource<Doanh_nghiep> & MushroomCountResource & MushroomFindByIdResource<Doanh_nghiep> & MushroomPartialUpdateResource<Doanh_nghiep> & Doanh_nghiep$CustomMethodResource,
    dang_ky_trang_vang: MushroomResourceBase & MushroomListResource<Dang_ky_trang_vang> & MushroomCountResource & MushroomFindByIdResource<Dang_ky_trang_vang> & Dang_ky_trang_vang$CustomMethodResource,
    /**
     * API dsvn
     */
    dsvn: MushroomResourceBase & Dsvn$CustomMethodResource,
    /**
     * Lưu thông tin mỗi lần người dùng save booking
     */
    dsvn_booking: MushroomResourceBase & MushroomListResource<Dsvn_booking> & MushroomCountResource & MushroomFindByIdResource<Dsvn_booking>,
    pmt_session: MushroomResourceBase & MushroomListResource<Pmt_session> & MushroomCountResource & MushroomFindByIdResource<Pmt_session> & Pmt_session$CustomMethodResource,
    pmt_merchant: MushroomResourceBase & MushroomListResource<Pmt_merchant> & Pmt_merchant$CustomMethodResource,
    pmt_paygate: MushroomResourceBase & MushroomListResource<Pmt_paygate> & MushroomCountResource & MushroomFindByIdResource<Pmt_paygate> & Pmt_paygate$CustomMethodResource,
    /**
     * Thông tin thanh toán tại điểm đến
     */
    pmt_ddat_payment: MushroomResourceBase & MushroomListResource<Pmt_ddat_payment> & MushroomCountResource,
    /**
     * API SHB
     */
    shb: MushroomResourceBase & Shb$CustomMethodResource,
    /**
     * Lịch sử giao dịch bảo lãnh SHB
     */
    shb_guarantee_history: MushroomResourceBase & MushroomListResource<Shb_guarantee_history> & MushroomCountResource,
    /**
     * Yêu cầu mở thẻ SHB
     */
    shb_request: MushroomResourceBase & MushroomListResource<Shb_request> & MushroomFindByIdResource<Shb_request>,
    /**
     * Thẻ ngân hàng SHB
     */
    shb_card: MushroomResourceBase & MushroomListResource<Shb_card> & MushroomCountResource & MushroomFindByIdResource<Shb_card> & MushroomPartialUpdateResource<Shb_card> & Shb_card$CustomMethodResource,
    /**
     * API BIDV QR
     */
    bidv: MushroomResourceBase & Bidv$CustomMethodResource,
    /**
     * API 2ID
     */
    twoId: MushroomResourceBase & TwoId$CustomMethodResource,
    /**
     * API bảo mật dùng chung
     */
    security: MushroomResourceBase & Security$CustomMethodResource,
    /**
     * Vị trí hiện tại của người dùng bên Sản vật
     */
    sanvat_location: MushroomResourceBase & Sanvat_location$CustomMethodResource,
    /**
     * Đơn hàng tổng của khách du lịch bên Sản vật (1 sanvat_tourist_order chứa nhiều sanvat_order)
     */
    sanvat_tourist_order: MushroomResourceBase & MushroomListResource<Sanvat_tourist_order> & MushroomCountResource & MushroomFindByIdResource<Sanvat_tourist_order> & Sanvat_tourist_order$CustomMethodResource,
    /**
     * Đơn hàng sản vật
     */
    sanvat_order: MushroomResourceBase & MushroomListResource<Sanvat_order> & MushroomCountResource & MushroomFindByIdResource<Sanvat_order> & Sanvat_order$CustomMethodResource,
    /**
     * Nhà cung cấp bán hàng sản vật
     */
    sanvat_station_merchant: MushroomResourceBase & MushroomListResource<Sanvat_station_merchant> & MushroomCountResource & MushroomFindByIdResource<Sanvat_station_merchant> & MushroomCreateResource<Sanvat_station_merchant> & MushroomPartialUpdateResource<Sanvat_station_merchant> & MushroomDeleteResource & Sanvat_station_merchant$CustomMethodResource,
    /**
     * Yêu cầu hoàn tiền đơn hàng sản vật (thông tin bổ sung cho sanvat_order)
     */
    sanvat_order_refund: MushroomResourceBase & MushroomListResource<Sanvat_order_refund> & MushroomCountResource & MushroomFindByIdResource<Sanvat_order_refund> & MushroomPartialUpdateResource<Sanvat_order_refund>,
    /**
     * Thông tin thanh toán chia tiền từ tài khoản chung SanVat về cho các nhà cung cấp
     */
    sanvat_pmt_order: MushroomResourceBase & MushroomListResource<Sanvat_pmt_order> & MushroomCountResource & MushroomFindByIdResource<Sanvat_pmt_order>,
    /**
     * Hóa đơn chia tiền sau của nhà cung cấp cho các bên liên quan (operator, sale)
     */
    pmt_settlement_sanvat: MushroomResourceBase & MushroomListResource<Pmt_settlement_sanvat> & MushroomCountResource & MushroomFindByIdResource<Pmt_settlement_sanvat> & MushroomPartialUpdateResource<Pmt_settlement_sanvat>,
    /**
     * QR kỹ thuật viên MyWell
     */
    mywell_qr: MushroomResourceBase & Mywell_qr$CustomMethodResource,
    /**
     * Vị trí hiện tại của người dùng gửi sang MyWell
     */
    mywell_location: MushroomResourceBase & Mywell_location$CustomMethodResource,
    /**
     * Thiết bị đăng nhập đã eKYC của kỹ thuật viên MyWell
     */
    mywell_ktv_device: MushroomResourceBase & Mywell_ktv_device$CustomMethodResource,
    /**
     * QR hướng dẫn viên
     */
    qr_hdv: MushroomResourceBase & Qr_hdv$CustomMethodResource,
    pmt_order: MushroomResourceBase & MushroomListResource<Pmt_order> & MushroomCountResource & MushroomFindByIdResource<Pmt_order> & MushroomCreateResource<Pmt_order> & MushroomPartialUpdateResource<Pmt_order>,
};

export type Api = /* all mushroom extensions types */AuthExtension.IMushroomAuth & FileExtension.IMushroomFile & IApi;

export default mushroom as unknown as Api;